import { supportEmailaddr } from "../constants";

export const gENAppsString = {
  "OK": "OK",
  "Cancel": "Cancel",
  "Yes": "Yes",
  "No": "No",
  "Reset": "Reset",
  "Search": "Search",
  "Add": "Add",
  "Delete": "Delete",
  "Applies to": "Applies to",
  "Rename": "Rename",
  "Up": "Up",
  "Down": "Down",
  "Edit": "Edit",
  "Arrange": "Arrange",
  "Rules": "Rules",
  "Default": "Default",
  "Open": "Open",
  "Save": "Save",
  "Duplicate": "Duplicate",
  "Min": "Min",
  "Max": "Max",
  "Required": "Required",
  "Notification": "Notification",
  "Allowed": "Allowed",
  "Restricted": "Restricted",
  "Name": "Name",
  "Title": "Title",
  "Location": "Location",
  "Department": "Department",
  "WorkPhone": "Work Phone",
  "Orphan": "Disconnect",
  "Disconnect": "Disconnect from hierarchy",
  "TopOfSubChart": "Top Of SubChart",
  "Level": "Level",
  "SubChartLevel": "SubChart Level",
  "SpanOfControl": "Span Of Control",
  "addnewgroup": "Click 'Add' to create a group.",
  "selectagroup": "Select a group from the list",
  "Subordinates": "Subordinates",
  "Headcount": "Headcount",
  "BudgetedHeadcount": "Budgeted Headcount",
  "SalaryRollup": "Salary Rollup",
  "CurrentPositionCost": "Current Position Cost",
  "PositionBudgetRollup": "Position Budget Rollup",
  "Budgeted Headcount": "Budgeted Headcount",
  "Salary Rollup": "Salary Rollup",
  "Position Budget Rollup": "Position Budget Rollup",
  "PositionCount": "Position Count",
  "SubordinatePositions": "Subordinate Positions",
  "DirectSubordinatePositions": "Direct Subordinate Positions",
  "PeerPositions": "Peer Positions",
  "overtarget": "{delta} over target",
  "undertarget": "{delta} under target",
  "Metric trend tooltip": "Starting: {starting} | Delta: {delta}",
  "ReportsTo": "Reports To",
  "ReportsToName": "Reports To Name",
  "Assigned to": "Assigned to",
  "Reassigned from": "Reassigned from",
  "NewSuperID": "SuperID Lookup",
  "complexpass": "Require complex passwords",
  "forcepass": "Force password change after reset",
  "smspass": "Use SMS for password retrieval",
  "contentlock": "Lock content",
  "layoutlock": "Lock layout",
  "hierlock": "Lock as subordinate to manager",
  "persistlock": "Do not delete (for manually added boxes)",
  "lockmsg": "Data refresh will not update locked items.",
  "Locking": "Locking",
  "New": "New",
  "Import": "Import",
  "querydata": "Builder",
  "svrchart": "My Chart",
  "refreshorg": "Refresh chart",
  "Configure": "Configure",
  "refreshorgprops": "Refresh properties",
  "FILE": "File",
  "DOCUMENT": "Document",
  "EDIT": "Edit chart",
  "EDITM": "Edit Background",
  "Save Master": "Save background",
  "INSERT": "INSERT",
  "DATA": "DATA",
  "VIEW": "VIEW",
  "IMPORT": "IMPORT DATA",
  "REFRESH": "Refresh",
  "SHARE": "Share",
  "PLAN": "PLAN",
  "HELP": "Help",
  "Launch": "Launch",
  "launchmode": "Launch mode",
  "Access": "Access",
  "Scheduler": "Scheduler",
  "enablesched": "Automatically refresh chart",
  "frequency": "Frequency",
  "Daily": "Daily",
  "Weekly": "Weekly",
  "Weeks": "Weeks",
  "Bi-Weekly": "Bi-Weekly",
  "Quarterly": "Quarterly",
  "Annually": "Annually",
  "First Day": "First Day",
  "Last Day": "Last Day",
  "gmttime": "Time (GMT)",
  "dayofweek": "Day",
  "emailnote": "Email notification",
  "emailtxt": "Enter comma delimited list",
  "Enter": "Enter",
  "Enter (Value)": "Enter",
  "schedulerna": "Scheduler not available for Free Trials.",
  "Position": "Position",
  "Assistant": "Assistant",
  "generatedelta": "Generating Delta Report",
  "Root": "Root",
  "deltaconfig": "Delta Report Notifications",
  "AutoText": "AutoText",
  "Change AutoText": "Change AutoText",
  "Table": "Table",
  "Legend": "Legend",
  "Select": "Select",
  "Pan": "Pan",
  "Move": "Move",
  "Subtract": "Subtract",
  "Multiply": "Multiply",
  "Divide": "Divide",
  "Average": "Average",
  "Count": "Count",
  "Sum": "Sum",
  "dropdups": "Drop duplicates",
  "moveobj": "Move chart or object",
  "Object": "Object",
  "movebox": "Move box or branch",
  "addsub": "Add subordinate box",
  "addassist": "Add assistant",
  "addsubtool": "Add box",
  "moveboxtool": "Move box",
  "moveoutboxtool": "Move outside plan",
  "moveobjtool": "Move Obj",
  "Cut": "Cut",
  "Copy": "Copy",
  "Paste": "Paste",
  "copyformat": "Copy format",
  "insertbreak": "Insert subchart break",
  "removebreak": "Remove subchart break",
  "maketop": "Make top of page",
  "branchstyles": "Branch styles",
  "selbranchstyle": "Select branch style",
  "resizeimage": "Resize Image",
  "imageinfo": "Image Properties",
  "branchstyleerr1": "Selected branch style not allowed.",
  "branchstyleerr2": "A minimum of 2 boxes must be selected.",
  "branchstyleerr3": "Invalid selection. All selected boxes must have the same manager.",
  "branchstyleerr4": "Invalid selection. Subcharts breaks not allowed.",
  "addboxerr1": "Invalid add. Drill down to add box.",
  "addboxerr2": "Invalid add. Add to first member of co-manager group.",
  "addtemplate": "Add view",
  "Header1": "Header1",
  "Header2": "Header2",
  "Headers": "Headers",
  "nousertemps": "All views used (or none defined). Use the Views panel to create additional views.",
  "Insert": "Insert",
  "Remove": "Remove",
  "Lock": "Lock",
  "Locked": "Locked",
  "Persist": "Persist",
  "filelocked": "You do not have permission to modify this file. File or folder locked.",
  "folderlocked": "You do not have permission to rename or delete this folder.",
  "Wizard": "Wizard",
  "Normal": "Normal",
  "Master": "Background",
  "Masters": "Backgrounds",
  "Apply": "Apply",
  "nofill": "No Fill",
  "customcolor": "Custom Color",
  "enterrgb": "RRGGBB",
  "colorvalmin": "Invalid color",
  "hexcolor": "Enter HEX color",
  "solidfill": "Solid Fill",
  "gradientfill": "Gradient Fill",
  "Gradient": "Gradient",
  "Linear Gradient": "Linear Gradient",
  "Radial Gradient": "Radial Gradient",
  "dashline": "Dashed Line",
  "triangle": "Triangle",
  "lefttriangle": "Left Triangle",
  "separator": "Separator",
  "solidborder": "Solid Border",
  "dashedborder": "Dashed Border",
  "solidline": "Solid",
  "dashedline": "Dashed",
  "hideline": "Hide",
  "moreoptions": "More Options...",
  "linegroup": "Line Group",
  "linesubgroup": "Line Subgroup",
  "clearsubgroup": "Clear Subgroup",
  "nomask": "No Mask",
  "cirmask": "Circular Mask",
  "noborder": "No Border",
  "singleborder": "Single Border",
  "dblborder": "Double Border",
  "Label": "Label",
  "labelvalue": "Label:Value",
  "Next": "Next",
  "Prev": "Prev",
  "Next (short)": "Next",
  "Prev (short)": "Prev",
  "Previous": "Previous",
  "findwhat": "Find what",
  "findfield": "Find field",
  "selectmatches": "Select Matches",
  "replacewith": "Replace with",
  "Replace": "Replace",
  "replaceall": "Replace All",
  "box": "box",
  "boxes": "boxes",
  "Box": "Box",
  "Boxes": "Boxes",
  "Layout": "Layout",
  "Setup": "Setup",
  "Template": "view",
  "Copyright": "Copyright",
  "Version": "Version",
  "Allrights": "All rights reserved.",
  "Edition": "Edition",
  "SupportMsg": "If this problem persists contact",
  "SalesMsg": "For more information, contact",
  "comingsoon": "Coming Soon!",
  "Help": "Help",
  "stayconnected": "Stay Connected",
  "adpadvopt": "ADP Profile:",
  "adprefropt": "Selected ADP profile:",
  "Profile": "Profile",
  "addoperations": "Click (+) to add operations.",
  "Templates": "views",
  "Parking": "Parking",
  "Box Styles": "Box styles",
  "Box Style": "Box style",
  "applychanges": "Apply changes to",
  "from": "From",
  "howto": "How To?",
  "Tutorials": "Tutorials",
  "Videos": "Videos",
  "OnlineDocs": "Online Docs",
  "Guide": "Guide",
  "commalerts": "Alerts",
  "ReleaseNotesLink": "Releases",
  "Newsletters": "News",
  "iwizselectmsg1": "The Import Wizard automatically creates an org chart from an Excel file.",
  "iwizselectmsg2": "If you need to create an Excel file, download the Sample spreadsheet and then modify it as needed.",
  "iwizselectmsg3": "All data files must be Uploaded to your cloud storage account before they can be used.",
  "iwizselectmsg4": "Click on the 'Import Data' button to import a file from cloud storage.",
  "iwizselectsample": "Sample",
  "iwizselectupload": "Upload files",
  "iwizselectimport": "Import data",
  "iwizselectSAPmsg1": "The Import Wizard automatically creates an org chart from an SAP XML file.",
  "iwizselectSAPmsg2": "Please contact technical support for assistance exporting data from your SAP System.",
  "iwizselectSAPmsg3": "All data files must be Uploaded to your cloud storage account before they can be used.",
  "iwizselectSAPmsg4": "Click on the 'Import Data' button to import a file from cloud storage.",
  "iwizselectAPDmsg1": "The Import Wizard automatically creates an org chart using a direct connection to your ADP Workforce Now or ADP Vantage account.",
  "iwizselectAPDmsg2": "Click on the ? for information on how to configure your ADP connection.",
  "iwizfiltermsg1": "Optionally, you can filter your source data.",
  "iwizfiltermsg2": "Only records that match the specified filter will be imported.",
  "iwizfilterchk": "Specify data filter",
  "iwizautobreakchk": "Automatically break up large pages",
  "buildhier1": "Please enter the required and optional fields.",
  "buildhier2": "If your data does not include hierarchy fields (Person ID and Supervisor ID), you can manually",
  "buildhier3": "drag & drop boxes to create an org chart after the data has been imported.",
  "buildhier4": "Data contains hierarchy fields",
  "assistwiz1": "Set assistant branch styles based on rules or data.",
  "stdassistantrule": "Use rule to identify standard assistants",
  "peerassistantrule": "Use rule to identify peer assistants",
  "assistonleft": "Place first assistant on the left of manager",
  "combinerecords": "Sub-Group by Field",
  "checkall": "Check All",
  "uncheckall": "Uncheck All",
  "levelchartcb": "Create level chart",
  "PersonID": "PersonID",
  "SupervisorID": "SupervisorID",
  "iwizerr0": "Loading Views. Please try again.",
  "iwizerr1": "Filter did not match any records",
  "No results found for the selected criteria. Please adjust your selection and try again": "No results found for the selected criteria. Please adjust your selection and try again",
  "iwizerr2": "Circular reference found. Use 'Specify top box' option or fix data.",
  "iwizerr3": "PersonID and/or SupervisorID fields not found in source data.",
  "iwizerr4": "Too many records for a single page. Adjust subchart options and retry.",
  "iwizsc1": "If your chart contains too many boxes on a page, you can break it into multiple pages.",
  "matchonly": "Matches Only",
  "directsubs": "Include direct subordinates",
  "allsubs": "Include all subordinates",
  "miniscarrow": "Mini-arrow",
  "onCommSet": "Notify me about upcoming releases, new features, and announcements for OrgChart",
  "offCommSet": "Do not notify me about upcoming product updates, changes, and announcements.",
  "commDialogueMessage": "Email notification preferences",
  "whitescarrow": "White arrow",
  "blackscarrow": "Black arrow",
  "themearrow": "Theme arrow",
  "autoopenlogin": "After login:",
  "noautoopen": "Take no action",
  "autoopen": "Auto-open specified chart",
  "autoopencur": "Auto-open current chart",
  "genreport": "Generate Diagnostic Report",
  "piccache": "Reload Employees Photos",
  "fileinfoerr": "Error retrieving file info.",
  "optbs": "Optimize branch styles",
  "optimizebranch": "Optimize to aspect ratio (if page too small):",
  "about": "About",
  "allowsort": "Resort boxes to save space",
  "prefstyle": "Preferred style",
  "tree": "Tree",
  "stagger": "Stagger",
  "banded": "Banded",
  "twocolumn": "Two column",
  "fourcolumn": "Four column",
  "sixcolumn": "Six column",
  "eightcolumn": "Eight column",
  "onecolCR": "One column center right",
  "onecolCL": "One column center left",
  "onecolR": "One column right",
  "onecolL": "One column left",
  "assistPR": "Assistant peer right",
  "assistPL": "Assistant peer left",
  "assistR": "Assistant right",
  "assistL": "Assistant left",
  "twelvecolumn": "Twelve Column",
  "sixteencolumn": "Sixteen Column",
  "twentycolumn": "Twenty Column",
  "treesingles": "Use tree style for singles",
  "optimizeall": "Optimize all subcharts",
  "interactive": "Interactive mode",
  "Optimize": "Optimize",
  "useinches": "Display units in inches",
  "usemetric": "Display units in centimeters",
  "Back": "Back",
  "Field": "Field",
  "Fields": "Fields",
  "Comparison": "Comparison",
  "Value": "Value",
  "Upload": "Upload",
  "Download": "Download",
  "Files": "Files",
  "files": "files",
  "Duplicate file or files":"Duplicate File(s)",
  "filemgr": "File Mgr",
  "Folders": "Folders",
  "Directory": "Directory",
  "File": "File",
  "orgcharts": "Org Charts",
  "wplan": "Workforce Planning",
  "wplantools": "Planning Tools",
  "Create": "Create",
  "Settings": "Settings",
  "Cloud": "Database",
  "Manage": "Manage",
  "clickhidden": "Click here to show hidden items.",
  "Showing": "Showing",
  "managers": "managers",
  "Showing X of Y managers": "Showing {visibleCount} of {totalCount} managers",
  "Showing results": "Showing {firstResult} - {lastResult} of {totalCount} results",
  "Results per page": "Results per page",
  "sysstyles": "System styles",
  "Interactive Filtering": "Interactive filtering",
  "My Filters": "My filters",
  "userstyles": "User styles",
  "sharedstyles": "Shared styles",
  "Field Properties": "Field properties",
  "Branch Style": "Branch style",
  "successupload": "successfully uploaded",
  "uploadcncl": "Upload canceled",
  "uploadfail": "upload failed",
  "successrupload": "successfully replaced",
  "uploadfailtoobig": "upload aborted - file too big",
  "uploadfailfiletype": "upload aborted - invalid file type",
  "System": "System",
  "Shared": "Shared",
  "User": "User",
  "charttemplate": "Chart view",
  "ruledriven": "Rule driven chart (manual presentation changes not persistent)",
  "addfields": "Add fields",
  "addkey": "Add Key",
  "removefields": "Remove fields",
  "removefolders": "Remove folders",
  "addfolders": "Add folders",
  "Search folder": "Search folder",
  "Search specific folder": "Search {folder}",
  "Search Charts": "Search charts",
  "foldermoveddeleted": "Folder cannot be found. This can happen if the folder was renamed or no longer exists.",
  "foldernotfound": "Folder not found",
  "addfolder": "Add folder",
  "optpage": "Optimize page",
  "showscnum": "Show Subchart #",
  "Complex Rule": "Boxes matching custom logic (advanced)",
  "deffilter": "Edit rule...",
  "enterrule": "Enter rule",
  "testrule": "Test rule",
  "testmath": "Test Math",
  "enterfontstyle": "Enter a font name (e.g Helvetica)",
  "defsubfilter": "Edit subordinate rule...",
  "invalidconcatfield": "Rule invalid. One or more field references not found",
  "rulevalid": "Rule valid.",
  "mathvalid": "Math valid.",
  "concatinvalid": "Rule Invalid.",
  "Limit Fields": "Restrict query to fields",
  "limitfields": "Limit fields",
  "Restricted fields": "Restricted fields",
  "conddefeditor": "Conditional definition editor",
  "Conditional Definition": "Conditional definition",
  "Add Branch Rule": "Add branch security rule",
  "topboxids": "Topbox IDs",
  "enumeratedbranch": "Enumerated Branches",
  "ownbranch": "Restrict to own branch",
  "branchaccesslist": "Branch Access Field",
  "nobreaks": "Single page chart",
  "BreadCrumbs": "Breadcrumbs",
  "autobreaks": "Automatic breaks",
  "filterinuse": "Filter name already in use",
  "highlightinuse": "Highlight name already in use",
  "breakbylevel": "Break by level",
  "breakbyfield": "Break by field",
  "assistrulemanual": "Manually set assistant branch styles",
  "assistrulefield": "Use 'isAssistant' field to set assistant branch styles",
  "assistruledef": "Use rules to set assistant branch styles",
  "sapouoptions": "SAP OrgUnit Chart Options",
  "sapoption1": "Convert to Position to Position",
  "sapoption2": "Combine OrgUnits and Chief Positions",
  "sapoption3": "Separate OrgUnits and Positions",
  "entirechart": "Entire chart",
  "selection": "Selection",
  "scopechart": "Use chart top",
  "scopebranch": "Use branch top",
  "countif": "COUNTIF",
  "averageif": "AVERAGEIF",
  "sumif": "SUMIF",
  "concatenate": "CONCATENATE",
  "lookup": "LOOKUP",
  "Lookup": "Lookup",
  "lookupmsg": "Lookup a value from another record.",
  "LookupField": "Lookup key:",
  "LookupValue": "Lookup result:",
  "LookUp": "Look up",
  "sum": "SUM",
  "average": "AVERAGE",
  "map": "MAP",
  "math": "MATH",
  "max": "MAX",
  "min": "MIN",
  "countifdesc": "Count only if record matches defined criteria.",
  "sumifdesc": "Sum only if record matches defined criteria.",
  "averageifdesc": "Average only if record matches defined criteria.",
  "rightcalc": "RIGHT",
  "leftcalc": "LEFT",
  "leftblank": "Value cannot be blank.",
  "leftmsg": "Return characters from the LEFT.",
  "rightmsg": "Return characters from the RIGHT.",
  "rightleftmsg": "Enter # or break char",
  "fieldblank2": "Select a field.",
  "valueSelect": "Select a",
  "fieldSelect": "Select a field",
  "Select All": "Select all",
  "Deselect All": "Deselect all",
  "Select a Profile": "Select a Profile",
  "summsg": "Select field to sum.",
  "Additional Levels": "Additional levels",
  "averagemsg": "Select field to average.",
  "maxmsg": "Select field for max function.",
  "minmsg": "Select field for min function.",
  "fieldblank": "Select lookup fields.",
  "concatblank": "Text cannot be blank.",
  "concatmsg": "Enter text and fields to concatenate. Enclose fields with square brackets.",
  "concatmsg2": "Example: '[FirstName] [LastName]'",
  "mathmsg": "Enter calculation. Enclose fields with square brackets.",
  "mathmsg2": "Example: '[FieldA]/[FieldB]*100'",
  "mapmsg": "Enter mapping.",
  "mapmsg2": "Example: '94121':'Richmond','94122':'Sunset'",
  "boxwidth": "Box width",
  "Fixed": "Fixed",
  "Auto": "Auto",
  "boxheight": "Box Height",
  "Gutter": "Gutter",
  "Options": "Options",
  "Optional": "Optional",
  "Properties": "Properties",
  "Cell": "Cell",
  "Custom": "Custom",
  "aligncells": "Align Cells",
  "Preview": "Preview",
  "setasdef": "Set as default layout",
  "Standard": "Standard",
  "Dense": "Dense",
  "Manual": "Manual",
  "addparams": "Parameters",
  "spacingmode": "Select box spacing",
  "adjboxmarg": "Adjust box margins",
  "adjboxspace": "Adjust box spacing",
  "adjboxsubs": "Adjust subordinate spacing",
  "enterval": "Enter value",
  "addval": "Add Value",
  "fieldeditor": "Field manager",
  "andor": "And/Or",
  "Remove rule": "Remove rule",
  "Height": "Height",
  "Width": "Width",
  "curpagesize": "Current page size",
  "minpagesize": "Minimum page size",
  "showmarg": "Show margin lines",
  "Margins": "Margins",
  "Orientation": "Orientation",
  "headfoot": "Header & Footer",
  "showheadfoot": "Show header & footer lines",
  "Top": "Top",
  "Right": "Right",
  "Left": "Left",
  "autodelta": "Automatic notifications",
  "letterps": "Letter",
  "legalps": "Legal",
  "tabloidps": "Tabloid",
  "a0ps": "A0",
  "a1ps": "A1",
  "a2ps": "A2",
  "a3ps": "A3",
  "a4ps": "A4",
  "ppt1ps": "PowerPoint 4:3",
  "ppt2ps": "PowerPoint 16:9",
  "ppt3ps": "PowerPoint 16:10",
  "customps": "Custom page size",
  "widem": "Wide",
  "extrawidem": "Extra wide",
  "standardm": "Standard",
  "narrowm": "Narrow",
  "customm": "Custom margin",
  "landscape": "Landscape",
  "portrait": "Portrait",
  "standardh": "Standard header",
  "noheader": "No header",
  "customh": "Custom header",
  "return": "Return",
  "standardf": "Standard footer",
  "nofooter": "No Footer",
  "customf": "Custom footer",
  "breakfield": "Break on field:",
  "breakevery": "Break every:",
  "pagedensity": "Page density:",
  "pagedense": "Dense",
  "pagestandard": "Standard",
  "pageverydense": "Very Dense",
  "minbreak": "Minimum subs for break:",
  "selecttemplate": "Select a view to apply to the chart. After the chart is created, you can use the Views Panel to switch to another view.",
  "createchart": "Create Chart",
  "Create base chart": "Create base chart",
  "importerr": "The selected data file could not be imported. The following issue needs to be resolved before the file can be imported:",
  "unknownerr": "<Unknown Error>",
  "Retry": "Retry",
  "importwiz": "Import Wizard",
  "selectimportfile": "Select Data File To Import",
  "selectimportsapfile": "Select SAP XML File To Import",
  "filterdata": "Filter Data",
  "noFilterName": "Please enter a filter name.",
  "buildhier": "Define Fields",
  "assistwiz": "Assistant Wizard",
  "Pagination wizard": "Pagination wizard",
  "selectchart": "Select Chart",
  "selectctemplate": "Select Chart View",
  "selectcdoc": "Select Chart Document",
  "selectplan": "Select Plan",
  "switch view prompt": "Click here to switch view sets",
  "switch views": "Switch View Set",
  "switch to shared views to create new views": "Switch to shared views to create new views",
  "viewsets": "View Sets",
  "unableimport": "Unable to import data",
  "unablebuildhier": "Unable to build hierarchy",
  "importfiltercharterr": "One or more issues were found with the applied import filter. Modify or remove the import filter.",
  "chartScopeFilterCharterr": "One or more issues were found with the applied chart scope filter. Modify or remove the chart scope filter.",
  "wirehiererr": "Person ID and/or Supervisor ID fields are not set.",
  "Levels": "Levels",
  "alllevels": "All levels",
  "and": "and",
  "or": "or",
  "Middle": "Middle",
  "Bottom": "Bottom",
  "ruleorder": "Rule (applied in order shown)",
  "equals": "equals",
  "notequal": "not equal to",
  "startswith": "starts with",
  "contains": "contains",
  "doesnotcontain": "does not contain",
  "isempty": "is empty",
  "isnotempty": "is not empty",
  "greater": "greater than",
  "after": "after",
  "less": "less than",
  "before": "before",
  "greaterequal": "greater or equal to",
  "afterequal": "after or at",
  "lessequal": "less or equal to",
  "beforeequal": "before or on",
  "inlist": "in list",
  "notinlist": "not in list",
  "pagenum": "Page #",
  "totalpages": "Total pages",
  "pagex": "Page X",
  "pagexy": "Page X of Y",
  "today": "Today",
  "Static Range": "Static range",
  "Dynamic Range": "Dynamic range",
  "refreshdate": "Refresh date",
  "refreshtime": "Refresh date & time",
  "lastrefresh": "Last refreshed",
  "lastrefreshdatetime": "{date}, at {time}",
  "lastvalidation": "Last validated",
  "notvalidated": "Not validated",
  "subchartname": "Subchart name",
  "subchartnum": "Subchart #",
  "subchartpath": "Subchart path",
  "filename": "Filename",
  "exportFilenameInvalidChars": "File name cannot contain: \\ / : * ? \" < > |",
  "exportFailedTitle": "Export failed",
  "exportFailedMsg": "We couldn't create your export. Please try again. If the problem continues, contact support.",
  "includechain": "Include chain of command",
  "Include a field that contains the reporting hierarchy for each employee": "Include a field that contains the reporting hierarchy for each employee",
  "Include system calculations": "Include system calculations",
  "Include pre-defined system formulas, such as headcount and span of control": "Include pre-defined system formulas, such as headcount and span of control",
  "Accessibility Report": "Accessibility Report",
  "accessibilityReportHelper": "Generate a Section 508, screen-reader-friendly flat Excel workbook",
  "Maximum 3 additional fields": "Maximum 3 additional fields",
  "accessibilityFieldCapReached": "Maximum of 3 additional fields reached. Remove a field to include another.",
  "includefiltered": "Include filtered managers",
  "autofixhier": "Handle multiple department heads",
  "addexecteam": "Add 'Executive Team'",
  "dateBracket": "Date Bracket",
  "january": "January",
  "february": "February",
  "march": "March",
  "april": "April",
  "june": "June",
  "july": "July",
  "august": "August",
  "september": "September",
  "october": "October",
  "november": "November",
  "december": "December",
  "jan": "Jan",
  "feb": "Feb",
  "mar": "Mar",
  "apr": "Apr",
  "may": "May",
  "jun": "Jun",
  "jul": "Jul",
  "aug": "Aug",
  "sep": "Sep",
  "oct": "Oct",
  "nov": "Nov",
  "dec": "Dec",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",
  "Sunday": "Sunday",
  "alignleft": "Align Left",
  "aligncenter": "Align Center",
  "alignright": "Align Right",
  "aligntop": "Align Top",
  "alignmiddle": "Align Middle",
  "alignbottom": "Align Bottom",
  "bringtofront": "Bring to Front",
  "sendtoback": "Send to Back",
  "bringforward": "Bring Forward",
  "sendbackward": "Send Backward",
  "datagroupmapping": "Data group mapping",
  "group": "Group",
  "ungroup": "Ungroup",
  "groupprops": "Group Properties",
  "Grouping": "Grouping",
  "pinoff": "Pin Off",
  "pinoptions": "Positioning",
  "pinobj": "Pin Position",
  "scalingOptions": "Scaling",
  "stickleft": "Stick left on resize",
  "stickright": "Stick right on resize",
  "sticktop": "Stick top on resize",
  "stickbottom": "Stick bottom on resize",
  "managefields": "Manage fields",
  "Formulas": "Formulas",
  "Formula": "Formula",
  "of": "of",
  "Untitled": "Untitled",
  "allboxes": "All boxes",
  "allmgr": "All managers",
  "allassist": "All assistants",
  "allnonmgr": "All non-managers",
  "allconn": "All connecting lines",
  "Peers": "Peers",
  "Branch": "Branch",
  "boxsame": "Boxes w/ same format",
  "profloaderr": "Unable to Load profile. Please try again.",
  "profsaveerr": "Unable to create profile. Please try again.",
  "profload": "Profile loaded.",
  "profsave": "Profile saved.",
  "boxsimiliar": "Boxes w/ similar format",
  "textboxes": "Text Boxes",
  "textbox": "Text box",
  "summary": "Summary",
  "lockedboxes": "Locked Boxes",
  "Clipboard": "Clipboard",
  "Tools": "Tools",
  "Alignment": "Alignment",
  "Line": "Line",
  "Chart": "Chart",
  "Charts": "Charts",
  "Editing": "Editing",
  "Page": "Page",
  "Pages": "Pages",
  "Document": "Document",
  "Utilities": "Utilities",
  "Data": "Data",
  "Missing": "Missing",
  "Unzip": "Unzip",
  "comparedirs": "Compare Directories",
  "compare": "Compare",
  "merge": "Merge",
  "rowscols": "Rows & Columns",
  "Merge": "Merge",
  "cellborder": "Cell Border",
  "closeeditor": "Close Editor",
  "Views": "Views",
  "Navigation Sidebar": "Navigation Sidebar",
  "Extras": "Extras",
  "Subcharts": "Subcharts",
  "Track": "Track",
  "tmoved": "Box Moved",
  "tadded": "Box Added",
  "tdelete": "Box Deleted",
  "tupdated": "Box Updated",
  "tmoveupdate": "Box Moved & Updated",
  "comgr": "Co-Mgrs",
  "setascomgr": "Set as co-manager",
  "leftassist": "Left assistant",
  "rightassist": "Right assistant",
  "leftpassist": "Left peer assistant",
  "rightpassist": "Right peer assistant",
  "createcomgr": "Create co-manager group",
  "removecomgr": "Remove co-manager group",
  "datarefresh": "Data Refresh",
  "Connectors": "Connectors",
  "Export": "Export",
  "deletesource": "Delete source file after refresh",
  "refreshmsg": "Refresh your chart to see these changes applied",
  "allowcommitsds": "Allow commits to data source",
  "Web": "Web",
  "webpublish": "Web publish",
  "openfile": "Open chart",
  "openbackground": "Open background",
  "openchartdoc": "Open document",
  "Open Background": "Open background",
  "saveas": "Save as",
  "saveas (short)": "Save as",
  "savemasteras": "Save background as",
  "uploadfile": "Upload/Download Files",
  "selectimport": "Select data file to import",
  "notsandbox": "Not a sandbox account.",
  "bsapply": "Box style to apply:",
  "notset": "<Not Set>",
  "selectbs": "Please select a box style",
  "selectf": "Select field",
  "Select field": "Select field",
  "selectboxprop": "Please set at least one box property",
  "selectfieldprop": "Select field and at least one field property",
  "ctloaderr": "Error loading chart views. Please try again.",
  "helploaderr": "Error loading help file. Please try again.",
  "bsloaderr": "Error loading box styles. Please try again.",
  "fileloaderr": "Unable to load file. Check file permissions.",
  "fileloaderr2": "Unable to load data",
  "fileloaderr3": "File missing or invalid format",
  "accesserr1": "You do not have permission to open this file.",
  "unlinkerr1": "Remove subchart breaks before unlinking a branch.",
  "nameinuse": "Name already in use or reserved.",
  "personidinuse": "PersonID already in use.",
  "nameblank": "Name cannot be blank.",
  "Publisher": "Publisher",
  "Publish": "Publish",
  "ExportChart": "Export chart",
  "createpreview": "Creating preview...",
  "createxml": "Creating XML...",
  "createpdf": "Creating PDF...",
  "createppt": "Creating PPT...",
  "creategoogleslides": "Creating Google Slides...",
  "renderpdf": "Rendering page",
  "loadingpages": "Loading page",
  "generatepdf": "Downloading PDF",
  "generateppt": "Downloading PPT",
  "generategoogleslides": "Uploading Google Slides to Google Drive",
  "downloadprep": "Preparing download...",
  "createsvg": "Creating SVG...",
  "Creating": "Creating",
  "Bkgrnd": "Bkgrnd",
  "Crop": "Crop",
  "navtorec": "Navigate to record",
  "recnavprompt": "Would you like to navigate to the newly added record?",
  "IWizHeadsUp1": "Informational: This method of importing data has been replaced.",
  "IWizHeadsUp2": "Click here to configure master charts.",
  "Conflict": "Conflicts detected",
  "Preexistingid": "This ID already exists in your plan: ",
  "Exit": "Exit",
  "Close": "Close",
  "exporto": "Export to",
  "folderadderr": "Unable to add folder. Please try again.",
  "permdel": "Are you sure you want to permanently delete the selected files?",
  "deleteallmsg": "Are you sure you want to delete all files in this folder?",
  "deleteallpermmsg": "Are you sure you want to permanently delete {fileCount} files in the trash folder?",
  "deleteerr": "Unable to delete selected files. Please try again.",
  "deletefoldererr": "Unable to delete folder. Please try again.",
  "deleteall": "Delete all files",
  "duperr": "Unable to duplicate selected files. Please try again.",
  "renameerr": "Unable to rename selected files. Please try again.",
  "renamefolder": "Unable to rename folder. Please try again.",
  "moveerr": "Unable to move all selected files. Please try again.",
  "filenotfound": "File not found. Please enter a valid file name.",
  "wrongextension": "Invalid file type selected for current mode.",
  "wrongextension2": "Please select a valid ",
  "novalue": "Value must be at least 2 characters long",
  "saveerror": "Error saving file. Please try again.",
  "uploaderror": "Unable to upload file. Please try again.",
  "bssaveerror": "Error saving box styles. Please try again.",
  "bsreload1": "Are you sure you want to reload box styles?",
  "bsreload2": "All changes will be discarded.",
  "ctsaveerror": "Error saving chart views. Please try again.",
  "ctreload1": "Are you sure you want to reload your chart views?",
  "ctreload2": "All changes will be discarded.",
  "deletect": "Are you sure you want to delete the selected chart views?",
  "deleteusers": "Are you sure you want to delete the selected users?",
  "deleteuser": "Are you sure you want to delete user ",
  "deleteuser2":"from your account",
  "fileinfoerror": "Unable to refresh directory. Please try again.",
  "unziperr": "Unable to unzip file. Check zip file and try again.",
  "unzipping": "Unzipping...",
  "uploadingnow": "File Uploading...",
  "loadingfolder": "Loading...",
  "addafolder": "No files exist",
  "optimizing": "Optimizing...",
  "nofoldersexist": "No folders exists",
  "copypuberr": "Unable to copy output to selected folder. Please try again.",
  "copypubfolder": "Saving to",
  "pubdest": "Select publish destination",
  "savefolder": "Account Folder",
  "nofolderselect": "No folder selected",
  "selectfolder": "Select Folder",
  "outwhat": "Output what",
  "outoptions": "Slide size",
  "standardppt": "Standard (4:3)",
  "widescreenppt": "Widescreen (16:9)",
  "printpdf": "Optimize for printing",
  "screenpdf": "Optimize for screen",
  "folderempty": "This folder is empty.",
  "publimit1": "Are you sure you want to publish",
  "publimit2": "pages?",
  "replacemsg": "The file already exists. Do you want to replace the file?",
  "groupnamemsg": "Need at least 3 characters for group name.",
  "Group Name Exists": "Please use a unique name for your filter group.",
  "delbsmsg1": "Are you sure you want to delete the selected box styles?",
  "delbsmsg2": "Warning: Some box styles referenced by chart views.",
  "delctmsg1": "Are you sure you want to delete the selected chart views?",
  "delviewmsg1": "Are you sure you want to delete the selected views?",
  "delfltrwmsg1": "Are you sure you want to delete the selected filter?",
  "viewdeldmsg": "The selected view has been deleted. Please contact your system administrator.",
  "saveconfirm1": "Do you want to save changes to",
  "saveconfirm2": "?",
  "ql1": "Manually create a new chart.",
  "ql2": "Open an existing chart.",
  "ql3": "Download sample Excel data.",
  "ql4": "Upload an Excel file.",
  "ql5": "Launch the Import Wizard.",
  "ql6": "Publish the current chart to PNG, SVG or PDF.",
  "ql7": "Run through the tutorials.",
  "ql8": "Review the sample files.",
  "ql9": "Watch 'How To' Videos.",
  "ql10": "Download the Getting Started Guide.",
  "quicklinks": "Quick Links",
  "showql": "Show Quick Links after login",
  "freetrialtl1": "Your free trial has",
  "freetrialtl2": "left.",
  "freetrial1": "Free Trial",
  "freetrial2": "Thank you for trying",
  "freetrial4": "Your trial account allows you to import up to 1000 records. Contact us if you need more capacity.",
  "freetrial5": "At the end of your trial, you will be downgraded to a free read only account and will continue to have access to all of your documents. ",
  "freetrial6": "There is no obligation to you.",
  "quickstart": ">>>Click here to open the Quick Start Guide<<<",
  "freetrial4a": "allows you to create charts directly from ADP Workforce Now or Vantage.",
  "freetrial4b": "Call 1-415-462-1313 for assistance or to schedule a demo.",
  "quickstarta": ">>> Setup your ADP Connection ",
  "quickstartb": ">>> Open the Quick Start Guide ",
  "quickstartc": ">>> Email us with any questions ",
  "adphelpemail": "ADP Free Trial Connection Assistance",
  "Day": "Day",
  "To": "To",
  "addrestricted": "Add Restricted Field",
  "Search Archived Charts": "Search Archived Charts",
  "Days": "Days",
  "singleplimit": "Max number of boxes on a single page",
  "maxplimit": "Max number of boxes on a custom chart",
  "signout": "Sign out",
  "Limit": "Limit",
  "items": "items",
  "results": "Results",
  "yesfileresults": "Search results in ",
  "nofileresults": "No Search results in ",
  "noitems": "No items match your search.",
  "Continue": "Continue",
  "Purchase": "Purchase",
  "ExistingAppend": "An existing append entry already exists. Click YES to be redirected to the existing append entry.",
  "ManyExistingAppends": "Many existing append entries already exist. Click YES to be redirected to the list of existing append entries.",
  "acctdisable1": "Account Disabled",
  "acctdisable2": "Your account is disabled.",
  "acctdisable3": "Please email us at",
  "acctdisable4": "if you would like to reactivate your account.",
  "acctexpired1": "Free Trial Complete",
  "acctexpired2": "Thank you for trying",
  "acctexpired3": "Your free trial is complete.",
  "acctexpired4": "Your account has been downgraded to a read only account. You still have access to all of your documents.",
  "msgpostlogin": "Show this message next time I login.",
  "oldpass": "Old password",
  "newpass": "New password",
  "passinvalid": "Old password invalid.",
  "Password must": "Password must",
  "New password must": "New password must",
  "passincnum": "Contain at least one number",
  "passincupp": "Contain at least one upper case character",
  "passinclow": "Contain at least one lower case character",
  "passincspc": "Contain at least one special character",
  "passcommon": "Password is too common. Please try a different password",
  "passnomatch": "Passwords do not match.",
  "passmin": "Be at least",
  "passmin2": "characters",
  "passmsg": "Password must be at least ",
  "passmsg2": " characters, and contain a number, an uppercase letter, a lowercase letter, and a special character (!#@*+? etc).",
  "newpassinvalid": "New password invalid",
  "passreuse": "Password cannot be reused.",
  "resetpass": "Please reset password.",
  "photoqueue": "Loading photos",
  "downexcel": "Preparing Excel...",
  "reenteremail": "Please enter valid email address(s).",
  "invalidemail": "Invalid email address.",
  "reenteremailviewer": "Minimum email length is 4 chars.",
  "noemailwarning": "Warning! Users require an email to sign in. Are you sure you want to save changes?",
  "Reset password": "Reset password",
  "reqaccessacct": "Request access to existing account.",
  "requestaccess": "Request Access",
  "requestaccessmsg": "Contact your administrator if email address not found.",
  "Enter full URL here": "Enter full URL here",
  "autologon": "Automatically Sign In",
  "Log in": "Log in",
  "loginfail": "Login failed. Please try again.",
  "logintoomany": "Too many login attempts. Account locked for 5 minutes.",
  "passexpired": "Password expired. Use Forgot password link to reset.",
  "disabledAccount": "Account disabled. Click here for details.",
  "acctexpired": "Subscription Expired. Click here for details.",
  "pwemail": "Enter email address",
  "backlogin": "Back to login screen",
  "retrieveuser": "Retrieve User Name",
  "resetpwsuccess": "Check your email for credentials.",
  "resetpwfail": "Could not find a user with this email address. Contact your system administrator for login details.",
  "loaderr1": "The data file format is invalid.",
  "loaderr2": "The first row of the data file must contain field names.",
  "loaderr2b": "The first row of the data file contains a blank field name.",
  "loaderr2c": "Check column",
  "loaderr3": "The field 'ID' is reserved for internal use and cannot be used as a field name.",
  "loaderr4a": "Field names must be unique. The field",
  "loaderr4b": "is used more than once in the data file.",
  "loaderr4c": "is reserved by a predefined calculation. Please change the field name in the data source.",
  "loaderr5": "The file does not contain any data.",
  "loaderr6a": "You are limited to importing a maximum of",
  "loaderr6b": "records. You'll need to upgrade your account to import more records.",
  "loaderr7": "Number of data elements on a row must match number of fields (Check row:",
  "loaderr8": "Field definitions are missing.",
  "loaderr9": "Invalid photo format (convert photos to jpg).",
  "removebreaks": "Remove all breaks",
  "renamebreaks": "Rename all breaks",
  "renamesinglesc": "Rename selected",
  "renameallsc": "Rename All",
  "Letter": "Letter",
  "Legal": "Legal",
  "Tabloid": "Tabloid",
  "A0": "A0",
  "A1": "A1",
  "A2": "A2",
  "A3": "A3",
  "A4": "A4",
  "namescusing": "Name using field",
  "nomaster": "Blank background",
  "currentmaster": "Current background",
  "stdmaster": "Standard background",
  "custommaster": "Custom background",
  "subchartwiz": "Subchart Wizard",
  "selectcmasterIW": "Background",
  "selectcmasterSA": "Background options",
  "advancedoptions": "Advanced options",
  "selectmasterfile": "Select background",
  "multifactorauth": "Multi-Factor Authorization",
  "Change password": "Change password",
  "companyname": "Company name",
  "scarrowstyle": "Subchart arrows",
  "datarefreshoptions": "Data refresh options",
  "datarefreshinfo": "Update the current chart by requerying the data source.",
  "Refresh": "Refresh",
  "entercompany": "Enter company name",
  "enteraccessgroup": "Enter access group name",
  "accessgroup": "Access group",
  "nogroup": "No group selected",
  "orginfochgfail": "Update failed. Please try again.",
  "Subchart": "Subchart",
  "mpdoc": "Not available. The current document is a background.",
  "selectmaster": "Elements on the background will appear on all pages of your chart.",
  "savemaster": "background",
  "Update": "Update",
  "reload": "Reload",
  "documentproperties": "Document properties",
  "manageusers": "Manage users",
  "delegatedsameorgemail": " has already been granted access to this org.",
  "reloadusers": "Reload",
  "ufuserfeed": "UserFeed Folder",
  "ufsystem": "System Folder",
  "manageaccessgroups": "Manage Access Groups",
  "managegroups": "Manage Groups",
  "accessgroups": "Access Groups",
  "Access groups": "Access groups",
  "Manage users": "Manage users",
  "UI profiles": "UI profiles",
  "Chart management": "Chart management",
  "usertype": "User Type",
  "enableexporte": "Enable export to Excel",
  "enableaccesslist": "Enable row level security",
  "enabledittemp1": "Update chart views and box styles",
  "enabledittemp2": "",
  "enablelimitaccess": "Set branch level security",
  "orgchartbuild": "OrgChart Builder",
  "querybuildsetuperr": "OrgChart Builder is not configured. Contact technical support for next steps.",
  "querybuilddataerr": "Could not load your chart. ",
  "nosearchresults": "No items found.",
  "servercharterr": "Unable to load chart data. Contact customer support if this issue persists.",
  "Could not load page": "Could not load page",
  "The number of records on the page exceeds the single page limit": "The number of records on the page exceeds the single page limit",
  "canvastoolarge": "This page is too large for the browser to draw.",
  "Maximum": "Maximum",
  "To remedy this issue: reduce the number of levels shown, adjust subchart break criteria, or apply a filter": "To remedy this issue: reduce the number of levels shown, adjust subchart break criteria, or apply a filter",
  "Server": "Server",
  "serverqueryerr": "Search failed. Contact technical support if this problem persists.",
  "searching": "Searching...",
  "queryoptions": "Search for Top Position",
  "Recent Target Positions": "Recent Top Positions",
  "displayoptions": "Display Options",
  "filteroptions": "Filter Out",
  "dataoptions": "Data Options",
  "subchartoptions": "Insert subchart breaks",
  "Page size": "Page size",
  "pagebreaks": "Page Breaks",
  "singlepage": "Single Page Chart",
  "multipage": "Insert Page Breaks",
  "queryresults": "Top Position",
  "queryblank": "No top position specified",
  "No top box specified": "No top box specified",
  "f_name": "First name",
  "l_name": "Last name",
  "preferredfirst": "Preferred First",
  "preferredlast": "Preferred Last",
  "s_title": "Title",
  "alternatetitle": "Alternate Title",
  "noqueryresults": "Could not retrieve data. Try refreshing your chart or adjusting your filter settings.",
  "unknownqerr": "System not configured. Contact customer support at: ",
  "sharepointqerr": "Failed to configure SharePoint. Contact customer support at: ",
  "connectionerr": "Connection error occurred. Please check your connection and try again",
  "planconfigupdated": "Plan configuration has been updated.",
  "planupdatedlatest": "Plan changes synced.",
  "talentpoolupdated": "Talent pool has been updated",
  "querytoomanyresults": "Too many records returned.",
  "querytoomanyresults4": "Too many results to fit on a single page ",
  "querytoomanyresults3": "Too many results to fit in a document ",
  "Too many matches Expand your search to narrow the results": "Too many matches. Narrow search.",
  "includelevels": "Levels to include",
  "pleaseReduceNumberLevels": "Please reduce the number of levels of your chart.",
  "buildchart": "Go",
  "None": "None",
  "No preview": "No preview",
  "Select a preview": "Select a preview",
  "failedauth": "Failed Authentication",
  "Never": "Never",
  "searchdir": "Search",
  "orgprefs": "Preferences",
  "sysadmin": "System Admin",
  "genlayout": "Generate Layout",
  "perfreport": "Test Performance",
  "testpanel": "Test Panel",
  "savewhat": "Save what",
  "hidemaster": "Hide background elements",
  "excludebackgrnd": "White background",
  "Use a white background instead of a color. This option is helpful if you plan to print this file": "Use a white background instead of a color. This option is helpful if you plan to print this file",
  "currentbranch": "This branch",
  "orphanrecords": "All disconnected records",
  "toporphans": "Disconnected branches",
  "includeorphans": "Include orphans",
  "entirechartplus": "All records",
  "redeployed": "Redeployed only",
  "section508": "Section 508",
  "customexcel": "Custom...",
  "customfont": "Custom",
  "customFontTitle": "New Font Style",
  "customFontCmd": "Font Name",
  "customFontMsg": "e.g. Helvetica ",
  "chainofcommand": "Chain of command",
  "excelsubs": "Subordinates",
  "excelmgr": "Manager",
  "headerrow": "Free Text - 1 column",
  "headerrow2": "Free Text - 2 column",
  "groupfolders": "Folders",
  "filemgrfolder": "folder",
  "Author": "Author",
  "useringroup": "group members can access the folders:",
  "boxlayouteditor": "Box layout editor",
  "Open Editor": "Open editor",
  "Box Properties": "Box properties",
  "tableprops": "Table editor",
  "legendprops": "Legend editor",
  "mrbprops": "Group properties",
  "grouptype1": "Group with Header",
  "grouptype2": "Headerless Group",
  "grouptype3": "Co-manager Group",
  "Columns": "Columns",
  "grouptype": "Group Type",
  "SelectP": "Select...",
  "SortP": "Sort...",
  "OptionsP": "Options...",
  "RestrictP": "Restrict...",
  "restrictblank": "List cannot be blank",
  "agroupnamemin": "Access group name cannot be blank.",
  "agroupnameused": "Access group name must be unique.",
  "agroupnofolders": "Access group contains all folders.",
  "Report Blank": "Report name cannot be blank.",
  "Rename failure": "Rename failure",
  "agroupdirerr": "Transaction failed (GROUPDIRFAIL).",
  "fullaccess": "Full access",
  "fullaccess0": "Full access + read-only role",
  "fullaccess1": "Full access + read / write role",
  "fullaccess2": "Full access + admin role",
  "GroupName": "Group:",
  "defaultgroupname": "Enter group name",
  "userdetails": "User details",
  "userdetails (short)": "User details",
  "orgnamemin": "Company name cannot be blank.",
  "changeimportfile": "Select Data Source",
  "currentimportfile": "Import data from:",
  "rpdatasource": "Source",
  "rpfilter": "Filter Data",
  "rpreqfields": "Define Fields",
  "rpassistwiz": "Assistants",
  "rpsubcharts": "Subcharts",
  "Chart view": "Chart view",
  "rpmaster": "Background",
  "rpadvoptions": "Advanced",
  "refreshnow": "Refresh Data Now",
  "loading": "[1] Loading...",
  "dynloading": "Building Chart...",
  "dynmsg1": "Loading settings...",
  "dynmsg2": "Gathering latest base chart data...",
  "dynmsg3": "Applying customization...",
  "Session Timeout": "Session Timeout",
  "Saving": "Saving",
  "buildingchart": "[2] Loading...",
  "saving": "[1] Saving...",
  "saving2": "[2] Saving...",
  "savinggroups": "Saving changes...",
  "retrievingkey": "Retrieving Keys...",
  "savingprofile": "Saving Profile...",
  "loadingprofile": "Loading Profile...",
  "retrievingdata": "Retrieving Data...",
  "loadingdata": "Syncing base chart from source HRIS...",
  "creatingchart": "Creating Chart...",
  "pagelimit": "Single page limit exceeded!",
  "dirtyfilter": "Chart modified by user. Discard changes?",
  "smartstartlevel": "Start breaks at:",
  "nochartsloaded": "No charts loaded",
  "nochartsforplanning":
    "No charts have been configured. Please click here to configure a chart first.",
  "clicktoconfigure": "Click here to configure",
  "nomatches": "No matches found.",
  "onematch": "1 match found.",
  "matchesfound": "matches found.",
  "nowrap": "Text wrap off",
  "oneline": "Limit to 1 line",
  "twolines": "Limit to 2 lines",
  "threelines": "Limit to 3 lines",
  "fourlines": "Limit to 4 lines",
  "unlimited": "Unlimited wrap",
  "freetext": "Free text",
  "fieldcompblank": "Fields and comparisons cannot be blank.",
  "cursubchart": "Current Subchart",
  "currentpage": "This page",
  "autoself": "Auto (Self)",
  "autosmart": "Auto (Smart)",
  "selectimagefile": "Select Image",
  "Open Image": "Open Image",
  "comparecurfile": "Select Comparison File",
  "Select comparison": "Select comparison",
  "Toggle fields to include": "Toggle fields to include",
  "mergecurfile": "Select File to Merge",
  "action": "Action",
  "validfile": "Please select a valid file type.",
  "maxfilesize": "Maximum file size is",
  "maximagesize": "Maximum image file size is 1MB.",
  "scaleh": "Scale Height %",
  "scalew": "Scale Width %",
  "maintainaspect": "Lock aspect ratio",
  "Set Aspect Ratio": "Set Aspect Ratio",
  "freeaspect": "Unlock aspect ratio",
  "scalehorz": "Scale to fill page (horizontal)",
  "scalevert": "Scale to fill page (vertical)",
  "scalefill": "Scale to fill entire page",
  "fieldtype": "Field Type",
  "fieldlabel": "Field Label",
  "invalidchartappend": "You must have a master chart open in viewer to begin configuring an append table. ",
  "decimalplaces": "Decimal Places",
  "Text": "Text",
  "Number": "Number",
  "Date": "Date",
  "RefText": "Summary",
  "Image": "Image",
  "Images": "Images",
  "Photo": "Photo",
  "Photos": "Photos",
  "textwrapchars": "Break Chars",
  "Performance": "Performance",
  "Potential": "Potential",
  "ninebox": "Nine Box",
  "Blank": "Blank",
  "Null - Not configured": "Null - Not configured",
  "Link Type": "Link Type",
  "nobreakstoomany": "Single page chart (disabled - too many records)",
  "removebreakstoomany": "Remove all breaks (Disabled - too many records)",
  "Match": "Match",
  "Matches": "Matches",
  "clearsearch": "Clear",
  "selfsubs": "Self + Subordinates",
  "subsonly": "Subordinates",
  "selfdirreports": "Self + Direct Reports",
  "dirreports": "Direct Reports",
  "Range": "Range",
  "clearprops": "Clear Properties",
  "useradderr": "User ID in use. Please try another id.",
  "maxseats": "All read/write seats in use.",
  "emailadderr": "Email already in use. Please try another email.",
  "unexpectederr": "Update failed. An internal error occured.",
  "readonlyuser": "Read Only",
  "readwriteuser": "Read/Write",
  "readonly": "Read Only",
  "readwrite": "Read/Write",
  "adminuser": "Administrator",
  "adminuser2": "Admin",
  "agupdatedbody": "Users with this applied Group won't change role until next login",
  "logindisabled": "Login Disabled",
  "privatefolder": "Add private folder",
  "deleteself": "The current user cannot be deleted.",
  "disablecuruser": "You cannot disable your own account.",
  "curusersysadmin": "Seat type cannot be changed for current user.",
  "curuserchgid": "User ID of current user cannot be changed.",
  "deluserserr": "Transaction failed. Please try again (USERDELFAIL).",
  "userlisterr": "Transaction failed (USERLISTFAIL).",
  "grouplisterr": "Transaction failed (GROUPLISTFAIL).",
  "groupupdateerr": "Transaction failed (GROUPUPDATEFAIL).",
  "applyingtemplate": "Applying View...",
  "buildinghierarchy": "Building Hierarchy...",
  "API": "API",
  "applymaster": "Apply background",
  "apikey": "API Key",
  "orgname": "Org Name",
  "username": "Username",
  "mobile": "Mobile (Optional)",
  "userid": "User ID",
  "Email address": "Email address",
  "Email": "Email",
  "email": "email",
  "Skype": "Skype",
  "skype": "skype",
  "Phone": "Phone",
  "phone": "phone",
  "file2": "File",
  "validuserid": "Minimum User ID length 6 chars.",
  "validmongouserid": "Minimum User ID length is 3 chars.",
  "Minimum length is 2 characters": "Minimum length is 2 characters",
  "initialpass": "Initial Password",
  "docopy": "Copy Text",
  "reloadpic": "Reload Photo",
  "domgraction": "Manager Actions",
  "doprofile": "Employee Profile",
  "doemail": "Send Email",
  "docall": "Call Phone",
  "doskype": "Call Skype",
  "dohyperlink": "Open Hyperlink",
  "dofile": "Open File",
  "seatsused": "read/write seats used",
  "used": " used",
  "Password": "Password",
  "Output": "Output",
  "Share": "Share",
  "seattype": "Seat Type",
  "prefix": "Prefix",
  "postfix": "Postfix",
  "percentage": "Percentage",
  "thousandssep": "Use 1000 Separator",
  "Hyperlink": "Hyperlink",
  "hyperlink": "hyperlink",
  "notlinked": "-",
  "oldInternetExplorer": "Internet Explorer 9 detected. Please upgrade to a newer release of Internet Explorer or try using Google Chrome.",
  "replacefile": 'Click "Replace Existing File" to update the existing file in this directory or "Skip Duplicate" to only add the new file.',
  "replacefilenonew": 'Click "Replace Existing File" to update the existing file in this directory or "Cancel" to cancel the upload.',
  "replacefiles": 'Click "Replace Existing Files" to update existing files in this directory or "Skip Duplicates" to only add new files.',
  "replacefilesnonew": 'Click "Replace Existing Files" to update existing files in this directory or "Cancel" to cancel the upload.',
  "sortorder": "Order",
  "sortfield": "Sort Field",
  "Ascending": "Ascending",
  "Descending": "Descending",
  "Sort": "Sort",
  "sortselection": "Selection",
  "sortsubchart": "Current Subchart",
  "sortchart": "Entire Chart",
  "blankselection": "Unable to sort. Select at least one box.",
  "Refine": "Refine By",
  "applyto": "Apply to:",
  "addcoheadscb": "Create co-head chart",
  "addcoheadsplancb": "Create co-head plan",
  "cohead": "Co-Head",
  "sortboxescb": "Sort boxes after refresh",
  "includereftbl": "Use Reference Table",
  "refinvalid": "Invalid",
  "refnotfound": "Not Found",
  "viewnotfound": "View not found",
  "sourcenotfound": "Source Not Found",
  "refnotconfig": "Not Configured",
  "refcirc": "Circular Reference",
  "invaliddate": "INVALID",
  "appenddata": "Append Data",
  "restrictcb": "Restrict Query",
  "customoutfields": "Use Custom Output Fields",
  "compoundcb": "Create multi-chart document",
  "topboxcb": "Specify top box",
  "restrictq": "Restrict Query to these Fields",
  "entertopbox": "Enter comma separated list of top box ids",
  "topboxmin": "Top box ids cannot be blank.",
  "spliton": "Split using",
  "Division": "Division",
  "splitaltkey": "Alternate key",
  "connmsg1": "Email",
  "connmsg2": "for help configuring connectors.",
  "English": "English",
  "French": "French",
  "Spanish": "Spanish",
  "German": "German",
  "rows": "rows",
  "Span": "Span",
  "authenticating": "Authenticating...",
  "preservebs": "Preserve manual changes to branch styles",
  "preservebo": "Preserve box sort (overrides sort after refresh)",
  "preservesb": "Preserve user changes to pagination (subchart breaks)",
  "preserveassist": "Preserve manual identification of assistants",
  "preservebl": "Preserve manual changes to box presentation (box layouts)",
  "selectedtemp": "Selected chart view",
  "refreshwarning1a": "Warning:",
  "refreshwarning1b": "option is not recommended for charts with more than 100 boxes. Use conditional formatting (Chart Views) or Box Locking.",
  "testauth": "Authentication test",
  "dateformat": "Date format",
  "commit": "Commit",
  "accessprivs": "Access Privileges",
  "restrictaccess": "Restrict access to current document",
  "uploadaccess": "Upload New Privs",
  "loadtoedit": "Load a chart to edit filters and highlights",
  "downloadaccess": "Download Current Privs",
  "validaccesspriv": "Access privs loaded successfully.",
  "invalidaccesspriv1": "Error - file empty.",
  "invalidaccesspriv2": "Error - check line: ",
  "invalidaccesspriv3": "Error - header invalid.",
  "twocolortri": "Two Color Triangle",
  "chartaccess": "Allow access",
  "branchlevelsecurity": "Branch level security",
  "canExportExcel": "Export to Excel",
  "canEditTemps": "Edit views and box styles",
  "advancedSettings": "Advanced settings",
  "Access Group": "Access group",
  "allowedviews": "Allowed views",
  "allowedFilters": "Allowed filters",
  "allowedHighlights": "Allowed highlights",
  "availableviews": "Available views",
  "setcolor": "Set Color",
  "setlabel": "Set Label",
  "setdashed": "Set Dashed",
  "setposition": "Position on left",
  "worker": "ADP Workforce Now",
  "workerdemo": "ADP Vantage",
  "workerrun": "ADP RUN",
  "xmlformat": "XML Format",
  "pdftype": "PDF",
  "ppttype": "PPT",
  "boxcount": "Box count",
  "aboxcount": "Allowed box count:",
  "seatcount": "Seat count:",
  "status": "Status:",
  "userlookup": "User lookup:",
  "usage": "Usage:",
  "user": "user",
  "users": "Users",
  "sysutilities": "Tools:",
  "expiredate": "Expire date:",
  "serverinfo": "Server information:",
  "accounttype": "Account type:",
  "source": "Source:",
  "notsupported": "Not supported by",
  "source2": "Select source",
  "connector": "Connector:",
  "ats": "ATS:",
  "channel": "Channel:",
  "country": "Country:",
  "startdate": "Start date:",
  "keycontact": "Key Contacts:",
  "keyname": "Key Name",
  "contactemail": "Contact email:",
  "notes": "Notes:",
  "term": "Term:",
  "deployment": "Deployment:",
  "edition": "Edition:",
  "orginfo2": "Org info: ",
  "userinfo2": "User info: ",
  "orgname2": "Legal name:",
  "LookupU": "Lookup",
  "ActivityR": "Activity report",
  "ActivityLog": "Logs...",
  "notSelected": "Please select a source.",
  "profilesavepanel": "Save Profile",
  "sandboxupdate": "Sandbox account updated.",
  "sandboxtool": "Sandbox Account:",
  "expirytool": "Subscription Report:",
  "expirybutton": "Download",
  "resetdirs": "Reset Folders",
  "resetcharts": "Blank",
  "saveconf": "Are you sure you want to leave? You will lose any unsaved changes.",
  "genericsave": "Do you want to save your changes? Any unsaved changes will be lost.",
  "LookupR": "Lookup Result",
  "usersummary": "User Report",
  "svrsummary": "Tenant Report",
  "trialstart": "Trial Start:",
  "invaliddatemsg": "Invalid Date",
  "triallen": "Trial Length (days):",
  "orginfo": "Account information updated successfully.",
  "userinfo": "User information updated successfully. Changes apply on next login.",
  "accountdetails": "Account Details updated successfully.",
  "acctdetails": "Account details",
  "acctdetails2": "Account details",
  "missingmissing": "Photos directory does not contain missing.jpg.",
  "pngstdquality": "Standard quality",
  "pnghiquality": "High quality",
  "Export a higher quality image to embed into a Word document or PowerPoint presentation": "Export a higher quality image to embed into a Word document or PowerPoint presentation",
  "validated": "Validated",
  "testlink": "Test link",
  "TestLinkTokenError": "Unable to test this link right now. Please try again.",
  "genlink": "Generate link",
  "copylink": "Copy link",
  "allowmanualrefresh": "Allow this chart to be refreshed manually",
  "publiclink": "Public link",
  "privatelink": "Private link",
  "restrictedlink": "Restricted link",
  "benchtoviewer": "VIEWER",
  "onlaunch": "On Launch:",
  "takenoaction": "Take No Action",
  "openmychart": "Open 'My Chart",
  "directory": "Directory",
  "portal": "Portal",
  "iframe": "iFrame",
  "Presentation": "Presentation",
  "background": "Background",
  "zoom": "Zoom",
  "useuiprofile": "Use UI Profile",
  "showprofpanel": "Profile card",
  "showscpanel": "Subchart card",
  "includeself": "Include self",
  "enablemw": "Enable Mouse Wheel",
  "startpoint": "Starting Point",
  "Additional parameters": "Additional parameters",
  "togglesaml": "SAML deep link",
  "entityid": "Entity ID:",
  "Result": "Result",
  "confidential": "Confidential - Internal Use Only",
  "orgchart": "OrgChart",
  "croptochart": "Crop to chart",
  "transbk": "Transparent background",
  "Filters": "Filters",
  "Actions": "Actions",
  "Shortcuts": "Shortcuts",
  "includebkgrndcolor": "Background color",
  "tab": "Inital Tab:",
  "enablefilemgr": "Enable File Manager",
  "enableexcel": "Enable Excel Export",
  "enablegoogleslides": "Enable Google Slides Export",
  "enablepublish": "Enable publishing",
  "More": "More",
  "newchart": "New chart",
  "New Append Table": "New append table",
  "Create New Table": "Create new table",
  "Edit Append Table": "Edit append table",
  "Edit Table": "Edit table",
  "Create Override": "Create override",
  "Delete Table": "Delete table",
  "Dynamic Navigation": "Navigation arrows",
  "Include clickable navigation arrows connecting pages of the chart. May not be useful when physically printing": "Include clickable navigation arrows connecting pages of the chart. May not be useful when physically printing",
  "Background Publish": "Background publish",
  "Zoom": "Zoom",
  "OrgChart Workbench": "OrgChart Workbench",
  "Open Existing Chart": "Open existing chart",
  "Default Template": "Default view",
  "Theme": "Theme",
  "Measurements": "Measurements",
  "SI": "SI",
  "Enable Right-Click": "Enable right-click",
  "Mouse wheel": "Mouse wheel",
  "More Options": "More options",
  "Drill down available": "Drill down available",
  "Drill down": "Drill down",
  "Drill up": "Drill up",
  "Drill up available": "Drill up available",
  "Chart keyboard help": "Org chart. Use the arrow keys to move between boxes, Enter to open the box actions, and Alt plus Up or Down arrow to drill. Press Tab to leave the chart.",
  "Fit to Screen": "Fit to screen",
  "Size": "Size",
  "Include Master": "Include background",
  "Include elements on the background, such as logos, legends, tables, and page numbers": "Include elements on the background, such as logos, legends, tables, and page numbers",
  "Size for Printing": "Size for printing",
  "Scope": "Scope",
  "Show fields": "Show fields",
  "showvalues": "Show Values",
  "Default view": "Default view",
  "Support": "Support",
  "View": "View",
  "Page Size & Margins": "Page size & margins",
  "Advanced": "Advanced",
  "Changes": "Changes",
  "Assistants": "Assistants",
  "createnew": "Create new",
  "reqpitinfo": "Click Here to learn more about Point in Time Charts",
  "archivesuccess": "Archive Created Successfully.",
  "archiveloadsuccess": "Archive Loaded Successfully",
  "archivenotfound": "Archive not found for specified date.",
  "deltaerr": "Error generating delta report",
  "invalidrange": "Invalid Date Range",
  "deltafailure": "Delta Report Generation Unsuccessful",
  "archivefail": "Archive Request Failure.",
  "exportnotfound": "Archive Export Not Found for Specified Date.",
  "exportfailure": "Archive Export Unsuccessful",
  "exportfullaccessonly": "Archive export is only available to users with full access to this chart.",
  "Help Resources": "Help Resources",
  "Terms of Service": "Terms of Service",
  "paywalldropdown": "Upgrade to unlock-Enterprise Features",
  "paywalldropdownGeneral": "Enterprise Features-Not Enabled",
  "paywallhover": "Enterprise Feature",
  "moreviews": "Manage Views...",
  "Manage Profile": "Manage Profile...",
  "Manage Filters": "Manage Filters...",
  "Chart background": "Chart background",
  "Print Current Screen": "Print current screen",
  "Off": "Off",
  "vscroll": "Scroll (Up/Down)",
  "hscroll": "Scroll (Left/Right)",
  "function": "Function",
  "supportfunction": "Supporting Function",
  "placeholdercb": "Functional Chart",
  "functionalchartoption": "Function {index}",
  "backgroundHotLink": "Modify Backgrounds",
  "directoryHotLink": "Modify Directory Keys/Settings",
  "enterhighlight": "Enter highlight rule here",
  "enterhighlightname": "Enter highlight name here",
  "enterfilter": "Enter filter rule here",
  "enterfiltername": "Enter filter name here",
  "filterinvalid": "Invalid filter rule",
  "filtervalid": "Valid filter rule",
  "valuedefvalid": "Valid field value",
  "valuedefinvalid": "Invalid field value: field does not exist.",
  "upgradepremiumemail": "Upgrade to OrgChart Premium",
  "ADPKeyFailure": "Failed to retrieve ADP keys. Ensure that consent has been provided in the ADP marketplace.",
  "isolvedKeyFailure": "No isolved employee data is available yet. You may need to wait until your next employee sync. Contact support if this occurs again.",
  "Print Preview": "Print preview",
  "resettocheckpoint": "Restore current Checkpoint",
  "Type": "Type",
  "Advanced Search Keys": "Advanced Search Keys",
  "searchkeys": "Search Keys",
  "Mapping": "mapping",
  "Configuration Settings": "Configuration Settings",
  "Configuration": "Configuration",
  "deltareport": "Delta report",
  "CSVRefreshFailure": "Could not load the CSV data. Ensure the file is in the specified directory.",
  "autoposition": "Launch to own chart box",
  "setChartDefault": "Set chart as default",
  "dumpMetadata": "Make new checkpoint",
  "loadMetadata": "Upload a checkpoint",
  "Add Access Group": "Add access group",
  "Login mode": "Login mode",
  "Font Face": "Font style",
  "Launch Workbench": "OrgChart Workbench",
  "RefreshConfirm": "Are you sure you want to refresh this chart from data source?",
  "Refresh Now": "Refresh now",
  "Language": "Language",
  "selected": " selected.",
  "Select Language": "Select Language",
  "All": "All",
  "AddNewChartDBConfig": "Do you want to add new charts from your metadata file?",
  "deleteChart": "Delete this chart",
  "deleteConfirm": "Are you sure you want to delete this chart?",
  "deleteOpenConfirm1": "Are you sure you want to delete this chart? Once you save your changes, the current open chart will close.",
  "deleteOpenConfirm2": "You have deleted the current open chart. To open a new chart, close the Account Settings menu, and then select a chart from the Chart dropdown in the Top Toolbar.",
  "buildpit": "Build from Archive",
  "My Settings": "My settings",
  "Chart Settings": "Chart settings",
  "Account Settings": "Account settings",
  "Plan settings": "Plan settings",
  "usernameupdatefail": "Cannot change username of this user.",
  "New User": "New user",
  "Time Format": "Time format",
  "Chart Builder Masters": "Chart builder backgrounds",
  "Chart Info": "About",
  "Current Screen": "This screen",
  "Alert": "Alert",
  "GroupNameError": "Group Name Error",
  "Chart Template Missing": "The chart view for the selected View is missing. Please contact your system administrator to fix.",
  "Checkpoints": "Checkpoints",
  "Checkpoint": "Checkpoint",
  "entercheckpointname": "Enter a checkpoint name",
  "checkdelconfirm": "Are you sure you want to delete this checkpoint?",
  "permanentaction": "Warning: This action cannot be undone",
  "loadeddate": "Currently Loaded Archive",
  "scheduleoptions": "Scheduling options",
  "pitenabled": "Automatic archive",
  "lastpit": "Last archive",
  "Links": "Links",
  "Link": "Link",
  "totalusers": "users total.",
  "You do not have permission to view this chart": "You do not have permission to view this chart.",
  "No chart data loaded - select the Refresh Data Now option to load data": "No chart data loaded - select the Refresh Chart option to load data.",
  "No chart data loaded mobile": "No chart data loaded. Select the refresh button in the tools menu below to load data. If issue persists, configure chart in full site version of OrgChart.",
  "Invalid or unset default chart Define the default chart in the database config panel": "Invalid or unset default chart. Define the default chart in the database config panel.",
  "ADPKeyFailurePremium": "OrgChart Premium needs you to provide consent before we can load your HR data. Click on the link below to provide consent. After providing consent, click on the RETRY button to start using OrgChart.",
  "Current View": "Current view",
  "Current view applied": "Current view applied",
  "Current Chart": "Chart info",
  "copyall": "All",
  "copyitem": "Item",
  "chartinfo": "Chart info",
  "accountinfo": "Account details",
  "appinfo": "Application info",
  "planinfo": "Plan info",
  "copyclipboard": "Copy to clipboard",
  "Chart Name": "Chart name",
  "Filters Applied": "Filters applied",
  "Master Page": "Background",
  "copymessage": "Copied ",
  "containstext": "Enter Text",
  "containsuser": "Enter user name or email",
  "copymessage2": " to clipboard",
  "Section": "Section",
  "Levels Shown": "Levels shown",
  "Current top box": "Current top box",
  "Number of Boxes": "Boxes shown",
  "OrgID": "OrgID",
  "boxlimit": "Box limit ",
  "allowedlimit": "allowed box limit ",
  "uploadinprogress": "File Uploading...",
  "UserID": "UserID",
  "Browser": "Browser",
  "Browse": "Browse",
  "Browse Files": "Browse files",
  "SFTP": "SFTP",
  "Application": "Application",
  "unknownerrnoemail": "Unknown error. Try reloading the page, or contact support if this issue persists.",
  "Get started with OrgChart Premium!": "Get started with OrgChart Premium!",
  "basicROPaywall": `Your ADP Role does not allow you to make purchases in the ADP Marketplace. To purchase, contact your ADP Workforce Now administrator. Email ${supportEmailaddr} or call 1.415.462.1313 for more information.`,
  "basicAdminPaywall": `To purchase OrgChart Premium visit the ADP Marketplace or for more information email ${supportEmailaddr} or call 1.415.462.1313.`,
  "basicPaywallExcl": `OrgChart Premium is not yet available in your region. For more information email ${supportEmailaddr} or call 1.415.462.1313.`,
  "basicPaywallLegacy": `You are already subscribed to an older version of OrgChart. Email ${supportEmailaddr} or call 1.415.462.1313 to switch over to OrgChart Premium.`,
  "refreshdata": "Refresh Data",
  "Chart Builder": "Chart Builder",
  "Security": "Security",
  "Enter name here": "Enter name here",
  "Auto Apply": "Auto Apply",
  "Load Charts": "Load Charts",
  "Add new chart confirm": "Do you want to manually create a new chart? You will need to ensure that your data source and configuration are correct.",
  "docut": "Cut Text",
  "Data Refresh Successful!": "Data Refresh Successful!",
  "Merge Data": "Merge Data",
  "No Rule": "No Rule",
  "Basic Rule": "Boxes matching field value criteria",
  "color": "Color",
  "border": "Border",
  "shape": "Shape",
  "Apply Template": "Apply View",
  "Applied From": "Applied From",
  "needsrefresh": "A new version of OCN has been released. Please reload your browser (Ctrl+Shift+R).",
  "redirectToIDP": "Redirecting to your IDP.",
  "signInDisabled": "Direct sign-in has been disabled. Please contact your administrator for details.",
  "confirmationCode": "Please enter the Confirmation Code from your authenticator app.",
  "invalidConfirmationCode": "Invalid confirmation code.",
  "Highlight": "Highlight",
  "Highlights": "Highlights",
  "highlight": "highlight",
  "automatic": "Automatic",
  "manual": "Manual",
  "on": "On",
  "Build": "Build",
  "autochildren": "Auto (Children)",
  "using": "using",
  "Saved filters": "Saved filters",
  "Interactive filters": "Interactive filters",
  "Shared filters": "Shared filters",
  "Shared highlights": "Shared highlights",
  "Archived Charts": "Archive",
  "Presentation Options": "Presentation",
  "7029": "Unrecognized command. Please refresh your browser, or contact customer support if this issue persists.",
  "2016": "Preprocessor Failure",
  "0503": "The client consent record is not available. Contact your ADP representative.",
  "0429": "Too many Requests. Please try again in a few minutes.",
  "0400": "The API has returned a permissions or authentication error. Check your connection settings",
  "6004": "One or more formulas contains invalid references. Please verify the formulas (More > Chart Settings > Fields & Formulas) for accuracy, or contact customer support if this issue persists.",
  "6000": "Connector not compatible with selected file type.",
  "General": "General",
  "Fields & Formulas": "Fields & Formulas",
  "Import Filters": "Import filters",
  "filterbuild": "Selected filters will be applied to next build",
  "nosavedfilter": "No saved filters found.",
  "nosavedhighlight": "No saved highlights found.",
  "Branch Security": "Branch Security",
  "Calculation": "Calculation",
  "Predefined": "Predefined",
  "Dynamic": "Dynamic",
  "Always Apply": "All boxes",
  "include": "Include",
  "exclude": "Exclude",
  "Include all": "Include all",
  "Exclude all": "Exclude all",
  "seed": "Seed (Limit to branch)",
  "NoValuesAdded": "No values. Click here to add.",
  "chartbuildertemplates": "Chart Builder Views",
  "buildcharton": "Build chart on",
  "Map": "Map",
  "CopyChartDBConfig": "Do you want to copy an existing chart configuration?",
  "Local": "Local",
  "Local (time)": "local",
  "Row Level Security": "Row level security",
  "bypasstemplatelist": "Bypass Template Whitelist",
  "bypasstemplatelistwarning": "Users with permission to edit views and box styles will be able to see and edit all Shared Views in the account.",
  "savescheduler": "You must save this chart before enabling the refresh scheduler.",
  "Launch File": "Launch file",
  "Company Name": "Company name",
  "Organization ID": "Organization ID",
  "Chart Management": "Chart management",
  "UI Profiles": "UI profiles",
  "UI Profile": "UI profile",
  "Authentication": "Authentication",
  "viewernochartserr": "No charts have been configured. Click Create New Chart to get started.",
  "No charts have been configured": "No charts have been configured",
  "endpoint": "Endpoint",
  "selectuser": "Input Service User",
  "selectpassword": "Input Service Password",
  "mymap": "My Map",
  "enterMyMap": "Input Mapping Field",
  "selectpersonid": "Input PersonID",
  "selectsupervisorid": "Input SupervisorID",
  "Refreshing": "Refreshing",
  "UpdatingSC": "Updating subchart names",
  "uiprofile": "Profile name",
  "selectuiprofile": "Input UI profile",
  "copyuiprofile": "Copy UI profile",
  "newnameuiprofile": "Rename UI profile",
  "createuiprofile": "New UI profile",
  "showFilenames": "Show filenames",
  "adpoid": "ADP OID",
  "selectadpoid": "Input ADP OID",
  "nospaceuiprofile": "UI Profiles may not contain spaces",
  "Group Configuration": "Access group configuration",
  "User Information": "User Information",
  "Security Profile Configuration": "Security configuration",
  "companynamedd": "Enter company name: ",
  "Grid": "Grid",
  "Administration": "Administration",
  "launchto": "Launch To",
  "viewernotset": "Not Set",
  "generalchartbuilder": "General Chart Builder Settings",
  "defaultchartlevels": "Default Chart Levels",
  "uploadfailmultiplefiles": "Upload Failed: Cannot upload multiple files. Please upload one file at a time.",
  "viewerdatafilters": "Import filters",
  "invalidaccountdate": "Invalid date format. Please use date format 'yyyy-mm-dd'",
  "Formatting": "Formatting",
  "nofieldvalues": "No values associated with field",
  "Description": "Description",
  "No chart description": "No chart description",
  "Chart description": "Chart description",
  "rowsecallowedfields": "Only these fields can be seen.",
  "rowsecallowedfieldsimplicit": "All unrestricted fields can be seen.",
  "rowsecrestrictedfields": "None of these fields can be seen.",
  "Definitions": "Definitions",
  "clicktoadd": "Click (+) to add",
  "Not Equal": "Not equal",
  "Not In": "Not in",
  "Equal": "Equal",
  "In": "In",
  "Conditional rule": "Conditional rule",
  "Conditions": "Conditions",
  "Rule criteria": "Rule criteria",
  "Field value criteria": "Field value criteria",
  "Allowed fields": "Allowed fields",
  "SecurityRules": "Security rules",
  "Rule Configuration": "Rule configuration:",
  "Security Profile": "security profile",
  "Details": "Details",
  "Enterit": "Enter a ",
  "Rule": "Rule",
  "FieldValue": "Field value",
  "Criteria": "Criteria",
  "AddNew": "Add New ",
  "Condition": "Condition",
  "Self": "Self",
  "Allow View": "Allow view",
  "Current": "Current",
  "Records": "Records",
  "highlightcolor": "Highlight color",
  "dataresetinprogress": "Resetting data",
  "Loading Plan": "Loading plan",
  "Building Plan": "Building plan",
  "dataresetconfirm": "Are you sure you want to reset chart data? Any changes made prior to this checkpoint will be lost.",
  "savingaccountsettings": "Saving account settings",
  "Role Assignment": "Role assignment",
  "Role": "Role",
  "Private Folder Access": "Private folder access",
  "securityoverride": "Bypass data driven group assignment",
  "overrideMFA": "Override Multi-Factor Authorization",
  "mfaAuthenticator": "Authenticator active",
  "reqMFAWarning": "All your users have MFA enabled and will continue to be able to sign in after you require MFA. Click yes to require future users to set-up MFA.",
  "mfaStatus": "MFA status",
  "Not Configured": "Not Configured",
  "Configured": "Configured",
  "Valid Email Address Required": "Valid email address required",
  "Required & Not Configured": "Required & Not Configured",
  "Enabled": "Enabled",
  "QRCodeGen": "Authenticator QR Code successfully generated.",
  "mfaSetting": "MFA setting",
  "mfaNotRequired": "Disabling required MFA will allow users to access your organization without needing to enable and use a MFA method. Users with MFA already enabled will continue to utilize it, although they will now be allowed to disable it. Are you sure you want to proceed?",
  "step1": "Step 1",
  "mfaStep1Short": "Download the App",
  "mfaStep1LongPre": "Download and install an authenticator app to your phone or tablet. Supported apps include",
  "step2": "Step 2",
  "mfaStep2Short": "Scan this Barcode",
  "mfaStep2Long": "Open the authentication app, and then tap the '+' icon. Scan the image to the right, using your device’s camera.",
  "step3": "Step 3",
  "mfaStep3Long": "Once the QR Code above is scanned, enter the 6-digit verfication code generated by the app.",
  "mfaConfirmCode": "Enter Confirmation Code",
  "mfaAdminPreReq": "You must configure MFA for your user before you can require MFA login for your account. Click Configure to setup MFA now.",
  "resetAuth": "Reset Authenticator",
  "mfaVerify": "Verify Code and Activate",
  "Code": "Code",
  "mfaValidateFirst": "MFA will not be enabled until validated. 1. Please download an authenticator application if you haven't already. 2. Scan QR Code. 3. Confirm QR Code.",
  "disableMFAWarning": "You have successfully disabled MFA.",
  "validCode": "You have successfully enabled MFA.",
  "invalidCode": "Invalid Confirmation Code.",
  "mfaRequired": "Multi-Factor Authorization is Required to Login",
  "mfaInactivePost": "users have not configured MFA and will not be able to sign in. Do you want to require Multi-Factor Authorization, anyways?",
  "Chart Access": "Chart Access",
  "Importfiltereditor": "Import Filter Editor",
  "Filtered Managers": "Filtered Managers",
  "Filter values": "Filter values",
  "Seed Value": "Seed Value",
  "Background": "Background",
  "Custom Colors": "Custom colors",
  "UI Colors": "UI Colors",
  "Time Formats": "Time Formats",
  "Date Format": "Date Format",
  "clocktime": "24 hour clock",
  "fontstyle": "Font Styles",
  "customfonts": "Custom Fonts",
  "uifont": "UI Font",
  "scarrowstyles": "Subchart arrow style",
  "renameuiprofile": "Enter Name of UI Profile",
  "DecimalPlaces": "Decimal places",
  "breakcharacter": "Break Character",
  "configerror": "CONFIGURATION ERROR",
  "configerrormsg": "One or more fields is improperly defined for this chart. Please use the mapping section to set them appropriately.",
  "docMappingChanged": "The file you selected may have a different mapping. Select Save & Continue to save your current changes and to configure mapping.",
  "reqFieldNotMapped": "Please map required field.",
  "reqFieldsNotMapped": "Unable to refresh until all required fields are mapped.",
  "Point In Time": "Point In Time",
  "Point in time": "Point in time",
  "Main Data Source": "Main data source",
  "Data Source": "Data Source",
  "Data sources": "Data sources",
  "Append data sources": "Append data sources",
  "Merge data sources": "Merge data sources",
  "Include Active on Leave": "Include Active on Leave",
  "Additional fields": "Additional fields",
  "Custom fields": "Custom fields",
  "Fields shown": "Fields shown",
  "rowsecnocharts": "No charts have been loaded. Add a chart to begin configuring security rules.",
  "nosubchartupdate": "Subchart panel will not be updated until a refresh is made.",
  "Formula name cannot contain a period": "Formula name cannot contain a period.",
  "formulaerrnoname": "Formula name is required.",
  "formulaerrdupname": "Name already exists.",
  "formulaerrnooperations": "Add at least one operation.",
  "formulaerrnorule": "Rule definition is required.",
  "This field is required": "This field is required.",
  "Both fields are required": "Both fields are required.",
  "Add at least one value to the operation": "Add at least one value to the operation.",
  "There are required fields missing": "There are required fields missing.",
  "Minimum group size": "Minimum group size",
  "Allow groups with managers": "Allow groups with managers",
  "Co-manager": "Co-manager",
  "Manager group box style": "Manager group box style",
  "Apply Box Style To Members": "Apply Box Style To Members",
  "Try to pull records from Parking": "Try to pull records from Parking",
  "Operations": "Operations",
  "Operation": "Operation",
  "Values": "Values",
  "Complex Math": "Complex Math",
  "Basic Math": "Basic Math",
  "Concatenate": "Concatenate",
  "Static Formula Editor": "Static Formula Editor",
  "Loading": "Loading",
  "Split": "Split",
  "Load": "Load",
  "expiredSession": "Session expired. Please try to sign-in again.",
  "Set Font Color": "Set font color",
  "Set Fill Color": "Set fill color",
  "Set Text Style": "Set text style",
  "Hide Field": "Hide field",
  "Linked Template": "Linked view",
  "Link Template": "Link view",
  "Container Box Style": "Container box style",
  "Clear Existing Groups": "Clear existing groups",
  "Groups": "Groups",
  "Box Shape": "Box shape",
  "Box Color": "Box color",
  "Border Style": "Border style",
  "Border Color": "Border color",
  "Border Weight": "Border weight",
  "Connecting Line Style": "Connecting line style",
  "Connecting Line Color": "Connecting line color",
  "Box Flag": "Box flag",
  "Existing Chart": "Existing chart",
  "Input": "Input",
  "uiprofiles": "UI profiles",
  "checkpoint": "checkpoint",
  "Select value": "Select value",
  "createcheck": "Select 'New' to create a checkpoint.",
  "Scheduled By": "Scheduled By",
  "Container": "Container",
  "Limit to single row": "Limit to single row",
  "Fields Included": "Fields included",
  "Included fields": "Included fields",
  "Excluded fields": "Excluded fields",
  "Fields that can be chosen for Excel export": "Fields that can be chosen for Excel export",
  "Fields that cannot be chosen for Excel export": "Fields that cannot be chosen for Excel export",
  "Choose which fields to include in the order in which they will appear. Drag fields from one column to the other.": "Choose which fields to include in the order in which they will appear. Drag fields from one column to the other.",
  "Fields allowed for Excel export": "Fields allowed for Excel export",
  "By default, users can choose any fields permitted by their security overlay to export to excel. This feature allows you to optionally customize the list of fields your users will have access to downloading in their excel file": "By default, users can choose any fields permitted by their security overlay to export to excel. This feature allows you to optionally customize the list of fields your users will have access to downloading in their excel file",
  "Layout Type": "Layout Type",
  "noheaders": "You must import data once before adding Auxiliary Supervisors.",
  "Home": "Home",
  "Format": "Format",
  "Box Sorting": "Box sorting",
  "Header": "Header",
  "Footer": "Footer",
  "Fast Select": "Fast select",
  "Find": "Find",
  "Show Username": "Show username",
  "month": "Month",
  "Months": "Months",
  "Monthly": "Monthly",
  "year": "Year",
  "Years": "Years",
  "Date Bracket": "Date bracket",
  "fotm": "1st of the Month",
  "motm": "15th of the Month",
  "eotm": "Last of the Month",
  "AuxSuperID": "Aux Supervisor ID",
  "allgroups": "All grouped boxes",
  "boxingroup": "All boxes in this group",
  "unitID": "Org Unit ID",
  "parentUnitID": "Parent Org Unit ID",
  "orgChiefID": "Org Unit Chief ID",
  "chiefID": "Position Chief ID",
  "PersonUnitID": "Position Org Unit ID",
  "occcode": "Position Code",
  "occtext": "Position Title",
  "occcount": "Position Count",
  "allowallfolders": "Click (+) to allow folder access.",
  "Search & Directory": "Search & Directory",
  "Excel Settings": "Excel settings",
  "ssofail": "Single-Sign on failed. Click here for more information",
  "topbox": "Top box",
  "Enable Administrator User Impersonation": "Enable administrator user impersonation",
  "Planning": "Planning",
  "Activity Log": "Activity Log",
  "Dashboard": "Dashboard",
  "piechartprops": "Pie Chart Editor",
  "enumeratedtableprops": "Enumerated Table Editor",
  "headerssaveconfirm": "You are about to modify the data source for the selected chart.",
  "refreshsaveconfirm": "You are about to perform a data refresh.",
  "importsaveconfirm": "You are about to import new data.",
  "saveandcontinue": "Save changes and continue?",
  "loadheadersfailure": "One or more issues were detected with the data source field mapping. Click Configure Mapping to resolve.",
  "Plan": "Plan",
  "Plan On": "Plan on",
  "New plan": "New plan",
  "Open Plan": "Open plan",
  "Save Plan": "Save plan",
  "Delete Plan": "Delete plan",
  "Lock Plan": "Lock plan",
  "Unlock Plan": "Unlock plan",
  "Edit Plan": "Edit plan",
  "Share Plan": "Share plan",
  "Enter Plan Name": "Enter plan name",
  "Plan Name": "Plan name",
  "Created": "Created",
  "Date Modified": "Date modified",
  "Status": "Status",
  "people": "people",
  "person": "person",
  "(No people)": "(No people)",
  "Rename Plan": "Rename plan",
  "Rename profile": "Rename profile",
  "Change Topbox": "Change topbox",
  "Change Levels": "Change levels",
  "Compare Plans": "Compare plans",
  "Duplicate Plan": "Duplicate plan",
  "Archive Plan": "Archive plan",
  "Restore plan": "Restore plan",
  "Locking plan": "Locking plan",
  "Unlocking plan": "Unlocking plan",
  "Deleting plan": "Deleting plan",
  "Duplicating plan": "Duplicating plan",
  "Archiving plan": "Archiving plan",
  "Renaming plan": "Renaming plan",
  "Plan Status": "Plan status",
  "Sharing & Collaboration": "Sharing & Collaboration",
  "Share to collaborate": "Give other users collaborative or view only access to this plan",
  "Select a user to share with": "Select a user to share with",
  "Editable Fields": "Editable fields",
  "Fields available": "Fields that appear here become available for editing in your plan",
  "Manage Editable Fields": "Manage editable fields",
  "Fields editable in plan": "Fields below are editable in your plan",
  "Default Fields": "Default fields",
  "Metrics": "Metrics",
  "Metrics & Data Visualization": "Metrics & Data Visualization",
  "Syncing Plan": "Syncing plan",
  "Last Synchronized": "Last synchronized",
  "Last Sync": "Last sync",
  "Last Modified": "Last modified",
  "Team members": "Team members",
  "Plan Metrics": "Plan metrics",
  "Metric": "Metric",
  "Share with others": "Share with others",
  "Manage access": "Manage access",
  "Active": "Active",
  "Paused": "Paused",
  "Inactive": "Inactive",
  "Away": "Away",
  "Online": "Online",
  "Offline": "Offline",
  "NoSharedUsers": "You are not sharing this plan. Click here to start sharing.",
  "NoMetrics": "Click here to add a metric.",
  "Private": "Private",
  "Active Plans": "Active plans",
  "Archived Plans": "Archived plans",
  "Shared Plans": "Shared plans",
  "No Plans Alert": "Click here to create your first plan.",
  "Private Plan": "Private plan",
  "Plan Explorer": "Plan explorer",
  "Plan Builder": "Plan builder",
  "SystemError": "Failed to complete transaction: ",
  "SystemError2": " Try reloading the page, or contact support if this issue persists.",
  "Error": "Error",
  "Unable to Save Changes": "Unable to save changes",
  "This field is read-only and cannot be edited": "This field is read-only and cannot be edited",
  "Target": "Target",
  "Change": "Change",
  "Total Changes": "Total changes",
  "Edits": "Edits",
  "Moves": "Moves",
  "Deletes": "Deletes",
  "Adds": "Adds",
  "Target Field": "Target field",
  "Target Value": "Target value",
  "Add Metric": "Add metric",
  "Distance To Target": "Distance To Target",
  "stageNew": "No records staged. Search to add new records.",
  "Starting": "Starting",
  "Edit Box": "Edit box",
  "Edit Record": "Edit record",
  "Edit employee record": "Edit employee record",
  "Comment": "Comment",
  "Comments": "Comments",
  "Talent Pool": "Talent pool",
  "Select a user to start sharing": "Select a user to start sharing",
  "viewer": "Viewer",
  "collaborator": "Collaborator",
  "owner": "Owner",
  "Archived": "Archived",
  "NoPlansExist": "No plans have been created yet. Click here or Select New Plan to get started.",
  "Plan Name cannot be left blank": "Plan Name cannot be left blank",
  "Change History": "Change History",
  "Manage metrics": "Manage metrics",
  "Maximum number of metrics reached alert": "You can track up to {MAX_METRICS} {metrics} at a time. To add a new metric, you will need to remove an existing one.",
  "formulas": "formulas",
  "No more formulas available to add alert": "You do not have any formulas available to track. Admins can create formulas in {chartSettingsFieldsFormulasPath}.",
  "No metrics available to add": "No metrics are available to add.",
  "Remove a metric to add a new one":"Remove a metric to add a new one.",
  "Add metrics info": "Add metrics to set plan targets and track changes.",
  "Add metric": "Add metric",
  "chartSettingsFieldsFormulasPath": "Chart Settings: Fields & Formulas",
  "Show Overlay": "Show overlay",
  "Additional Tables": "Additional tables",
  "grayscale": "Grayscale",
  "Uniform Scaling": "Uniform scaling",
  "Ensure all boxes on each page are identically sized. This generally means boxes will be smaller than usual to accomodate large pages": "Ensure all boxes on each page are identically sized. This generally means boxes will be smaller than usual to accomodate large pages",
  "Index Page": "Index page",
  "Include a page at the end of the export with name and number": "Include a page at the end of the export with each employee’s name and corresponding page number",
  "Hover Profile": "Hover profile",
  "Validation Alert": "Validation alert",
  "No formulas have been created": "No formulas have been created. Go to Chart Settings > Fields & Formulas to Add Formulas",
  "alldivisions": "All Divisions",
  "Subcharts & Shortcuts": "Subcharts & Shortcuts",
  "Shortcut Field": "Shortcut field",
  "Inverted": "Inverted",
  "History": "History",
  "Summary": "Summary",
  "Phases": "Phases",
  "by": "by",
  "Expand": "Expand",
  "Collapse": "Collapse",
  "All plans are shared with you": "All plans are shared with you",
  "No archives have been created": "No archives have been created",
  "Timeline": "Timeline",
  "Included Headers": "Included Headers",
  "Chart Builder & Publisher Subchart Breaks": "Chart Builder & Publisher Subchart Breaks",
  "Effective Dates": "Effective Dates",
  "Effective date": "Effective date",
  "Effective Dating": "Effective Dating",
  "Master Charts": "Master Charts",
  "Chart Documents": "Chart Documents",
  "Chart Document": "Chart Document",
  "Documents": "Documents",
  "Auto Format": "Auto-Format",
  "Activity": "Activity",
  "Show Activity": "Show activity",
  "Configure dedicated API photo connectors.": "Configure dedicated API photo connectors.",
  "Conflict Detected": "This plan has changes that differ from your updated source data.",
  "Employee Removed": "Record no longer exists in Source Data. Revert the change to resolve the conflict.",
  "Choose Source": "Choose to keep the changes you made in your plan, or use the new values in the updated source data.",
  "Use Plan": "Use Plan",
  "Use Source": "Use Source",
  "Conflicted record":"Conflicted record",
  "Revert": "Revert",
  "Rule comparison": "Rule comparison",
  "Value comparison": "Value comparison",
  "No rule conditions": "No rule conditions. Click here to add.",
  "neqdesc": "Conditional fields are hidden if a record's value does not equal the field value criteria.",
  "indesc": "Conditional fields are hidden if a record's value matches any field value criteria.",
  "nindesc": "Conditional fields are hidden if a record's value does not match any field value criteria.",
  "eqdesc": "Conditional fields are hidden if a record's value equals the field value criteria.",
  "confirmAddDelegated": "A user with this email address already exists in another organization. Do you want to grant them access to your organization?",
  "Delegated": "Delegated",
  "Archive Cleanup": "Archive clean-up",
  "Older Than": "Delete archives older than",
  "Symbols": "Symbols",
  "Branch Level Security": "Branch level security",
  "Branch Level": "Branch level",
  "formulareservedname": " is a reserved name.",
  "formulareservedname2": "Please enter a unique field name.",
  "Reserved Field Name": "Reserved Field Name",
  "Card": "Card",
  "Update existing record": "Update existing record",
  "Append Remove Duplicates": "Duplicate entries were found. Do you want to consolidate your entries? Note: This action is not reversible.",
  "Append Table": "Append Table",
  "Append Tables": "Append Tables",
  "No Tables Exist": "No tables exist. Click here to manage all tables.",
  "Manage Tables": "Manage tables",
  "Create Table" : "Create table",
  "Active append table": "Active append table",
  "Configure Data Source": "Configure Data Source",
  "Append Plan": "Append Plan",
  "Suppress": "Suppress",
  "About Append Tables": "Append Tables allow you to change values from your source data.",
  "Append Entry Help": "Add, Update, Move, and Suppress Records in your chart.",
  "New Table": "Click here to create a table.",
  "No Append Entries": "No append entries have been created. Use the buttons on the left to create your first entry.",
  "Find Record": "Find Record",
  "Find record to add to talent pool…": "Find record to add to talent pool…",
  "Delete Confirm Append Entry": "Are you sure you want to remove selected append entry? (Changes will take effect next chart refresh).",
  "tabledeleteconfirm": "WARNING: All charts using this table as an Append Source will no longer include append data associated with this table (Changes will reflect next data refresh). Are you sure you want to permanently delete this table? This action cannot be undone.",
  "Revert To Source": "Revert To Source",
  "Source Data": "Source Data",
  "Automated Chart Export": "Automated chart export",
  "Also Reports To": "Also reports to",
  "Authorization": "Authorization",
  "Link User Configuration": "Link user configuration",
  "Auto-Assignment Configuration": "Auto-assignment configuration",
  "Automatically assign users to access group upon login": "Automatically assign users to access group upon login",
  "Master chart used to validate user": "Master chart used to validate user",
  "Data field used for assignment": "Data field used for group assignment",
  "Use data field for Row Level Security assignment": "Use data field for Row Level Security assignment",
  "Set which groups line up with values in your data": "Set which groups line up with values in your data",
  "Use default group instead of denying access": "Use default group instead of denying access",
  "generateSPMetadata": "SAML SP Metadata",
  "Bounded": "Bounded",
  "Left Bound": "Before",
  "Right Bound": "After",
  "Bounds": "Bounds",
  "Allow public access": "Allowing public access will allow anyone on the internet with a link with this user to access OCN. Are you sure you want to proceed?",
  "Configure whitelist domains for restricted link access": "Configure whitelist domains for restricted link access",
  "Allow Public Access": "Allow Public Access",
  "Allowed Referrer Domains": "Allowed referrer domains",
  "Configure Link Access": "Configure link access",
  "Table Manager": "Table Manager",
  "Select UI Profile": "Select UI Profile",
  "All fields are exported by default": "All fields are exported by default.",
  "Export Options": "Export Options",
  "Image Settings": "Image Settings",
  "Use Presentation": "Use Presentation",
  "Document Settings": "Document Settings",
  "Background Settings": "Background Settings",
  "No activity yet": "No activity yet.",
  "Show Details": "Show Details",
  "Add to plan": "Add to plan",
  "Move within plan": "Move within plan",
  "Remove from pool": "Remove from pool",
  "About Plan": "About plan",
  "Basic info": "Basic info",
  "Additional info": "Additional info",
  "New Record": "New Record",
  "Remove Field": "Remove Field",
  "navtocell": "Show Table",
  "addmanualsub": "Add Subordinate",
  "deletemanualbox": "Delete Box",
  "Overwrite": "Overwrite",
  "Overwrite Existing Data": "Overwrite Existing Data",
  "Confirm Overwrite Manual Data Source": "PROCEED WITH CAUTION! Changing your data source file will overwrite any existing data including all manual edits. Are you sure you want to overwrite your source data?",
  "Please Correct": "Please Correct",
  "Return to Chart": "Return to Chart",
  "confirmexit": "Are you sure you want to exit",
  "Chart Editor": "Chart Editor",
  "Are you sure you want to": "Are you sure you want to",
  "Close Plan Builder": "Close Plan Builder",
  "Add Branch": "Add Branch",
  "Filtering": "Filtering",
  "Prebuilt Filters": "Prebuilt Filters",
  "No filter applied": "No filter applied",
  "Interactive": "Interactive",
  "Saved": "Saved",
  "My filters": "My filters",
  "My highlights": "My highlights",
  "Legacy": "Legacy",
  "Share filter": "Share filter",
  "Share highlight": "Share highlight",
  "Copy filter": "Copy filter",
  "Copy to My filters": "Copy to My filters",
  "Copy highlight": "Copy highlight",
  "Copy to My highlights": "Copy to My highlights",
  "Filter details": "Filter details",
  "Highlight details": "Highlight details",
  "Back to filters": "Back to filters",
  "Back to highlights": "Back to highlights",
  "copy": "copy",
  "shared": "shared",
  "No shared filters yet": "No filters have been shared with you yet.",
  "No filters created yet": "No filters created yet.",
  "No shared highlights yet": "No highlights have been shared with you yet.",
  "This user cannot be a collaborator because of their read-only role": "This user cannot be a collaborator because of their read-only role",
  "A shared filter with this name already exists": "A shared filter with this name already exists on this chart.",
  "A shared highlight with this name already exists": "A shared highlight with this name already exists on this chart.",
  "Share filter info text": "When a filter is shared, only the owner can manage the shared access and delete the filter.",
  "Share highlight info text": "When a highlight is shared, only the owner can manage the shared access and delete the highlight.",
  "Share this entity with": "Share this {entity} with:",
  "Entity details": "{entity} details",
  "Update sharing": "Update sharing",
  "Entity sharing access saved": "{entity} sharing access saved.",
  "Failed to share": "Failed to share",
  "Shared filter banner": "This is a shared filter and any changes will apply to users who have access to it.",
  "Shared highlight banner": "This is a shared highlight and any changes will apply to users who have access to it.",
  "Delete shared filter?": "Delete shared filter?",
  "Delete shared highlight?": "Delete shared highlight?",
  "Delete shared filter confirm": "Deleting this shared filter will remove it for all users it has been shared with.",
  "Delete shared highlight confirm": "Deleting this shared highlight will remove it for all users it has been shared with.",
  "Delete highlight": "Delete highlight",
  "Delete filter confirm": "Deleting this filter will remove it from your filter list.",
  "Delete highlight confirm": "Deleting this highlight will remove it from your highlight list.",
  "Shared filter copied": "{entity} copied to 'My filters'.",
  "Shared highlight copied": "{entity} copied to 'My highlights'.",
  "Entity copy created": "{entity} copied.",
  "Entity filter created": "{entity} filter created.",
  "Entity highlight created": "{entity} highlight created.",
  "Entity group created": "{entity} group created.",
  "View rule saved": "View rule saved.",
  "Chart scope changes saved": "Chart scope changes saved.",
  "Entity rule renamed": "{entity} renamed.",
  "Do you want to resume planning in your last open plan?": "Do you want to resume planning in your last open plan?",
  "Do you want to resume work in your last open report?": "Do you want to resume work in your last open report?",
  "View successfully imported. Be sure to save the changes to your shared views and box styles libraries.": "View successfully imported. Be sure to save the changes to your shared views and box styles libraries.",
  "Hit the paste shortcut on your keyboard to import templates": "Hit the paste shortcut on your keyboard to import views",
  "Error importing views message": "Error importing views. Please ensure you use the 'export views' button in another OCN account and hit the paste button on this screen.",
  "publicinfotext": "Public links are accessible to anyone on the internet with a link tied to this user.",
  "privateinfotext": "Private links allow you to build customized entry points into your chart while still requiring authentication (SSO or direct login).",
  "restrictedinfotext": "Restricted links are secured, accessible only from site(s) that you specify.",
  "Launch Configuration": "Launch Configuration",
  "linnkuserconfigwarning": "No users have been configured for this link type. Go to More -> Account Settings -> Authorization to configure users for links. Click the ? button for more details. ",
  "User Record Retrieval": "User record retrieval",
  "Configure the fields used to identify a chart record that corresponds with a user.": "Configure the fields used to identify a chart record that corresponds with a user.",
  "Filter Options": "Filter Options",
  "Enable Report Issue": "Enable Report Issue",
  "Enable Workbench": "Enable Workbench",
  "Use Value from current User Record": "Use Value from current User Record",
  "User Value": "User Value",
  "Dynamic Value": "Dynamic Value",
  "Static Value": "Static Value",
  "Mode": "Mode",
  "Click Setup Chart to get started": "Click Setup Chart to get started",
  "Get Started": "Get Started",
  "Buy Now": "Buy Now",
  "Switch To Field Level": "Switch To Field Level",
  "Switch To Branch Level": "Switch To Branch Level",
  "supportdeskhelp": "If the problem persists, you can reach out to our ",
  "supportdeskhelp2": "support desk",
  "genericSupportDeskHelp": "If the problem persists, you can reach out to your support or service team.",
  "Do you want to roll up the subordinates from other pages": "Do you want to roll up the subordinates from other pages",
  "Please wait": "Please wait",
  "Save Alert": "Save your changes?",
  "Launch to Self": "Launch to Self",
  "Refresh chart now": "Refresh chart now",
  "Planning Access Denied": "Planning Access Denied",
  "Permission denied to access Planning module. Ensure your role and organization have access to Planning": "Permission denied to access Planning module. Ensure your role and organization have access to Planning.",
  "Contact your system administrator if this issue persists": "Contact your system administrator if this issue persists.",
  "Confirm Delete Plan": "Are you sure you want to permanently delete this plan? This action cannot be undone.",
  "Exit Plan Builder": "Exit Plan Builder",
  "leave the Plan Builder": "leave the Plan Builder",
  "Stay": "Stay",
  "Continue Working": "Continue Working",
  "Continue Planning": "Continue Planning",
  "Exit Builder": "Exit Builder",
  "and return to your chart": "and return to your chart?",
  "Resume last open plan": "Resume last open plan?",
  "Open Last Plan": "Open Last Plan",
  "Open Plan Explorer": "Open Plan Explorer",
  "See Plans": "See Plans",
  "Plan Needs Sync": "Plan Needs Sync",
  "Plan Needs Updates": "This plan has been synced since you last opened it. Confirm to get the latest updates.",
  "Plan Updates Available": "Plan Updates Available",
  "Sync plan": "Sync plan",
  "Locked plans cannot be synced with base chart data": "Locked plans cannot be synced with base chart data",
  "Archived plans cannot be synced with base chart data": "Archived plans cannot be synced with base chart data",
  "Cannot sync with unsaved background changes": "Cannot sync with unsaved background changes",
  "Sync Now": "Sync Now",
  "Revert Change": "Revert Change?",
  "Revert changes":"Revert changes",
  "Revert Confirm": "Are you sure you want to revert this change?",
  "Revert All Changes": "Revert all changes?",
  "Revert All Confirm": "Are you sure you want to revert all changes associated with this entry?",
  "darkmode": "Dark Mode",
  "lightmode": "Light Mode",
  "saveconfirm3": "Any unsaved changes will be lost.",
  "Save Changes": "Save Changes",
  "Discard Changes": "Discard Changes",
  "Privacy Policy": "Privacy Policy",
  "Create a Workbench document": "Create a Workbench document",
  "Load Headers": "Load headers",
  "Advanced Search": "Advanced search",
  "Agent View": "Agent View",
  "Standard Search": "Standard search",
  "Search Name or Title": "Search name or title",
  "Last Login": "Last login",
  "Shadow": "Shadow",
  "Unable to locate target box!": "Unable to locate target box!",
  "Move Out": "Move out",
  "Group Assigned": "Group assigned",
  "Master Chart Settings": "Master chart settings",
  "Box Sort": "Box sort",
  "Box Spacing": "Box spacing",
  "Align Chart Top": "Align top",
  "Center Chart Horizontal": "Center horiz",
  "Center Chart Vertical": "Center vert",
  "Line Color": "Line color",
  "Line Thickness": "Line thick",
  "Font Selector": "Font selector",
  "Font Size": "Font size",
  "Font Color": "Font color",
  "Cell Fill": "Cell fill",
  "Bold": "Bold",
  "Italic": "Italic",
  "Underline": "Underline",
  "Label Options": "Label options",
  "Pie Chart": "Pie chart",
  "Justify": "Justify",
  "Wrap Text": "Wrap text",
  "Saved highlights": "Saved highlights",
  "Master Editor": "Background editor",
  "Chart Templates": "Chart views",
  "App Settings": "App settings",
  "Confirm New Password": "Confirm new password",
  "Password reset successfully. Be sure to update your password manager, if you use one.": "Password reset successfully. Be sure to update your password manager, if you use one.",
  "Staging": "Staging",
  "Invalid photo credentials": "Invalid photo credentials",
  "ConfigureSharePoint": "SharePoint credentials configuration",
  "Sharepoint Domain": "SharePoint Domain",
  "NoSharepointConfig": "Incomplete or no SharePoint credentials configured. Click here to configure.",
  "Delete Sharepoint": "Delete Sharepoint",
  "DeleteSharepointConfig": "Are you sure you want to permanently delete your Sharepoint configuration? This action cannot be undone.",
  "incompletesharepointcreds": "Please finish the automated Sharepoint setup by saving your Sharepoint credentials inside the Account Settings Panel > Authorization.",
  "SharePoint": "SharePoint",
  "Test Connection": "Test Connection",
  "sharepoint_test_in_progress": "Testing…",
  "sharepoint_test_ok": "Connection successful",
  "sharepoint_test_auth_failed": "Authentication failed — check Tenant ID, Client ID, and Client Secret",
  "sharepoint_test_folder_failed": "Connected, but the 'Shared Documents' library is not accessible",
  "sharepoint_test_unreachable": "Unable to reach SharePoint — check Domain and network",
  "sharepoint_test_unknown": "Connection test failed",
  "Metadata Type": "Metadata type",
  "Custom SLO Endpoint": "Custom SLO Endpoint",
  "NameID Handling": "NameID handling",
  "main SAML assertion": "main SAML assertion",
  "SAML attributes": "SAML attributes",
  "Metadata Location": "Metadata location",
  "SSO Enabled": "SSO enabled",
  "SSO Deletion": "SSO deletion",
  "SSO Deletion Warning": "You are about to delete this SSO configuration. Please confirm that you want to proceed.",
  "SSO Save Warning": "This will leave the organization with no active SSO sign-in. Please confirm that you want to proceed.",
  "Direct Sign-In": "Direct sign-in",
  "Custom Sign-Out URL": "Sign out to site instead of returning to login page",
  "ssoenableinfotext": "Enable/Disable users from signing on through configured IDP.",
  "ssodisableinfotext": "SSO can NOT be disabled while direct sign in is disabled.",
  "ssodirectinfotext": "Enable/Disable users from signing on directly.",
  "ssoautoproinfotext": "Automatically create new users if they do not already exist.",
  "sloinfotext": "Automatically sign users out of IDP in addition to application sign-out.",
  "Sharepoint Configuration": "Sharepoint configuration",
  "SSO Configuration": "SSO configuration",
  "Delete SSO Configuration": "Delete SSO configuration",
  "Confirm delete SSO configuration": "Confirm delete SSO configuration",
  "SSO Entity ID": "SSO entity ID",
  "SSO Metadata Type": "SSO metadata type",
  "SSO Metadata Location": "SSO metadata location",
  "Enable SSO": "Enable SSO",
  "Disable SSO": "Disable SSO",
  "Enable Direct Sign-In": "Enable Direct Sign-In",
  "Disable Direct Sign-In": "Disable Direct Sign-In",
  "New SSO Configuration": "Warning: Please check the SSO Enabled box to enable SSO sign-on.",
  "SSO Enabled Warning": "Are you sure you want to enable SSO? SSO will be activated for this entityID",
  "SSO Disabled Warning": "Are you sure you want to disable SSO? All users currently using sso will no longer be able to sign in using the IDP corresponding to entityID",
  "Sign-In Enabled Warning": "Are you sure you want to enable direct sign-in? Users will be able to sign-in outside of SSO.",
  "Sign-In Disabled Warning": "Are you sure you want to disable direct sign-in? Users will ONLY be able to sign-in with SSO. If MFA was previously required, then it will now be disabled.",
  "Auto Provision": "Auto provision",
  "Single Logout": "Single logout",
  "SAML Attributes Handling": "SAML attributes handling",
  "SAML Attribute From": "IDP security group",
  "SAML Attribute To": "Application security group",
  "SAML Group Attribute": "SAML group attribute",
  "SAML Name Attribute": "SAML name attribute",
  "SAML NameID Attribute": "SAML nameID attribute",
  "SAML Email Attribute": "SAML email attribute",
  "enterAttributeGroup": "Enter SAML attribute for group",
  "enterAttributeName": "Enter SAML attribute for name",
  "enterAttributeNameID": "Enter SAML attribute for nameID",
  "enterAttributeEmail": "Enter SAML attribute for email",
  "No Shortcuts Found": "No shortcuts found",
  "SAML Invalid Mapping": "Invalid or missing values in SAML Group Attribute.",
  "Duplicate EntityID": "Unable to save SSO configuration. Confirm the entity ID is correct, and contact support if the issue persists",
  "Invalid SSO Metadata": "Unable to save SSO configuration. Check the metadata type and location.",
  "Remote": "Remote",
  "Localization": "Localization",
  "Show different fields depending on user language.": "Show different fields depending on user language.",
  "Photo Source": "Photo Source",
  "Hierarchy": "Hierarchy",
  "Additional photo configuration": "Additional photo configuration",
  "Some sources require additional photo configuration in order to pull photos": "Some sources require additional photo configuration in order to pull photos",
  "Configure AzureAD Photos": "Configure AzureAD Photos",
  "Set your AzureAD credentials here to import Azure AD photos with your chart data.": "Set your AzureAD credentials here to import Azure AD photos with your chart data.",
  "Comm Preferences": "Comm Preferences",
  "Session Warning": "You are being timed out due to inactivity. Please choose to stay signed in or to log off. Otherwise, you will be logged off automatically.",
  "Stay Logged In": "Stay Logged In",
  "PDF Document": "PDF document",
  "Powerpoint document": "Powerpoint document",
  "PPT Document": "PPT Document",
  "Google Slides": "Google Slides",
  "PNG Image": "PNG image",
  "JPG Image": "JPG image",
  "SVG Image": "SVG image",
  "Excel Spreadsheet": "Excel spreadsheet",
  "Legacy Chart": "Legacy Chart",
  "Excel Data": "Excel Data",
  "Web Link": "Web link",
  "Missing Photos": "Missing Photos",
  "Compare Charts": "Compare Charts",
  "File Manager": "File manager",
  "Undo": "Undo",
  "Redo": "Redo",
  "Refresh document": "Refresh document",
  "File Name": "File name",
  "Switch Mode": "Switch Mode",
  "File Preview": "File Preview",
  "No File Selected": "No file selected",
  "AdvSecEnterperisePaywall": "Advanced security is an Enterprise-only feature. Contact your sales representative for more information.",
  "Delete Manager": "Delete manager",
  "What would you like to do with the subordinates of this manager?": "What would you like to do with the subordinates of this manager?",
  "Roll Up": "Roll up",
  "Move to Staging": "Move to Staging",
  "No records found outside the scope of the plan": "No records found outside the scope of the plan",
  "Launch Chart Builder": "Launch Chart Builder",
  "Open document": "Open document",
  "Create blank chart": "Create blank chart",
  "Recent documents": "Recent documents",
  "No Recent Documents": "No Recent Documents",
  "Appearance": "Appearance",
  "Alter the appearance the chart box layout.": "Alter the appearance of the chart box layout.",
  "Custom Background Color": "Custom Background Color",
  "Custom Accent Color": "Custom Accent Color",
  "Accent": "Accent",
  "Enter Hex Value": "Enter Hex Value",
  "Automatically sign users out of IDP in addition to application sign-out.": "Automatically sign users out of IDP in addition to application sign-out.",
  "Automatically create new users if they do not already exist": "Automatically create new users if they do not already exist",
  "Field in Record": "Field in record",
  "Invalid File Name": "Invalid file name",
  "Invalid name": "Invalid name. Cannot include",
  "A file name can't contain": "A file name can't contain the following characters: ",
  "Rename Subchart": "Rename Subchart",
  "Chart Setting Mismatch": "Warning! Chart being configured is different than current open chart. Editing is disabled.",
  "Rename Field": "Rename Field",
  "Save View Changes": "Would you like to save your current view before linking it to a Master Chart?",
  "Select a view to start editing": "Select a view to start editing",
  "System Vew Edit Prompt": "This is a System view and cannot be modified.",
  "Upload Image": "Upload Image",
  "Rename view": "Rename view",
  "Manage Views": "Manage Views",
  "Move View": "Move View",
  "Duplicate view": "Duplicate view",
  "Delete view": "Delete view",
  "Save View": "Save view",
  "New View": "New view",
  "Current Set": "Current Set",
  "No archives found for this chart.": "No archives found for this chart.",
  "View manager": "View manager",
  "BuilderNoMasterChartsNotAdmin": "The Chart Builder needs a Master Chart to quickly create charts. Contact your system administrator to configure your account.",
  "ViewerNoMasterChartsNotAdmin": "Could not load any chart data. Contact your system administrator to configure your account.",
  "New Mapping": "New Mapping",
  "unableOpenPlan": "Unable to open plan. Confirm the source chart data integrity and field mapping. ",
  "planNoChartAccess": "You need access to the source chart to view this plan. Contact your administrator to request access.",
  "Plan Access Denied": "Plan Access Denied",
  "Select the field to translate based on the end-user's language settings.": "Select the field to translate based on the end-user's language settings.",
  "Users": "Users",
  "restrictedfiletypeupload": "To upload this kind of file, go to Workbench → Document → File Manager",
  "Reload Directory": "Reload Directory",
  "Plan Options": "Plan Options",
  "Mute": "Mute",
  "Enable Automatic Archives to Begin Configuring Automated Delta Report Emails": "Enable Automatic Archives to Begin Configuring Automated Delta Report Emails",
  "Create an Archive to begin making use of Delta Reports": "Create an Archive to begin making use of Delta Reports",
  "Add Fields to Table": "Add fields to table",
  "Add field": "Add field",
  "Add value to field": "Add value to field",
  "Remove value from field": "Remove value from field",
  "Add field value to rule criteria": "Add field value to rule criteria",
  "Remove field value from rule criteria": "Remove field value from rule criteria",
  "Edit rule criteria": "Edit rule criteria",
  "Duplicate rule criteria": "Duplicate rule criteria",
  "Remove rule criteria": "Remove rule criteria",
  "All fields are shown in the Profile Tab by default": "All fields are shown in the Profile Tab by default.",
  "Filtered records will show with a filter overlay": "Filtered records will be shown with a filter overlay",
  "Filtered Records will be removed when possible": "Filtered Records will be removed when possible",
  "Filtered records other than managers will be removed from the chart when possible": "Filtered records other than managers will be removed from the chart when possible",
  "Field Mapping": "Field Mapping",
  "Unable to find topbox": "Unable to find topbox",
  "Select a new topbox": "Select a new topbox",
  "Click on a topbox from the list below": "Your filter criteria have removed all the boxes on screen. Click on a topbox from the list below to navigate to an unfiltered branch, or adjust your filter criteria",
  "Move With Manager": "Move with manager",
  "Move Manager": "Move manager",
  "Move Out Manager": "Move out manager",
  "Do you want to create a manual Archive for": "Do you want to create a manual Archive for",
  "No Snapshots found for this chart. Click here to configure automated snapshot generation.": "No snapshots found for this chart. Click here to configure automated snapshot generation.",
  "No Snapshots found for the above date range.": "No Snapshots found for the above date range.",
  "ExportIndexPage": "Download scope will be limited to 'Entire Chart' while publishing with Index Page",
  "Snapshot": "Snapshot",
  "This is a Point in Time chart generated": "This is a point in time chart generated",
  "Allow RW Users to Refresh Master Charts": "Allow RW Users to Refresh Base Charts",
  "Case Insensitive Match": "Case insensitive match",
  "Turn On": "Turn On",
  "Allow Photo Search": "Allow Photo Search",
  "System views cannot be modified": "System views cannot be modified",
  "Open a chart to begin editing View rules": "Open a chart to begin editing View rules",
  "Select Main Data Source": "Select Main Data Source",
  "Select Append Data Source": "Select Append Data Source",
  "Select Merge Data Source": "Select Merge Data Source",
  "Select Photo Data Source": "Select Photo Data Source",
  "Assign Data Source": "Select a data source to begin setup",
  "Load Mapping": "Load Mapping",
  "Create Field Map": "Create Field Map",
  "FieldAccessReminder": "Row Level Security applies to every Master Chart. The fields and values present in the pickers here are associated only with the currently open Master Chart. To add fields from another master chart, close this panel, select the master chart from the chart dropdown menu, and then re-open this interface.",
  "Maximum character limit reached": "Maximum character limit reached",
  "Character length cannot exceed": "Character length cannot exceed",
  "Max Char Limit Warning": "Max Char Limit Warning",
  "Unhandled Validation": "Unable to validate credentials in application. Please verify that the creds you have entered are correct. If validation continues to fail, please contact support if you wish to validate creds.",
  "No API Support": "We do not yet have a direct API connection with this system. Click here to contact us about setting up an integration.",
  "Find by username or email": "Find by username or email",
  "Notification Center": "Notification Center",
  "No Messages": "No Messages",
  "Blank Notification": "This message has no content.",
  "Blank Message": "Messages will be displayed here",
  "single unread": "unread message",
  "multiple unread": "unread messages",
  "Unread": "Unread",
  "Inbox": "Inbox",
  "Select a message to read": "Select a message to read",
  "Yesterday": "Yesterday",
  "No Content": "No content",
  "No Subject": "No Subject",
  "Older": "Older",
  "Default Group": "Default Group",
  "Set the group new users are created in by default.": "Set the group new users are created in by default.",
  "Filters and Highlights": "Filters & Highlights",
  "Position Management": "Position Management",
  "Synthesize positional data from employees": "Synthesize positional data from employees",
  "Map positions from source data": "Map positions from source data",
  "Positions": "Positions",
  "Holder": "Holder",
  "Employee": "Employee",
  "PositionID": "PositionID",
  "Parent PositionID": "Parent positionID",
  "Position Location": "Position location",
  "Employee PositionID": "Employee positionID",
  "EmployeeID": "EmployeeID",
  "Employee SupervisorID": "Employee supervisorID",
  "Employee Location": "Employee location",
  "Position Title": "Position title",
  "Position Division": "Position division",
  "Employee Title": "Employee title",
  "Position Budgeted Salary": "Position budgeted salary",
  "Position Cost Center":"Position cost center",
  "Position Cost Band Minimum":"Position cost band minimum",
  "Position Cost Band Midpoint":"Position cost band midpoint",
  "Position Cost Band Maximum":"Position cost band maximum",
  "Employee Salary":"Employee compensation",
  "Employee Pay":"Employee compensation YTD",
  "Employee Cost Center":"Employee cost center",
  "StaticFormula": "Static formula",
  "AggregatedField": "Aggregated Field",
  "This chart exceeds your total box limit": "This chart exceeds your total box limit",
  "Field Picker": "Field Picker",
  "Interactive Highlighting": "Interactive Highlighting",
  "My Highlights": "My Highlights",
  "Launch directory with all records": "Launch directory with all records",
  "Do not automatically format document layout": "Do not automatically format document layout",
  "No profiles defined": "No profiles defined",
  "Unread Force Read Messages": "You have important unread messages that you must select before leaving the notification center",
  "Background Editor": "Background Editor",
  "BackgroundEditorQuickLink": "Background Editor",
  "About BackgroundEditorQuickLink": "Create & customize your backgrounds",
  "About View Manager": "Configure your views and box layouts",
  "About Chart Settings": "Configure your API connection and data settings",
  "About Account Settings": "Manage your users and security settings",
  "About Background Editor": "Configure your Backgrounds",
  "Create New Background": "Create New Background",
  "Loading Background Editor": "Loading Background Editor",
  "Setting Up Background": "Setting Up Background",
  "Select background": "Select background",
  "Open In Editor": "Open In Editor",
  "Manual Chart": "Manual Chart",
  "Start From Scratch": "Start From Scratch",
  "Excel File": "Excel File",
  "Start From File": "Start From File",
  "I Have an Excel File": "I Have an Excel File",
  "I Use an HRIS System": "I Use an HR System",
  "Start From Connection": "Start From Connection",
  "HRIS Connection": "HRIS Connection",
  "Recommended": "Recommended",
  "API Connection": "API Connection",
  "Flat File": "Flat File",
  "Flat Files": "Flat Files",
  "About flatfile": "Use data from an Excel or CSV",
  "About manualchart": "Manually enter my data",
  "About API": "Sync data from my HR system",
  "Where is your data": "Where is your employee data",
  "Select Initial Import Method": "Where is the best place to get your org chart data?",
  "Welcome to OrgChart": "Welcome to OrgChart",
  "Welcome to OrgChart!": "Welcome to OrgChart!",
  "Welcome Message 2": "We'll need data to build your chart",
  "Please Select Field": "Please select a valid field",
  "enterorgsize": "Enter the number of records you have in your organization and click Next",
  "estimateorgsize": "It's okay to approximate, you can add or remove employees later",
  "enterorgsizeh": "How many employees are in your organization?",
  "selectfieldsh": "What data fields would you like to include?",
  "Desired Holders": "Staffing target",
  "DesiredHolders": "Staffing target",
  "selectfields": "Select the fields you would like to include in your chart data",
  "reviewmanualh": "Review Chart Setup",
  "reviewmanual": "If everything looks good, click Finish to complete setup!",
  "I have no data": "Start from Scratch",
  "Core": "Core",
  "Diversity": "Diversity",
  "Contact": "Contact",
  "Compensation": "Compensation",
  "Personal": "Personal",
  "Behavior": "Behavior",
  "Page Breaks": "Page Breaks",
  "Custom Filter": "Custom Filter",
  "Edit Metrics": "Edit Metrics",
  "Edit Users": "Edit Users",
  "Edit Fields": "Edit Fields",
  "Chart Builder Filter": "Would you like to apply filters to narrow the focus of your chart?",
  "Chart Builder Filter Directions": "Filter your chart to focus on specific positions, departments, or other criteria",
  "Build Employees Chart": "Which employee would you like at the top of this chart?",
  "Build Employees Chart Directions": "Choose a key person to represent the top of your chart",
  "Select Build Chart Level": "How many levels under this employee would you like to include?",
  "Select Build Chart Level Directions": "Choose number of levels to change the depth of your chart",
  "Select Build Position Level": "How many levels under this position would you like to include",
  "Chart Builder Info": "Use your base data as a springboard to create a custom chart",
  "Plan Builder Directions": "Name your plan, choose a starting point, and start planning",
  "Plan Builder Position Directions": "Name your plan, choose a starting point, and start planning",
  "Build Employees Plan": "Which employee represents the top of your chart?",
  "Build Position Doc": "Which position would you like at the top of this {document}?",
  "Choose Plan Name": "Choose a name for this plan",
  "What View To Apply": "What view would you like to apply",
  "ManualBlank": "Leave blank for 4 person chart",
  "Org Size": "Org Size",
  "Data Fields": "Data Fields",
  "Data field": "Data field",
  "Review": "Review",
  "Picklist": "Picklist",
  "List": "List",
  "Delimiter": "Delimiter",
  "Set list": "Set list",
  "Reference Table": "Reference table",
  "BackgroundEditorTools": "Tools",
  "Editor Tools": "Editor Tools",
  "Open Existing": "Open Existing",
  "New Blank": "New Blank",
  "Background Name": "Background Name",
  "Default Background": "Standard Background",
  "Default Background Info": "Get up and running with a pre-made background",
  "Recently Opened Charts": "Recently Opened Charts",
  "Backgrounds": "Backgrounds",
  "Active Background": "Active Background",
  "Currently Applied": "Currently Applied",
  "Value Mismatch": "Value mismatch",
  "Value mismatches": "Value mismatches",
  "Enum Table": "Enum Table",
  "Include Background": "Include background",
  "uploaddatafile": "Upload your data file",
  "selectmapping": "Help us understand your data",
  "selecttopofchart": "Select a top employee from the list below",
  "Select File": "Select File",
  "Column Mapping": "Column Mapping",
  "Select Top of Chart": "Select Top of Chart",
  "All Files": "All Files",
  "API Timeout Message": "Due to the nature of your API integration, this refresh will take much longer than usual. While you won't be able to do on-demand refreshes in the app, we'll still be able to refresh your data during your scheduled automated refresh. You can find the details of your refresh in Chart Settings > Refresh",
  "API Timeout": "API Timeout",
  "Invalid File Type": "Invalid File Type",
  "nofilefiltermatches": "file(s) currently hidden. To see these files, change the file filter on the bottom right.",
  "Import From": "Import From",
  "Plan Open Failure": "Unable to open plan. Your permissions do not grant you access to this plan or required fields within the plan. Contact your system administrator.",
  "Record Not Found": "Record Not Found",
  "Record": "Record",
  "ReplaceOrAdd": "This table already contains data. Choose whether to replace all existing records or add your new data to them.",
  "Plan Load Record Failure": "This record no longer exists in your plan data source.",
  "Confirm Resolve Conflict": "Confirm Changes and Resolve",
  "Revert Change and Resolve": "Revert Change and Resolve",
  "Resolve conflict": "Resolve conflict",
  "Resolve": "Resolve",
  "Resolve later": "Resolve later",
  "Show All": "Show All",
  "Unsaved Charts": "Unsaved Charts",
  "Recover Charts": "Recover Charts",
  "View Unsaved Charts": "We have recovered one or more unsaved charts. Would you like to view them now?",
  "Review Unsaved Charts": "Review Unsaved Charts",
  "Review Later": "Review Later",
  "Authenticator": "Authenticator",
  "Record Info": "Record Info",
  "RemovedBreak": "Break removed under",
  "InsertedBreak": "Break inserted under",
  "No Changes Detected": "No changes detected.",
  "Reports": "Reports",
  "RenamedBreak": "Subchart renamed to",
  "Levels Below Topbox": "Levels Below Topbox",
  "Chain of Command Levels": "Chain of Command Levels Above Top of Chart",
  "Chart Document Linked To Master Chart": "This chart document is linked to a Master Chart.",
  "Standard Field": "Standard field",
  "Top of chart": "Top of chart",
  "Top box of chart": "Top box of chart",
  "Specify Top of Chart": "Specify Top of Chart",
  "Doc Inherits from Master Chart": "This Document inherits settings from a Master Chart.",
  "Levels Below Top of Chart": "Levels Below Top of Chart",
  "Setting Controlled by Master Chart": "This document setting is controlled by your Master Chart. Changes to this section will need to be done to the Source Master Chart in Chart Settings.",
  "Presentation Not Available": "Presentation Not Available",
  "Presentation Support": "This presentation option is not yet offered.",
  "Presentation Support Link": "If you would like access to this feature as soon as possible, please contact Support.",
  "Page properties": "Page properties",
  "Keep MFA Requirement On": "Keep MFA requirement on",
  "Disable MFA Requirement": "Disable MFA requirement",
  "Requirement": "Requirement",
  "MFA Enabled": "MFA is currently active and required at login. To disable this security measure or reconfigure using a new code, you can click the reset button below.",
  "MFA Required": "Multi-factor authentication is required by your account admin. If you need help with this feature, reach out to your account admin for assistance.",
  "Bypassed": "Bypassed",
  "See More Fields": "See more fields",
  "See Less Fields": "See less fields",
  "Child": "Child",
  "Children": "Children",
  "Create group": "Create group",
  "No Date Found": "No Date Found",
  "Doc Settings No Source": "This document has no data source. Use the workbench tools to manage your chart data.",
  "Point In Time Chart": "Point in time chart",
  "Chart Builder Chart": "Chart builder chart",
  "Which boxes should this rule apply to?": "Which boxes should this rule apply to?",
  "What should be done to those boxes?": "What should be done to those boxes?",
  "Pagination changes": "Pagination changes",
  "Data Source Details Unavailable": "Some chart details may be unavailable for older chart documents.",
  "AutoPopulateViewsFailure": "Max view limit reached (10) for this chart. Please remove a view before adding another.",
  "AutoPopulateFailure": "Failed to link content to Master Chart. Please check chart configuration limits and try again.",
  "Log in to your": "Log in to your",
  "OrgChart account": "{gAppName} account",
  "account": "account",
  "Group \"Full Access\"": "Group \"Full Access\"",
  "Welcome back. Please enter your credentials.": "Welcome back. Please enter your credentials.",
  "Don't have an account?": "Don't have an account?",
  "Sign up": "Sign up",
  "Reset your": "Reset your",
  "Levels up": "Levels up",
  "Levels down": "Levels down",
  "levels": "levels",
  "level": "level",
  "Removed subchart break": "Removed subchart break",
  "Inserted subchart break": "Inserted subchart break",
  "Renamed Subchart": "Renamed Subchart",
  "Data changes": "Data changes",
  "Formatting changes": "Formatting changes",
  "Cell formatting": "Cell formatting",
  "Text formatting": "Text formatting",
  "changed": "changed",
  "View rules": "View rules",
  "Show search fields": "Show search fields",
  "Finish editing": "Finish editing",
  "Clear all": "Clear all",
  "Add rule": "Add rule",
  "Edit View": "Edit view",
  "Update the automated rules driving chart presentation.": "Update the automated rules driving chart presentation.",
  "Available views": "Available views",
  "View library": "View library",
  "Position view library": "Position view library",
  "Employee view library": "Employee view library",
  "Manage available views": "Manage available views",
  "insertrowabove": "Insert 1 row above",
  "insertcolleft": "Insert 1 column left",
  "deleterows": "Delete rows",
  "insertrowbelow": "Insert 1 row below",
  "insertcolright": "Insert 1 column right",
  "deletecols": "Delete columns",
  "mergecells": "Merge cells",
  "mergeall": "Merge all",
  "unmergecells": "Unmerge",
  "deletevalues": "Values",
  "deletefield": "Field",
  "clearformat": "Clear formatting",
  "Chart type": "Chart type",
  "Default levels": "Default levels",
  "Seat limit": "Seat limit",
  "Currently used seats": "Currently used seats",
  "Currently used boxes": "Currently used boxes",
  "disconnected records": "disconnected records",
  "disconnected record": "disconnected record",
  "Disconnected": "Disconnected",
  "Record is disconnected from hierarchy": "Record is disconnected from hierarchy",
  "No background": "No background",
  "No background applied": "No background applied",
  "Applied by view": "Applied by view",
  "Applied by": "Applied by",
  "Cannot change background. This view is applying a rule driven background.": "Cannot change background. This view is applying a rule driven background.",
  "No refresh history": "No refresh history",
  "No disconnected records": "No disconnected records",
  "Edit this chart to adjust the filter": "Edit this chart to adjust the filter",
  "Click add rule to start conditionally formatting your chart": "Click add rule to start conditionally formatting your chart",
  "No conditional formatting rules": "No conditional formatting rules",
  "Your user is not permitted to access this instance of OrgChart": "Your user is not permitted to access this instance of OrgChart",
  "Choose views": "Choose views",
  "Auto-sync": "Auto-sync",
  "Chart Explorer": "Chart explorer",
  "Base Charts": "Base charts",
  "Plans": "Plans",
  "Recents": "Recents",
  "confirmViewRemove1": "You have deleted one or more views that are currently used by",
  "confirmViewRemove2": "existing charts. Once you save your changes, the view(s) will no longer be available. Are you sure you want to save your changes?",
  "Apply to all subcharts": "Apply to all subcharts",
  "Apply to chart": "Apply to chart",
  "Aux details": "Add in additional reporting relationships that exist in your data",
  "ChangeAppendInfo": "Update record information",
  "MoveAppendInfo": "Change reporting relationship",
  "DeleteAppendInfo": "Remove record from chart",
  "New SupervisorID Required": "New supervisor required for move",
  "No Changed Fields": "No fields have been changed. Edit a field in the record to create a new change.",
  "No field": "No field",
  "AuxRepMapping": "Additional reports mapping",
  "aTitle": "Alternate title",
  "EmpFieldMap": "Employee field mapping",
  "Position field mapping": "Position field mapping",
  "OptFieldMap": "Optional field mapping",
  "LoadMap": "Load field mapping",
  "ResetMap": "Reset field mapping",
  "First Name": "First name",
  "Preferred First": "Preferred first",
  "Last Name": "Last name",
  "Preferred Last": "Preferred last",
  "CreateFieldMap": "Create field map",
  "Create custom chart": "Create custom chart",
  "LinkUserNotSelectedError": "Please select a link user",
  "at": "at",
  "No results found": "No results found",
  "Find changes": "Find changes",
  "Changes effective": "Changes effective",
  "Filter out by type": "Filter out by type",
  "Show conflicts only": "Show conflicts only",
  "Plan changes": "Plan changes",
  "Source data changes": "Source data changes",
  "This plan has changes that are no longer valid": "This plan has changes that are no longer valid",
  "Select a new value to resolve the conflict": "Select a new value to resolve the conflict",
  "Search for": "Search for",
  "Conflict detected": "Conflict detected",
  "Conflict auto-resolved": "Conflict auto-resolved",
  "Conflicts detected": "Conflicts detected",
  "Filter by status": "Filter by status",
  "Filter by role": "Filter by role",
  "Show plans not shared with me": "Show plans not shared with me",
  "Enter formula rule": "Enter formula rule here: ",
  "Select formula field": "Select formula field",
  "Enter formula name": "Enter formula name",
  "Edit dynamic formula": "Edit dynamic formula",
  "Formula name": "Formula name",
  "Apply this formula to": "Apply this formula to",
  "Create dynamic formula": "Create dynamic formula",
  "Select formula span": "Select formula span",
  "DynFormWarn": "These formulas won’t work as expected for base charts or plans. Please use regular formulas instead.",
  "Function": "Function",
  "Choose fields": "Choose fields",
  "Create rule condition": "Create rule condition",
  "Create custom rule": "Create custom rule",
  "Create new conditional rule": "Create your own conditions to define complex rule criteria",
  "rowsecconditional": "Fields will be hidden when all conditions are met.",
  "Find branches": "Find branches",
  "Branch pruning": "Branch pruning",
  "Branch rule": "Branch rule",
  "Branch pruning info": "Users will only see records that match the specified rule criteria. (Recommended for 'Restrict to Own Branch' branch rule.)",
  "Choose file": "Choose file",
  "What would you like to call this plan?": "What would you like to call this plan?",
  "What data fields will be used in this plan?": "What data fields will be used in this plan?",
  "Select fields": "Select fields",
  "Create rule comparison": "Create rule comparison",
  "Rule definition": "Rule definition",
  "Enter rule definition": "Enter rule definition",
  "<blank>": "<blank>",
  "Create new highlight": "Create new highlight",
  "Create new filter": "Create new filter",
  "Edit highlight": "Edit highlight",
  "Show highlight": "Show highlight",
  "Hide highlight": "Hide highlight",
  "Create highlight": "Create highlight",
  "Create filter": "Create filter",
  "Edit filter": "Edit filter",
  "Show filter": "Show filter",
  "Hide filter": "Hide filter",
  "Turn on by default": "Turn on by default",
  "Turn off by default": "Turn off by default",
  "recordField": "Record field",
  "mergeField": "Merge field",
  "deltareportconfiguration": "Delta report configuration",
  "automaticarchive": "Automatic archive",
  "lastarchive": "Last archive",
  "Detailed data query": "Detailed data query",
  "Specify endpoint": "Specify endpoint",
  "Manually archive": "Manually archive",
  "Export to Excel": "Export to Excel",
  "Exporting archive": "Exporting archive",
  "Chart archives": "Chart archives",
  "Choose an archive to build off of or create a delta report between two dates": "Choose an archive to build off of or create a delta report between two dates",
  "Date from": "Date from",
  "Date to": "Date to",
  "Choose date": "Choose date",
  "Select a date range for your report": "Select a date range for your report",
  "Download report": "Download report",
  "Automatic delta report notifications": "Automatic delta report notifications",
  "Enter email address(es) for notification": "Enter email address(es) for notification",
  "Select fields included in delta report": "Select fields included in delta report",
  "Reports to": "Reports to",
  "No reports": "No reports",
  "Revert to source": "Revert to source",
  "Confirm field revert": "Are you sure you want to revert this field to the source value?",
  "Field change history": "Field change history",
  "Revert to prior value": "Revert to prior value",
  "Revert all field changes": "Revert all field changes",
  "Revert to": "Revert to",
  "Revert all changes to": "Revert all changes to",
  "Show less information": "Show less information",
  "Show more information": "Show more information",
  "Advanced search fields": "Advanced search fields",
  "Refine your search": "Refine your search",
  "Customize your search with various criteria to find the perfect match": "Customize your search with various criteria to find the perfect match",
  "SEARCH": "SEARCH",
  "Create folder": "Create folder",
  "Upload file": "Upload file",
  "Background changes will be saved as a new background": "Background changes will be saved as a new background",
  "Background changes will only be applied to this chart": "Background changes will only be applied to this chart",
  "Background changes will apply to all charts using this background": "Background changes will apply to all charts using this background",
  "Please choose how you want background changes to be saved": "Please choose how you want background changes to be saved",
  "Save Background": "Save Background",
  "Favorites": "Favorites",
  "Invalid input": "Invalid input",
  "Name your custom chart": "Name your custom chart",
  "Choose field": "Choose field",
  "Target field": "Target field",
  "Target value": "Target value",
  "Please check the following fields": "Please check the following fields",
  "Save changes to": "Save changes to ",
  "All changes will be lost": "All changes will be lost",
  "Create new group": "Create new group",
  "Edit group": "Edit group",
  "Application Security": "Application security",
  "Allowed folders": "Allowed folders",
  "Add folder": "Add folder",
  "Chart Security": "Chart security",
  "Can access chart": "Can access chart",
  "Branch level security": "Branch level security",
  "Allowed views": "Allowed views",
  "Allowed filters": "Allowed filters",
  "Allowed legacy filters": "Allowed saved filters (legacy)",
  "Add filters": "Add filters",
  "Add highlights": "Add highlights",
  "Allowed highlights": "Allowed highlights",
  "Allowed legacy highlights": "Allowed saved highlights (legacy)",
  "Configure group field mapping": "Configure group field mapping",
  "Edit Whitelist Domain": "Edit whitelist domain",
  "Add Whitelist Domain": "Add whitelist domain",
  "Discard": "Discard",
  "Create from existing": "Create from existing",
  "Must have a valid chart name": "Must have a valid chart name",
  "Reset Charts": "Reset charts",
  "Download activity report": "Download activity report",
  "Launch chart": "Launch chart",
  "Default mode": "Default mode",
  "Open file explorer": "Open file explorer",
  "Create new user": "Create new user",
  "Edit user": "Edit user",
  "Create security profile": "Create security profile",
  "Edit security profile": "Edit security profile",
  "Must have a valid profile name": "Must have a valid profile name",
  "Date Time Format": "Date time format",
  "Use 24 hour clock": "Use 24 hour clock",
  "Create new record": "Create new record",
  "What would you like to do with this record": "What would you like to do with this record?",
  "Choose entry type": "Choose entry type",
  "Select data source": "Select data source",
  "Main data": "Main data",
  "Append data": "Append data",
  "Merge data": "Merge data",
  "Add data source": "Add data source",
  "Remove data source": "Remove data source",
  "There are no reference tables": "There are no reference tables",
  "Fields and formulas": "Fields and formulas",
  "Dynamic formulas": "Dynamic formulas",
  "Treat UTC 0 as Local Browser Time": "Treat UTC 0 as local browser time",
  "New value": "New value",
  "OR": "OR",
  "Add new value": "Add new value",
  "No values added. Click here to add a value": "No values added. Click here to add a value",
  "Create rule": "Create rule",
  "Add to library": "Add to library",
  "Create formula": "Create formula",
  "Edit formula": "Edit formula",
  "Click + to add an operation": "Click + to add an operation",
  "Select an operation to configure": "Select an operation to configure",
  "Profile fields": "Profile fields",
  "Export format": "Export format",
  "Schedule Chart Refresh": "Schedule chart refresh",
  "Advanced search": "Advanced search",
  "Directory result fields": "Directory result fields",
  "Subchart name field": "Subchart name field",
  "Subchart sorting": "Subchart sorting",
  "Page sort order": "Page sort order",
  "Keep order as-is": "Keep order as-is",
  "Keep pagination as-is": "Keep pagination as-is",
  "A single page export will not need to re-paginate your chart": "A single page export will not need to re-paginate your chart",
  "Sort by field": "Sort by field",
  "Subchart breaks": "Subchart breaks",
  "Start breaks at": "Start breaks at",
  "Privacy policy": "Privacy policy",
  "Terms of service": "Terms of service",
  "Overlay a region of color over boxes that match the criteria": "Overlay a region of color over boxes that match the criteria.",
  "Linked View will be applied when the top box of the subchart matches the rule criteria": "Linked view will be applied when the top box of the subchart matches the rule criteria",
  "Choose which boxes (some boxes or all boxes) for this rule to target": "Choose which boxes (some boxes or all boxes) for this rule to target",
  "Set which formatting or style properties should apply to boxes that meet the criteria above": "Set which formatting or style properties should apply to boxes that meet the criteria above",
  "Select Custom Chart": "Select custom chart",
  "Link user": "Link user",
  "Configure link user": "Configure link user",
  "Add sort key": "Add sort key",
  "Time": "Time",
  "Box height": "Box height",
  "Insert break": "Insert break",
  "Insert field": "Insert a field",
  "Remove break": "Remove break",
  "Level up": "Level up",
  "Level down": "Level down",
  "Remove box": "Remove box",
  "Finish editing layout": "Finish editing layout",
  "Box layout editor": "Box layout editor",
  "Distribute Space Vertical": "Distribute space vertical",
  "Align Objects Top": "Align objects top",
  "Send Back": "Send back",
  "Wrap text": "Wrap text",
  "Text align": "Text align",
  "Vertical align": "Vertical align",
  "Model, filter, and build your own custom chart off the shared base chart": "Model, filter, and build your own custom chart off the shared base chart.",
  "Edit this custom chart": "Edit this custom chart",
  "Continue editing this custom chart": "Continue editing this custom chart.",
  "Custom chart filter": "Custom chart filter",
  "Finish editing your chart to update these rules": "Finish editing your chart to update these rules",
  "Finish editing your view to update these rules": "Finish editing your view to update these rules",
  "Reset view": "Reset view",
  "More options view": "More options view",
  "Moved under": "Moved under",
  "Added under": "Added under",
  "Deleted under": "Deleted under",
  "changed to": "changed to",
  "changed from": "changed from",
  "Closed under": "Closed under",
  "Reopened under": "Reopened under",
  "Released from": "Released from",
  "Username": "Username",
  "Enable automatic clean-up": "Enable automatic clean-up",
  "autoassignwarningheader": "Turn on group auto-assignment?",
  "autoassignwarningmessage": "Warning: This feature applies to your account globally. If you enable this feature without the proper configuration, you can lock yourself and all of your users from accessing OrgChart. Are you sure you want to proceed?",
  "Loading archive": "Loading archive",
  "Users with access": "Users with access",
  "Configure metrics": "Configure metrics",
  "Branch preferences": "Branch preferences",
  "No comments": "No comments",
  "Download plan": "Download plan",
  "Source chart": "Source chart",
  "Shared users": "Shared users",
  "No additional fields": "No additional fields",
  "No plan description": "No plan description",
  "Enter description": "Enter description",
  "Chart information": "Chart information",
  "No description": "No description",
  "Enter name": "Enter name",
  "No additional fields added": "No additional fields have been added yet",
  "Recalculating": "Recalculating",
  "Application details": "Application details",
  "Chart details": "Chart details",
  "Enable sort": "Enable sort",
  "Download this page": "Download this page",
  "Download this screen": "Download this screen",
  "Download this branch": "Download this branch",
  "Download entire chart": "Download entire chart",
  "App preferences": "App preferences",
  "Page density": "Page density",
  "record": "record",
  "Search plans": "Search plans",
  "Modified date": "Modified date",
  "Created date": "Created date",
  "Field lookup": "Field lookup",
  "Treat value as": "Treat value as",
  "Basic math operation": "Basic math operation",
  "Look up using": "Look up using",
  "Match using": "Match using",
  "Return using": "Return using",
  "Separator": "Separator",
  "Index": "Index",
  "Set the top box and add co-heads": "Set the top box and add co-heads",
  "Knowledge base": "Knowledge base",
  "Support portal": "Support portal",
  "Branch level info": "Branch Level will check if a record is present within the current user's branch",
  "Self level info": "Value used is the current User's chart record",
  "Create filters that can be shared with other users": "Filters shared with other users",
  "Create highlights that can be shared with other users": "Highlights shared with other users",
  "importfiltersdesc": "Specify the data (records and fields) that should be included or excluded in your chart upon refresh. Data that is filtered out with import filters is not searchable, and will not impact headcounts or other formulas",
  "Create new import filter": "Create new import filter",
  "Create import filter": "Create import filter",
  "Edit import filter": "Edit import filter",
  "No import filters have been added": "No import filters have been added",
  "Add field value": "Add field value",
  "No values have been added": "No values have been added",
  "All fields restricted": "All fields restricted",
  "Would you like to save layout changes": "Would you like to save layout changes? All views using this box style will be updated.",
  "Would you like to save layout changes plural": "Would you like to save layout changes? All views using these box styles will be updated.",
  "Would you like to apply layout changes": "Would you like to apply the box layout changes?",
  "Save layout changes": "Save layout changes",
  "Apply layout changes": "Apply layout changes",
  "Label only": "Label only",
  "Value only": "Value only",
  "Label and value": "Label and value",
  "Field Label": "Field label",
  "Selected field label": "Selected field label",
  "Layout Editor": "Layout editor",
  "Client secret": "Client secret",
  "Client ID": "Client ID",
  "Tenant ID": "Tenant ID",
  "Site": "Site",
  "Domain": "Domain",
  "Mouse controls": "Mouse controls",
  "Maps to": "Maps to",
  "Add group mapping": "Add group mapping",
  "Create group mapping": "Create group mapping",
  "Copy link": "Copy link",
  "Link copied": "Link copied to clipboard",
  "Notify people": "Notify people",
  "People with access": "People with access",
  "Default users as collaborators": "Default users as collaborators",
  "Add people or groups": "Add people or groups",
  "Cannot edit rule background": "Cannot modify background while it is being applied by an active view.",
  "Validate": "Validate",
  "Make a copy": "Make a copy",
  "Unsaved": "Unsaved",
  "minsubbreaksinfo": "Specify the minimum number of boxes required for a subchart break to be inserted. This option helps to reduce the number of pages in the generated chart.",
  "Unable to sort": "Unable to sort",
  "Your chart has an automatic sort configuration applied": "Your chart has an automatic sort configuration applied. In order to manually resort your boxes, remove the automatic sort configuration in the sort tab on your sidebar",
  "Clear search filters": "Clear search filters",
  "Click here to select data source": "Click here to select data source",
  "fieldFormatWarning": "Rules can only apply one field format change at a time. Create additional chart rules to apply more field format changes to your chart",
  "Moved from": "Moved from",
  "to": "to",
  "Unable to save additional fields": "Unable to save additional fields",
  "Contact plan owner to add additional fields": "Contact plan owner to add additional fields",
  "Click here to add additional fields": "Click here to add additional fields",
  "Max box limit for single page": "Max box limit for single page",
  "List options": "List options",
  "Picklist options": "Picklist options",
  "Set picklist": "Set picklist",
  "Picklist type": "Picklist type",
  "Constrained": "Constrained",
  "Unconstrained": "Unconstrained",
  "Allowed values": "Allowed values",
  "is invalid value": "is invalid value",
  "Apply filter": "Apply filter",
  "Enable auto-export": "Enable auto-export",
  "Destination": "Destination",
  "Add more": "Add more",
  "Enter email address(es) for auto-export": "Enter email address(es) for auto-export",
  "Notify on": "Notify on",
  "Success and failure": "Success and failure",
  "Failure only": "Failure only",
  "Run": "Run",
  "Save and run": "Save and run",
  "Report explorer": "Report explorer",
  "Resume last open report": "Resume last open report?",
  "Continue Reporting": "Continue Reporting",
  "Find report": "Find report",
  "Open Last Report": "Open Last Report",
  "Open Report Explorer": "Open Report Explorer",
  "Create report": "Create report",
  "See Reports": "See Reports",
  "Filter by chart": "Filter by chart",
  "Reports filter": "Filter reports by the base chart they are linked to.",
  "Report name": "Report name",
  "Last run": "Last run",
  "Report owner": "Report owner",
  "Untitled Report": "Untitled Report",
  "Changes will be applied next data refresh": "Changes will be applied after next data refresh",
  "Open chart explorer": "Open chart explorer",
  "Open report explorer": "Open report explorer",
  "Delete criteria": "Delete criteria",
  "Delete filter": "Delete filter",
  "Delete filter?": "Delete filter?",
  "Add criteria": "Add criteria",
  "You’ve exceeded the max number of boxes allowed for export. Please reduce the scope of your export, or attempt an export from a different part of your organization, so that the number of boxes will not exceed your limit": "You’ve exceeded the max number of boxes allowed for export. Please reduce the scope of your export, or attempt an export from a different part of your organization, so that the number of boxes will not exceed your limit",
  "Administrators can update this limit in the Chart Settings: Presentation panel, though OrgChart does not recommend exporting charts with more than 20,000 records": "Administrators can update this limit in the Chart Settings: Presentation panel, though OrgChart does not recommend exporting charts with more than 20,000 records",
  "You’ve reached the maximum limit of": "You’ve reached the maximum limit of",
  "boxes for a custom chart. Try building the chart from a smaller section of your organization or apply filters to reduce the number of boxes.": "boxes for a custom chart. Try building the chart from a smaller section of your organization or apply filters to reduce the number of boxes.",
  "Admins can adjust this limit in Chart Settings > Presentation Panel, but OrgChart recommends keeping charts under 20,000 records for best performance.": "Admins can adjust this limit in Chart Settings > Presentation Panel, but OrgChart recommends keeping charts under 20,000 records for best performance.",
  "maxboxlimiterr": "You’ve exceeded the max number of boxes allowed on a custom chart. Administrators can update this limit ",
  "boxlimitwar": "Note that increasing the limit may negatively impact application performance.",
  "Reporting": "Reporting",
  "Report information": "Report information",
  "Last ran report": "Last ran report",
  "Confirm password": "Confirm password",
  "Customer email": "Customer email",
  "Enter confirmation code": "Enter confirmation code",
  "Select organization": "Select organization",
  "Keep me signed in": "Keep me signed in",
  "Refresh from source": "Refresh from source",
  "Changes saved automatically": "Changes are automatically saved",
  "Changes not saved automatically": "Changes are not automatically saved",
  "Data sync automatic": "Data is synced automatically",
  "Data sync not automatic": "Data is not synced automatically",
  "Name your chart": "Name your chart",
  "Name your background": "Name your background",
  "Name your chart before turning on auto save": "Please name your Custom Chart before turning on auto save",
  "No chart name": "No chart name",
  "Add custom solid color": "Add custom solid color",
  "Add custom gradient": "Add custom gradient",
  "Filter behavior": "Filter behavior",
  "Mute filtered records": "Mute filtered records",
  "Remove filtered records": "Remove filtered records",
  "Save copy": "Save copy",
  "Use existing background": "Use existing background",
  "Default background": "Default background",
  "Impersonate user": "Impersonate user",
  "mfaActive": "Multi-Factor Authentication is active",
  "Disable MFA requirement": "Disable MFA requirement",
  "Enable MFA requirement": "Enable MFA requirement",
  "Enable anyways": "Enable anyways",
  "Turn off MFA": "Turn off MFA",
  "Disabled": "Disabled",
  "MFA status": "MFA status",
  "Email MFA setup link": "Email MFA setup link",
  "MFA Setup": "MFA Setup",
  "Use OAuth2.0 Authentication": "Use OAuth2.0 Authentication",
  "exportusers": "Export users",
  "exportuserstip": "Export users to Excel file",
  "topLeft": "Top left",
  "topMiddle": "Top center",
  "topRight": "Top right",
  "bottomLeft": "Bottom left",
  "bottomMiddle": "Bottom center",
  "bottomRight": "Bottom right",
  "customPlacement": "Custom placement",
  "Elements": "Elements",
  "Add element": "Add element",
  "Delete element": "Delete element",
  "Move element": "Move element",
  "Selected background": "Selected background",
  "Editing linked background": "This background may be linked to other charts.",
  "Background bottom spacing": "Adjust spacing from bottom margin",
  "Background top spacing": "Adjust spacing from top margin",
  "Background left spacing": "Adjust spacing from left margin",
  "Background right spacing": "Adjust spacing from right margin",
  "Save background alert": "Would you like to save a copy of your current background so it can be used by other charts?",
  "Save background": "Save background",
  "Rule driven background": "Rule driven background",
  "View controls background": "Backgrounds are being controlled by a view.",
  "Titles": "Titles",
  "Dates": "Dates",
  "Page Number": "Page number",
  "Enumerated Table": "Enumerated table",
  "Basic Table": "Basic table",
  "duplicateuiprofile": "UI Profile already exists",
  "Resort boxes to save space": "Resort boxes to save space",
  "Use tree style for singles": "Use tree style for singles",
  "Update existing": "Update existing",
  "This chart only": "This chart only",
  "Save as new": "Save as new",
  "BasicRule": "Basic Rule",
  "ComplexRule": "Complex Rule",
  "No record selected": "No record selected",
  "Share plan": "Share plan",
  "Delete plan": "Delete plan",
  "No files or folders here": "No files or folders here",
  "Enter Target Value": "Enter Target Value",
  "Delete metric": "Delete metric",
  "Invalid Date": "Invalid Date",
  "Creating Archive": "Creating Archive",
  "Person ID required": "Person ID required",
  "No Name": "No Name",
  "Create new reports of your organization, or run saved reports": "Create new reports of your organization, or run saved reports",
  "Select chart to configure": "Select chart to configure",
  "You must select a role": "You must select a role",
  "You must select a UI profile": "You must select a UI profile",
  "Add SSO Configuration": "Add SSO Configuration",
  "Create checkpoint": "Create checkpoint",
  "Revert to checkpoint": "Revert to checkpoint",
  "Viewing Chart": "Viewing Chart",
  "Base Chart": "Base Chart",
  "Custom Chart": "Custom Chart",
  "Launch Settings": "Launch Settings",
  "Display Name": "Display Name",
  "Find users": "Find users",
  "Name cannot be blank": "Name cannot be blank",
  "Black": "Black",
  "White": "White",
  "InvalidName": "Invalid name",
  "Area under construction": "Area under construction",
  "DPR": "DPR",
  "OrgChart LLC. All rights reserved": "OrgChart LLC. All rights reserved",
  "Enter person id of top box": "Enter person id of top box",
  "IAT endpoint": "IAT endpoint",
  "Status is active": "Status is active",
  "Active on leave": "Active on leave",
  "Status is current": "Status is current",
  "On leave": "On leave",
  "Include terminated employees": "Include terminated employees",
  "Use Table": "Use Table",
  "Use (Legacy) API Key": "Use (Legacy) API Key",
  "SAP OrgUnit Chart Options": "SAP OrgUnit Chart Options",
  "Org unit file": "Org unit file",
  "Position file": "Position file",
  "Use approved positions table": "Use approved positions table",
  "Approved positions file": "Approved positions file",
  "Select formula type": "Select formula type",
  "Edit field format": "Edit field format",
  "Edit configuration": "Edit configuration",
  "Delete formula": "Delete formula",
  "Dynamic formula": "Dynamic formula",
  "Enter break character": "Enter break character",
  "Enter prefix": "Enter prefix",
  "Enter postfix": "Enter postfix",
  "Basic math has no configurable settings": "Basic math has no configurable settings",
  "Choose field value": "Choose field value",
  "Enter custom value": "Enter custom value",
  "Choose operation": "Choose operation",
  "No filters have been added": "No filters have been added",
  "No highlights have been added": "No highlights have been added",
  "Save changes to filter": "Save changes to filter ",
  "Show Direct Reports": "Show Direct Reports",
  "Select frequency": "Select frequency",
  "Automatic refresh notifications": "Automatic refresh notifications",
  "Select format": "Select format",
  "Level 2": "Level 2",
  "Level 3": "Level 3",
  "Level 4": "Level 4",
  "Configure field mapping": "Configure field mapping",
  "collabplanalert": "Access to collaborative planning requires read/write or administrator seat. Contact your administrator to change seat type",
  "Remove access": "Remove access",
  "Currently Viewing": "Currently viewing",
  "Border type": "Border type",
  "Line weight": "Line weight",
  "Line style": "Line style",
  "No box style selected": "No box style selected",
  "Conflicting field format changes": "Conflicting field format changes",
  "This is not normally required": "This is not normally required",
  "Modify UI Profile": "Modify UI Profile",
  "Configure a flag and label for the selected boxes": "Configure a flag and label for the selected boxes",
  "Border dash": "Border dash",
  "Box shadow": "Box shadow",
  "Pin": "Pin",
  "Line subgroup style": "Line subgroup style",
  "Document status": "Document status",
  "Automatically save changes": "Automatically save changes",
  "Save now": "Save now",
  "Automatically sync with source": "Automatically sync with source",
  "Employee data updates hourly.":
    "Employee data updates hourly. No manual refresh available. Only append and merge sources can be refreshed on demand.",
  "Multi-Factor Authentication Settings": "Multi-Factor Authentication Settings",
  "More Details": "More Details",
  "Anyone with this link can access OrgChart": "Anyone with this link can access OrgChart",
  "Only existing OrgChart users can access this link": "Only existing OrgChart users can access this link",
  "Anyone with access to the web page on which you embed this link can access OrgChart": "Anyone with access to the web page on which you embed this link can access OrgChart",
  "Notifications": "Notifications",
  "Rows": "Rows",
  "Show and hide fields": "Show and hide fields",
  "Import fields from": "Import fields from",
  "Use fields from a base chart within this background": "Use fields from a base chart within this background",
  "Select which charts should use this background by default": "Select which charts should use this background by default",
  "Save Report": "Save Report",
  "Account details": "Account details",
  "Changes will appear here": "Changes will appear here",
  "Margin": "Margin",
  "Specify page size": "Specify page size",
  "Select sort field": "Select sort field",
  "Use preset query": "Use preset query",
  "Show more chart details": "Show more chart details",
  "Use advanced Entra Query": "Use advanced Entra Query",
  "Microsoft account type": "Microsoft account type",
  "Standard (.com)": "Standard (.com)",
  "US government (.us)": "US government (.us)",
  "Source info": "Source info",
  "Record details": "Record details",
  "Show source": "Show source",
  "Search record": "Search record",
  "Changes pending": "Changes pending",
  "Change data source": "Change data source",
  "Created by": "Created by",
  "Manually added": "Manually added",
  "Source information not available": "Source information not available",
  "Enter field name": "Enter field name",
  "levelcharthelp": "Select field to build level chart. All branches will use the Tree branch style.",
  "Select up to 3 fields": "Select up to 3 fields that will be shown at the top of the profile card.",
  "Enable profile starring": "Profile field starring (user defined)",
  "Enterprise source limit": "Enterprise accounts can aggregate up to 10 data sources.",
  "Over source limit": "Over source limit",
  "Could not refresh custom chart": "Could not refresh custom chart",
  "Could not open custom chart": "Could not open custom chart",
  "livechartnotfound": "The base chart associated with this custom chart could not be located, so it cannot be synced to retrieve updated data. You can create new custom charts off existing base charts",
  "chartnotfound": "The base chart associated with this custom chart could not be located, so it cannot be synced to retrieve updated data. You can create new custom charts off existing base charts, and this chart will be available for you to continue editing or exporting",
  "changePaylocity": "For issues regarding your Paylocity integration, or to set up a new Paylocity integration, reach out to ",
  "changeSage300za": "The API Endpoint for this integration must be configured by support. To set it up, reach out to ",
  "Cannot add plan top box to talent pool":"Cannot add plan top box to talent pool.",
  "Failed to reorder talent" : "Failed to reorder talent",
  "Failed to remove talent": "Failed to remove talent",
  "Could not locate employee to add to talent pool" : "Could not locate employee to add to talent pool",
  "refreshemail": "Enter email addresses for users who should receive alerts",
  "autoexportemail": "Enter email addresses for users who should recieve auto-exports",
  "invalidcharwarn": "Certain characters are unavailable for field names. You can utilize the field label feature to add characters like '$' to the way fields display. ",
  "Back to all groups": "Back to all groups",
  "Group name": "Group name",
  "Group by field": "Group by field",
  "Group style": "Group style",
  "Return to base chart":"Return to base chart",
  "Rename custom chart":"Rename custom chart",
  "Rename base chart" : "Rename base chart",
  "Rename plan" : "Rename plan",
  "Rename report" : "Rename report",
  "Auto-save": "Auto-save",
  "Configure chart":"Configure chart",
  "Chart settings": "Chart settings",
  "Save your current changes to this record": "Save your current changes to this record",
  "The scope of the export exceeds your account's box limit": "The scope of the export exceeds your account's box limit. Please reduce the export scope to continue, or contact clientsuccess@theorgchart.com to increase your box limit",
  "One or more scope options is disabled because they exceed the maximum box limit for custom charts": "One or more scope options is disabled because they exceed the maximum box limit for custom charts. This can be configured by an Administrator in Chart Settings",
  "Show grouping": "Show grouping",
  "Invalid email": "Invalid email",
  "invalidemailmessage": "Please enter a valid email address in scheduled refresh configuration to be able to save changes",
  "autoemailmessage": "Please enter a valid email address in automated export configuration to be able to save changes",
  "Fix email": "Fix email",
  "Reset integration":"Reset integration",
  "Dayforce reset info":"The Dayforce API detects changes only between the last and current data refresh. If you've made significant changes to your integration, click {resetLabel} to establish a new data baseline during the next nightly sync. After resetting, the data refresh may take longer, and manual refresh might not be available.",
  "Confirm reset integration": "Are you sure you want to reset your current integration? This action cannot be undone. Warning: The next data refresh may take longer, and manual refresh might not be available.",
  "Reset data integration":"Reset data integration",
  "One or more fields contain errors" : "One or more fields contain errors",
  "You are over your seat limit": "You have reached your Read/Write seat limit. You can free up seats by converting existing users to Read-Only seats. To purchase additional seats contact ",
  "deletesingleuser": "Delete user",
  "Confirm delete": "Confirm delete",
  "Cannot re-use previous password": "Cannot re-use previous password",
  "Unable to build preview": "Unable to build preview",
  "An error prevented the preview from being generated. Please try again": "An error prevented the preview from being generated. Please try again",
  "Rebuild preview": "Rebuild preview",
  "enableFields": "Allow interactive field toggling",
  "Record removed" : "Record removed",
  "Select a valid reports to":"Select a valid reports to",
  "Undo plan change" : "Undo plan change",
  "Reports to removed": "Record no longer exists. Search for a new 'Reports to' or undo the plan change to revert to source.",
  "createWebLink": "Create web links",
  "Create custom charts": "Create custom charts",
  "recordDetails": "Record details",
  "Application, Account, User, and Chart information": "Application, Account, User, and Chart information",
  "Refresh base charts (Read/Write users)": "Refresh base charts (Read/Write users)",
  "Allow language change": "Allow language change",
  "Apply pagination settings?": "Apply pagination settings?",
  "Applying these settings will remove any manual subchart breaks": "Applying these settings will remove any manual subchart breaks",
  "chartExplorerWarn": "You do not have access to the Chart explorer due to your UI profile.",
  "contactAdmin": "Contact your administrator.",
  "Permission denied": "Permission denied",
  "Delete background" : "Delete background",
  "Move background" : "Move background",
  "Are you sure you want to delete background" : "Are you sure you want to delete this background? Any charts linked to this background will not be able to load the background anymore.",
  "Are you sure you want to move background" : "Are you sure you want to move this background? Any charts linked to this background may not be able to load the background anymore.",
  "Replace Existing File" : "Replace Existing File",
  "Replace Existing Files" : "Replace Existing Files",
  "Skip Duplicate" : "Skip Duplicate",
  "Skip Duplicates" : "Skip Duplicates",
  "Existing": "Existing",
  "Replace or Discard Files": "Replace or Discard Files",
  "File manager": "File manager",
  "transferAttributesInfoText": "Transfer user attributes from the Identity Provider (IDP) to the application for enhanced user profile management.",
  "transferAttributeLabel":"Transfer user attributes",
  "Rules from chart": "Rules from chart",
  "Rules from view": "Rules from view",
  "Set default background": "Click here to make default background",
  "Do you want to save changes to Filters": "Do you want to save changes to Filters?",
  "Modify backgrounds": "Modify backgrounds",
  "Delete open chart": "Delete open chart",
  "Not now": "Not now",
  "Load now": "Load now",
  "Update mapping": "Update mapping",
  "Keep mapping": "Keep mapping",
  "photoviewnophotos": "None of your employees have photos. Add photos to your HR system to see photos populate here.",
  "Load field mapping now" : "Load field mapping now?",
  "Load field mapping info" :  "A valid field mapping is required to create charts. OrgChart will attempt to determine an appropriate field mapping, though some manual adjustments may still be necessary.",
  "Unable to delete rule": "Unable to delete rule",
  "lastrulemessage": "You are not allowed to delete the last rule in a view. If you would like to delete this rule, add another rule to the view",
  "duplicatedrop": "Enable to prevent any duplicate records in the source data from being added to the chart",
  "deleteuserdelegate1": "This user has at least one other secondary user associated with it in other ",
  "deleteuserdelegate2": "If you delete this user, all the secondary users with this same email in other accounts will be deleted as well. Are you sure you want to delete these users?",
  "confirmdeletedelegate": "Delete primary and secondary users",
  "denydeletedelegate": "Do not delete",
  "accounts": "accounts",
  "Send all files to trash": "Are you sure you want to send {fileCount} files from '{folder}' folder to the trash?",
  "Delete all files trash": "Are you sure you want to delete {fileCount} files from the trash? This action cannot be undone.",
  "Move to trash": "Move to trash",
  "Delete all" : "Delete all",
  "Permanently delete file": "Permanently delete file?",
  "Move all to trash" : "Move all to trash",
  "Empty trash": "Empty trash",
  "Move files to trash" : "Move to trash",
  "Move all files to trash": "Move files to trash?",
  "Delete all files" : "Delete all files?",
  "Save and exit": "Save and exit",
  "Box style name in use" : "Box style name in use",
  "Choose unique name" : "Please choose a unique name.",
  "Enter a field name": "Enter a field name",
  "No more changes to show": "No more changes to show",
  "Show all": "Show all",
  "Show less": "Show less",
  "Show more": "Show more",
  "disableIndexSwitch": "The index page option is only available for entire chart exports. Click on the General tab, and then update the scope to entire chart, in order to use this option",
  "This custom chart is currently open. Are you sure you want to delete this custom chart": "This custom chart is currently open. Are you sure you want to delete this custom chart",
  "Any unsaved work will be lost.": "Any unsaved work will be lost.",
  "Trash": "Trash",
  "Samples": "Samples",
  "source(s)": "sources(s)",
  "12 AM": "12 AM",
  "1 AM": "1 AM",
  "2 AM": "2 AM",
  "3 AM": "3 AM",
  "4 AM": "4 AM",
  "5 AM": "5 AM",
  "6 AM": "6 AM",
  "7 AM": "7 AM",
  "8 AM": "8 AM",
  "9 AM": "9 AM",
  "10 AM": "10 AM",
  "11 AM": "11 AM",
  "12 PM": "12 PM",
  "1 PM": "1 PM",
  "2 PM": "2 PM",
  "3 PM": "3 PM",
  "4 PM": "4 PM",
  "5 PM": "5 PM",
  "6 PM": "6 PM",
  "7 PM": "7 PM",
  "8 PM": "8 PM",
  "9 PM": "9 PM",
  "10 PM": "10 PM",
  "11 PM": "11 PM",
  "Generic insufficient permissions": "You do not have permission to perform this action due to your access group or role. Please contact your system administrator.",
  "Copy file": "Copy file",
  "Download file": "Download file",
  "Delete file": "Delete file",
  "Folder locked": "This folder is locked. You cannot modify content in locked folders.",
  "change by author": "{changeDatetime} by {author}",
  "back to filter list": "Back to filters",
  "back to highlight list": "Back to highlights",
  "No append tables (long)": "You do not have any tables set up yet. Create a table to manage and modify records in existing charts.",
  "Select a table" : "Select a table",
  "New Table (name)" : "New Table",
  "New Base Chart":"New Base Chart",
  "Table Name": "Table Name",
  "Table name cannot be empty" : "Table name cannot be empty",
  "Table name must be at least 4 characters": "Table name must be at least 4 characters",
  "Table name already exists": "Table name already exists",
  "Create table": "Create table",
  "Search for table name": "Search for table name",
  "Search by name or title": "Search by name or title",
  "Modifications": "Modifications",
  "Modifications shown here (long)": "All types of modifications will be recorded here in a table view",
  "Add record": "Add record",
  "Manage tables info (long)": "Manage your existing tables or create a new one to apply to your base chart.",
  "Additional field in use (long)":"A field name is being used more than once. Please check the table to ensure all field names are unique before you can save your changes.",
  "Additional field is reserved (long)": "One or more field names are reserved. Please check the table to ensure all field names are unique before you can save your changes.",
  "Name is reserved":"Name is reserved.",
  "Name already in use": "Name already in use.",
  "Errors in form": "You have unsaved changes, but there are errors that must be resolved before saving. Do you want to resolve the issues or discard your changes?",
  "About append table (long)":"The append table allows you to manage records in existing charts. Search for an existing employee or position to change, move or delete. You may also add records using the Add Record button or use the Upload/Download buttons to use a flat file to manage/add records in bulk.",
  "About additional fields (long)": "Use your append table to add new fields to your data and populate them for chosen records. You cannot rename the additional fields once they have been created.",
  "No Table Selected": "No table selected",
  "Modification history" : "History of record modifications",
  "Modification history tip": "All changes are saved automatically.",
  "Unsaved changes detected": "Unsaved changes detected",
  "Number of modifications": "Number of modifications made to this table",
  "Number of additional fields" : "Number of fields added to this table",
  "Changes have been saved": "Changes have been saved.",
  "An error occurred while saving": "An error occurred while saving.",
  "Active table set": "{tableName} set as active table.",
  "Entity not found": "{entity} not found",
  "Entity created": "{tableName} created.",
  "Entity changes saved": "{entity} changes saved.",
  "Are you sure you want to delete entity": "Are you sure you want to delete {entity}",
  "Entity deleted": "{entity} deleted.",
  "Entity copied": "Created copy of {entity}",
  "Entity renamed": "{oldEntity} renamed to {newEntity}",
  "Entity set as default": "{entity} set as default",
  "Entity i": "{entity} {i}",
  "Entity name": "{entity} name",
  "Add entity": "Add {entity}",
  "Create entity": "Create {entity}",
  "Edit entity": "Edit {entity}",
  "Copy entity": "Copy {entity}",
  "Entity saved": "{entity} saved.",
  "Edit entity details": "Edit {entity} details",
  "Entity name cannot be empty": "{entity} name cannot be empty",
  "Number of entity applied to the chart": "The number of {entity} applied to the chart.",
  "Fill all fields {entity}": "All required fields must be filled before you can save the {entity}.",
  "Invalid date range": "Invalid date range. The \"From\" date must come before the \"To\" date.",
  "Invalid numeric range": "Invalid range. The \"Starting value\" must be smaller than the \"Ending value\".",
  "Invalid range on criteria {n}": "Invalid range on criteria {n}. The \"Starting value\" must be smaller than the \"Ending value\".",
  "Invalid date range on criteria {n}": "Invalid date range on criteria {n}. The \"From\" date must come before the \"To\" date.",
  "Missing required field": "There are required fields missing.",
  "Missing required field on criteria {n}": "There are required fields missing on criteria {n}.",
  "Criteria {n} {msg}": "Criteria {n}: {msg}",
  "Generic default error": "An error was detected.",
  "Generic toast error": "An error occurred. Please try again.",
  "Table name must be at least 4 characters and unique": "Table name must be at least 4 characters and unique.",
  "Position fields": "Position fields",
  "Employee fields": "Employee fields",
  "The system only allows you to add up to three additional co-heads": "The system only allows you to add up to three additional co-heads",
  "Add co-head": "Add co-head",
  "Box selected": "Box selected",
  "Position box": "Position box",
  "Employee box": "Employee box",
  "Chart styles": "Chart styles",
  "Additional reports" : "Additional reports",
  "Additional reports to": "Additional reports to",
  "Add assignment": "Add assignment",
  "Duplicate additional reports are not allowed": "Duplicate additional reports are not allowed",
  "This supervisor is already selected": "This supervisor is already selected",
  "Chart fields changed": "Chart fields changed",
  "Chart fields changed (long)": "Chart fields have changed. Please refresh your chart",
  "Update Base Chart Mapping": "Update base chart mapping?",
  "Update Base Chart Mapping (long)": "Would you like OrgChart to update your base chart mapping to use your new additional report field?",
  "Update Base Chart Mapping (info)": "Report mapping can be adjusted in {mappingPath} under the {AuxRepMapping} section.",
  "Invalid reporting structure": "Invalid reporting structure",
  "Delete additional field": "Delete additional field?",
  "Delete additional field (long)": "Are you sure you want to delete {name} field?",
  "Broken field references warning": "References to this field (including box styles, profile, and other field formatting options) will no longer display properly.",
  "Additional reports limit": "The system allows you to add up to four additional supervisor assignments.",
  "Additional reports info": "Additional reports can be quickly added here, and managed in {mappingPath}.",
  "mappingPath": "Chart settings: Mapping",
  "You cannot rename the additional fields once they have been created": "You cannot rename the additional fields once they have been created.",
  "Refresh chart notice": "Refresh your chart to see the latest changes.",
  "Manage fields": "Manage fields",
   "Confirm copy base chart": "A base chart is your foundation and you typically only need one. You can create multiple {customCharts} from a single base chart to modify formatting, reporting lines, and other settings.",
  "Are you sure you want to copy base chart": "Are you sure you want to copy this base chart?",
  "Copy base chart":"Copy base chart?",
  "Delete base chart":"Delete base chart?",
  "custom charts":"custom charts",
  "Choose data source": "Choose data source",
  "What type of chart are you creating": "What type of chart are you creating?",
  "Confirm delete base chart":"Deleting a base chart will remove the chart permanently. Plans and custom charts using this base chart will no longer be able to access the data. This action cannot be undone.",
  "Employee Chart":"Employee Chart",
  "Position Chart":"Position Chart",
  "Base Employee Chart": "Base employee chart",
  "Base Position Chart": "Base position chart",
  "Custom Employee Chart": "Custom employee chart",
  "Custom Position Chart": "Custom position chart",
  "Employee Chart Plan": "Employee chart plan",
  "Position Chart Plan": "Position chart plan",
  "Employee Chart Details":"A people-focused chart that visualizes relationships between individual employees, showing direct connections regardless of formal position structure.",
  "Position Chart Details":"A position-focused chart that displays your organization's formal hierarchy based on roles and positions rather than the individuals who fill them.",
  "Position Chart Disabled":"To enable this feature, please contact customer support.",
  "Position Chart Coming Soon": "Position Chart is coming soon.",
  "Select employee chart type" : "Switch to an employee chart type",
  "Select position chart type" : "Switch to a position chart type",
  "characters remaining": "{count} characters remaining",
  "Switch chart types":"Switch chart types?",
  "Switch chart type (long)":"Switching chart types will require you to re-select a data source.",
  "Allocation Ratio": "Allocation Ratio",
  "Position field categories": "Position field categories",
  "Select fields and assign them as either holder fields, position fields, or both": "Select fields and assign them as either holder fields, position fields, or both using the buttons below.",
  "Data field categories": "Data field categories",
  "Assign as": "Assign as",
  "Both": "Both",
  "Create plan from": "Create plan from",
  "Create custom chart from": "Create custom chart from",
  "custom chart created": "{name} custom chart created.",
  "No rule": "No rule",
  "Chart plan": "{chart} plan",
  "Add a description": "Add a description",
  "Plan Objective": "What is the objective for creating this plan?",
  "planobjective": "Plan objective",
  "Plan Objective Help": "Learn more about plan objectives in our",
  "Plan Objective Help Link": "Help Center",
  "Share this plan with": "Optional: Share this plan now",
  "this can be done later": "this can be done later",
  "Cost reduction": "Cost reduction",
  "Headcount reduction": "Headcount reduction",
  "Relocation": "Relocation",
  "General organization design": "General organization design",
  "Select objective": "Select objective",
  "Objective": "Objective",
  "Employees": "Employees",
  "Modify fields": "Modify fields",
  "Upload checkpoint": "Upload checkpoint",
  "Select a chart type to configure data source": "Select a chart type to configure data source",
  "Employee List": "Employee List",
  "Unassigned": "Unassigned",
  "Assigned": "Assigned",
  "Released": "Released",
  "Assigned Out Of Scope":"Assigned*",
  "Assigned Out Of Scope Info": "Assigned outside of plan scope",
  "Unassigned from": "Unassigned from",
  "Assign": "Assign",
  "Assign to position": "Assign to position",
  "Clone position": "Clone position",
  "Unassign employee": "Unassign employee",
  "Unassign employees": "Unassign employees",
  "Assign employee": "Assign employee",
  "Release employee": "Release employee",
  "Release employees": "Release employees",
  "Set as default chart": "Set as default chart",
  "Open in chart settings": "Open in chart settings",
  "Create copy": "Create copy",
  "Delete chart": "Delete chart",
  "Delete chart disabled isolved": "You cannot delete this chart at this time. Please contact isolved support for more information.",
  "Add additional report field": "Add additional report field",
  "General field mapping" : "General field mapping",
  "Reset to default":"Reset to default",
  "This option is disabled due to role assignment restrictions": "This option is disabled due to role assignment restrictions",
  "Position dataset": "Position dataset",
  "Employee dataset": "Employee dataset",
  "Choose what type of position data":"Choose what type of data you want to use to create your position chart",
  "I have a single source with employee data": "I have a single source with employee data",
  "I have multiple sources with employee and position data":"I have multiple sources with employee and position data",
  "I have a single source with employee and position data": "I have a single source with employee and position data",
  "Budget field mapping": "Budget field mapping",
  "Employee details field mapping": "Employee details field mapping",
  "costband": "Cost band (per employee)",
  "costbandinfo": "Set a minimum and maximum cost range per employee to monitor budget impact.",
  "Position details": "Position details",
  "Multi position editor changes info": "Any changes you make to the following fields will apply to the {count} {positions} you selected.",
  "Reopen position editor changes info": "You can {__reopenTheCountPosition__}, but employees assigned at the time of closure {__wontBeAutomaticallyReassigned__} back to the position.",
  "Successfully updated positions": "Successfully updated {count} {positions}",
  "Failed to update positions": "Failed to update positions. Please try again.",
  "Basic Info": "Basic Info",
  "Start date": "Start date",
  "End date": "End date",
  "costbanderror": "Cost band min must be less than Cost band max",
  "startenddateerror": "Start date must be before end date",
  "staffingtargeterror": "Staffing target must be greater than 0",
  "Vacant": "Vacant",
  "Assignment status": "Assignment status",
  "Assignees": "Assignees",
  "Show more entity": "Show more {entity}",
  "Show less entity": "Show less {entity}",
  "staffingtargetinfo": "Represents the desired maximum number of employees assigned to this position. You can still assign as many employees as you see fit.",
  "System generated": "System generated",
  "System generated positions": "This field is automatically generated using the employee to employee reporting structure.",
  "System generated item": "{item} (System generated)",
  "Upgrade to add more": "Upgrade to add more",
  "Learn more": "Learn more",
  "Get started": "Get started",
  "Pricing and Packaging": "Pricing and packaging",
  "Share Filters & Highlights": "Share Filters & Highlights",
  "Access groups remaining": "Access groups remaining",
  "Access groups used": "Access groups used",
  "accessGroupLimit": `You have reached the limit for adding access groups. Please contact support at ${supportEmailaddr} for assistance`,
  "Source base chart": "Source base chart",
  "Auto-sync enabled": "Auto-sync enabled",
  "Auto-save enabled": "Auto-save enabled",
  "All staged records": "All staged records",
  "Box count tooltip": "Total number of boxes on the current open {document}.",
  "Boxes shown tooltip": "The number of boxes shown on the current open {document}.",
  "Filters applied tooltip": "Number of filters applied on the current open {document}.",
  "All staged records tooltip": "Total number of records in the Staging panel of the current open custom chart. Records may end up in the Staging panel, if their supervisor has been filtered out of the chart, or if you manually moved them there.",
  "Levels tooltip": "Number of organizational levels shown on the current open {document}.",
  "Disconnected records tooltip": "Total number of disconnected boxes on the current open chart. Disconnected boxes may have missing or invalid supervisor IDs, or may not report to other records on the main reporting tree of the base chart.",
  "Unassign": "Unassign",
  "Release": "Release",
  "Reopen": "Reopen",
  "Assignment": "Assignment",
  "all employees": "all employees",
  "Employee is unassigned from position": "{employee} is unassigned from {position}.",
  "Employee is assigned to position": "{employee} is assigned to {position}.",
  "{count} {employees} are assigned to {position}": "{count} {employees} are assigned to {position}.",
  "{count} {employees} are unassigned from {position}": "{count} {employees} are unassigned from {position}.",
  "totalHoldersCount employees are unassigned from entity": "{totalHoldersCountEmployees} are unassigned from {entity}.",
  "totalHoldersCount employees are unassigned from their positions": "{totalHoldersCountEmployees} are unassigned from their positions.",
  "totalHoldersCount employees are released from entity": "{totalHoldersCountEmployees} are released from {entity}.",
  "totalHoldersCount employees are released from their positions": "{totalHoldersCountEmployees} are released from their positions.",
  "Subordinate moved to parent": "{subordinate} moved to {parent}.",
  "Subordinate moved from position to position": "{fromPosition} moved to {toPosition}.",
  "Unassigned employees can be found in the Employee List": "Unassigned employees can be found in the Employee List.",
  "Are you sure you want to unassign employee from the position position?": "Are you sure you want to unassign {employee} from the {position} position?",
  "Are you sure you want to unassign totalHoldersCount employees from the position position?": "Are you sure you want to unassign {totalHoldersCountEmployees} from the {position} position?",
  "Are you sure you want to unassign totalHoldersCount employees from the following positions?": "Are you sure you want to unassign {totalHoldersCountEmployees} from the following positions?",
  "Released employees can be found in the Employee List": "Released employees can be found in the Employee List.",
  "Are you sure you want to release employee from the position position?": "Are you sure you want to release {employee} from the {position} position?",
  "Are you sure you want to release totalHoldersCount employees from the position position?": "Are you sure you want to release {totalHoldersCountEmployees} from the {position} position?",
  "Are you sure you want to release totalHoldersCount employees from the following positions?": "Are you sure you want to release {totalHoldersCountEmployees} from the following positions?",
  "Reopen position": "Reopen position",
  "Reopen position multi": "Reopen position(s)",
  "Close position": "Close position",
  "Close and release": "Close and release",
  "Close and unassign": "Close and unassign",
  "Closed positions remain in your chart and table view, but can be filtered out": `Closed positions remain in your chart and table view, but can be filtered out.\nUnassigned and released employees can be found in the Employee List.`,
  "Cannot move record": "Cannot move record",
  "You cannot move employees to closed positions.": "You cannot move employees to closed positions.",
  "You cannot move this record under a closed position.":
  "You cannot move this record under a closed position.",
  "supportContactGeneric": "your support or service team",
  "genericAccessGroupLimit": "You have reached the limit for adding access groups. Please contact your support or service team for assistance.",
  "genericFormulasLimit": "You have reached the limit for adding custom formulas. Please contact your support or service team for assistance.",
  "genericAddSourcesLimit": "You've reached the limit for adding additional data sources. Please contact your support or service team for assistance.",
  "genericBoxLimit": "The scope of the export exceeds your account's box limit. Please reduce the export scope to continue, or contact your support or service team to increase your box limit.",
  "genericUnknownError": "System not configured. Please contact your support or service team.",
  "genericSharePointErr": "Failed to configure SharePoint. Please contact your support or service team.",
  "genericSupportMsg": "If this problem persists, please contact your support or service team.",
  "genericSalesMsg": "For more information, please contact your support or service team.",
  "Are you sure you want to close the following position?": "Are you sure you want to close the following {__position__}?",
  "The entity is closed": "The {entity} is closed.",
  "Entities are closed": "{__entities__} are closed.",
  "The entity is reopened": "The {entity} is reopened.",
  "Entities are reopened": "{__entities__} are reopened.",
  "Entity has been reopened": "{entity} has been reopened.",
  "Entity has been updated": "{entity} has been updated.",
  "Closed": "Closed",
   "Search name": "Search name",
  "Employee filter": "Employee filter",
  "Show filter fields": "Show filter fields",
  "No filter fields selected": "No filter fields selected. Use the 'Fields' button to add fields.",
  "Type and press enter": "Type and press enter",
  "Cost bands": "Cost bands",
  "Use cost band data": "Use cost band data",
  "System calculate for me": "System calculate for me",
  "eymappingerror": "No mapping set for EY chart. Manually configure the mapping to finish loading chart data.",
  "Remove assignment": "Remove assignment",
  "Confirm remove assignment":"Are you sure you want to remove this employee from this position?",
  "Confirm reassign employee":"Are you sure you want to reassign this employee?",
  "Search for an employee": "Search for an employee",
  "Reassign employee": "Reassign employee",
  "Employee reassignment": "This employee is currently assigned to {title}: {id}. They will be moved when you save your changes.",
  "Employee unassignment": "This employee will be unassigned from {title}: {id} when you save your changes",
  "Budget details": "Budget details",
  "Position budget summary": "Position budget summary",
  "remaining": "remaining",
  "total budget": "total budget",
  "Utilization": "Utilization",
  "Total cost": "Total cost",
  "Employee cost breakdown": "Employee cost breakdown",
  "Cost band max": "Cost band max",
  "Current position cost": "Current position cost",
  "Create position": "Create position",
  "Custom count":"Custom count",
  "Copy position": "Copy position",
  "autogenerated":"auto-generated",
  "How many position copies": "How many copies of {title}: {id} would you like to create?",
  "Employee changes": "Employee changes",
  "Position changes": "Position changes",
  "Custom formulas remaining": "Custom formulas remaining",
  "Custom formulas used": "Custom formulas used",
  "formulasLimit": `You have reached the limit for adding custom formulas. Please contact support at ${supportEmailaddr} for assistance`,
  "Enter comment": "Enter comment",
  "Assigned position": "Assigned position",
  "Search for a position": "Search for a position",
  "budget": "budget",
  "overbudget": "over budget",
  "underbudget": "under budget",
  "View budget information": "View budget information",
  "Enable cost band info":"To see how assigning employees affects the position’s budget, turn on the setting for cost band data in Chart Settings: Mapping.",
  "Hide details":"Hide details",
  "Unable to create positions": "Unable to create position(s). Please try again.",
  "Clone position success":"The {entity} is cloned.",
  "How many new position copies": "How many position copies would you like to create?",
  "Create position success": "The {entity} position(s) created.",
  "Position selected": "Position selected: {title}: {id}",
  "There are number assignment issues": "There are {count} {text} with the employees you are assigning to this position.",
  "assignment state issues": "assignment state issue(s)",
  "Confirm assignments": "Confirm assignments",
  "is currently status": "is currently {status}",
  "is currently assigned to position": "is currently assigned to {title}: {id}.",
  "is currently assigned to position id": "is currently assigned to {id}.",
  "assigned and out of scope to": "assigned and out of scope to {id}.",
  "assigned and out of scope to position": "assigned and out of scope to {title}: {id}.",
  "Are you sure you want to assign them to position": "Are you sure you want to assign them to {title}: {id}?",
  "has an unknown assignment status": "has an unknown assignment status.",
  "Employee {employee} assigned to {position}": "Employee {employee} assigned to {position}",
  "{employee} is unassigned from {position}": "{employee} is unassigned from {position}",
  "{employee} is released from {position}": "{employee} is released from {position}",
  "Employee is unassigned from entity": "{employee} is unassigned from {entity}.",
  "Employee is released from entity": "{employee} is released from {entity}.",
  "Selections": "Selections",
  "Upgrade to create": "Upgrade to create",
  "conditional rls message" : "Upgrade to add conditional row level security and restrict users from only seeing certain fields for certain records.",
  "conditional rls template" : "Upgrade to add {conditional row level} security and restrict users from only seeing certain fields for certain records.",
  "conditional row level": "conditional row level",
  "Upgrade to group": "Upgrade to group",
  "compact and concise": "compact and concise",
  "grouping message": "Upgrade to use Grouping to group employees using location, department, or title fields for more compact and concise visualizations.",
  "grouping template": "Upgrade to use Grouping to group employees using location, department, or title fields for more {compact and concise} visualizations.",
  "multiple values": "multiple values",
  "multiple": "multiple",
  "Current values": "Current values",
  "Reports to (position)": "Reports to (position)",
  "Work Location": "Work Location",
  "Position Title is required": "Position Title is required",
  "Parent PositionID is required": "Parent PositionID is required",
  "Reports To is required": "Reports To is required",
  "Allocation must be a positive number": "Allocation must be a positive number",
  "Cost Band Minimum must be a number": "Cost Band Minimum must be a number",
  "Cost Band Maximum must be a number": "Cost Band Maximum must be a number",
  "Cost Band Minimum cannot be greater than Cost Band Maximum": "Cost Band Minimum cannot be greater than Cost Band Maximum",
  "End Date must be on or after Start Date": "End Date must be on or after Start Date",
  "Copy count must be a positive number": "Copy count must be a positive number",
  "Position ID is required": "Position ID is required",
  "and {count} more": "and {count} more",
  "includefilteredhelper": "Check to include managers who have subordinates that match the defined filter criteria, even if those managers do not match the filter criteria themselves.",
  "Base charts": "Base charts",
  "Delete plan message": "Deleting this plan will remove it permanently. This action cannot be undone.",
  "custom chart trash": "Move custom chart to trash bin",
  "custom chart trash message": "Moving the custom chart to the trash bin will remove it from this folder. You can recover custom charts from the trash bin by dragging them to a different folder.",
  "custom chart delete": "Delete custom chart",
  "custom chart delete message": "Deleting this custom chart will remove it from your account permanently. This action cannot be undone.",
  "View and select chart export options": "View and select chart export options",
  "User preferences menu": "User preferences menu",
  "Help Center": "Help Center",
  "Cost band help": "Use cost bands for budgeting, salary comparison, and variance insights. If not all fields are mapped, the system can generate the missing values using predefined formulas. For additional information, visit our {Help Center}",
  "Position budget help": "Position budget calculation will use this field when mapped, or calculate from cost band data if not mapped.",
  "Data source refresh failures":"Data source refresh failures",
  "Data Load Failure": "Data Load Failure",
  "Append Data Failure": "Append Data Failure",
  "Merge Data Failure": "Merge Data Failure",
  "Main data source": "Main data source",
  "Append data source": "Append data source",
  "Merge data source": "Merge data source",
  "Photo data source": "Photo data source",
  "Data source": "Data source",
  "Unknown": "Unknown",
  "Plan no longer exists": "Plan no longer exists",
  "Plan no longer exists (long)": "The current open plan has been deleted by another user. Please choose an existing plan or create a new one to continue planning.",
  "Error loading plan": "Error loading plan",
  "Permission denied to access planning module": "Permission denied to access planning module",
  "Permission denied to access plan": "Permission denied to access plan",
  "Insufficient role to access planning module": "Insufficient role to access planning module",
  "Core fields cannot be hidden in the table": "Core fields cannot be hidden in the table",
  "bls upgrade message": "Upgrade to add branch level security to restrict users from seeing only certain parts of the org chart, such as their department.",
  "bls upgrade template": "Upgrade to add {branch level} security to restrict users from seeing only certain parts of the org chart, such as their department.",
  "branch level": "branch level",
  "blsNavigationRestricted": "This record is outside your branch level security scope. You can only navigate to records within your branch.",
  "Enable approvals": "Enable approvals",
  "plan approvals upgrade message": "A plan approval system that enables a controlled review and approval process with multiple approvers, status tracking, and e-mail notifications.",
  "plan approvals upgrade template": "A {plan approval system} that enables a controlled review and approval process with multiple approvers, status tracking, and e-mail notifications.",
  "plan approval system": "plan approval system",
  "ag upgrade message": "Upgrade to add additional access groups, for granular control over future permissions and data security.",
  "ag upgrade template": "Upgrade to add additional access groups, for {granular control} over future permissions and data security.",
  "granular control": "granular control",
  "changes message":"Upgrade to track the data, formatting, and pagination changes you make on your custom chart. Audit who has made each change and easily revert prior changes.",
  "functional chart message": "Upgrade to create a Functional Chart to visualize your organization by function, i.e. department and overlay your functional hierarchy on top of your standard org structure.",
  "formulas message":"Upgrade to add more formulas to calculate metrics for custom headcounts, cost rollups, and more.",
  "formulas template": "Upgrade to add more formulas to {calculate metrics} for custom headcounts, cost rollups, and more.",
  "calculate metrics": "calculate metrics",
  "ar upgrade message": "Upgrade to visualize employees that report to more than one supervisor for a more accurate depiction of split roles and responsibilities.",
  "ar upgrade template": "Upgrade to visualize employees that report to more than one supervisor for a more {accurate depiction} of split roles and responsibilities.",
  "accurate depiction": "accurate depiction",
  "auto assign upgrade message": "Upgrade to configure OrgChart to automatically assign access groups to users based on your employee data.",
  "auto assign upgrade template": "Upgrade to configure OrgChart to {automatically assign} access groups to users based on your employee data.",
  "automatically assign": "automatically assign",
  "Clone":"Clone",
  "Edit position": "Edit position",
  "Multiple positions": "Multiple positions",
  "Multiple employees": "Multiple employees",
  "Automatically archive charts": "Automatically archive charts",
  "Org structures": "Org structures",
  "Stay audit ready": "Stay audit ready",
  "pit archive message":"Ensure org charts are securely captured and stored with automatic archiving capabilities.",
  "pit archive template":"Ensure org charts are {securely captured} and stored with automatic archiving capabilities.",
  "securely captured": "securely captured",
  "pit org message":"Review past org structures to identify patterns in hiring, turnover, and changes - helping you to make more informed decisions.",
  "pit org template":"Review past org structures to {identify patterns} in hiring, turnover, and changes - helping you to make more informed decisions.",
  "identify patterns": "identify patterns",
  "pit audit message":"Easily share historical org charts for audits, compliance, and presentations.",
  "pit audit template":"Easily {share historical} org charts for audits, compliance, and presentations.",
  "share historical": "share historical",
  "Assignments": "Assignments",
  "Additional data sources remaining": "Additional data sources remaining",
  "Upgrade to add": "Upgrade to add",
  "addSourcesLimit": `You've reached the limit for adding additional data sources. Please contact support at ${supportEmailaddr} for assistance`,
  "append message": "Upgrade to automatically add data from additional HR systems or spreadsheet files to visualize more information such as vacancies or contractors.",
  "append template": "Upgrade to automatically add data from {additional HR systems} or spreadsheet files to visualize more information such as {vacancies or contractors}.",
  "additional HR systems": "additional HR systems",
  "vacancies or contractors": "vacancies or contractors",
  "merge message": "Upgrade to automatically add data from additional HR systems or spreadsheet files to enrich your data visualization with information, such as secondary managers.",
  "merge template": "Upgrade to automatically add data from {additional HR systems} or spreadsheet files to enrich your data visualization with information, such as {secondary managers}.",
  "secondary managers": "secondary managers",
  "Upgrade to plan": "Upgrade to plan",
  "planning upgrade message": "Looking to create a strategic future plan? Ask us about upgrading to our workforce planning module as well!",
  "planning upgrade template": "{Looking to create a strategic future plan?} Ask us about upgrading to our {workforce planning module} as well!",
  "Looking to create a strategic future plan?": "Looking to create a strategic future plan?",
  "Plan with Position Data": "Plan with Position Data",
  "Track KPIs": "Track KPIs",
  "Collaborate in Real Time": "Collaborate in Real Time",
  "plan position data message": "Strategically plan for the future with accurate position data. Analyze positions and vacancies by salary, span of control, performace, and more to provide the most insight into your structure.",
  "plan position data template": "Strategically plan for the future with accurate position data. Analyze {positions and vacancies} by salary, span of control, performace, and more to provide the most {insight} into your structure.",
  "positions and vacancies": "positions and vacancies",
  "insight": "insight",
  "track kpis message": "Ensure your plans are set up for success. Analyze the impact of your proposed plans by setting and tracking target goals for budget, headcount, and more.",
  "track kpis template": "Ensure your plans are set up for success. Analyze the {impact} of your proposed plans by {setting and tracking} target goals for budget, headcount, and more.",
  "impact": "impact",
  "setting and tracking": "setting and tracking",
  "collaborate message": "Work alongside colleagues to drag and drop positions, move groups of employees, and ensure your team is aware of the impact of proposed changes.",
  "collaborate template": "Work alongside colleagues to {drag and drop} positions, {move groups} of employees, and ensure your {team is aware} of the impact of proposed changes.",
  "drag and drop": "drag and drop",
  "move groups": "move groups",
  "team is aware": "team is aware",
  "System calculation requires both Staffing target and Cost band maximum to be mapped": "System calculation requires both Staffing target and Cost band maximum to be mapped.",
  "System generate Position Budget": "This field will be calculated as: Staffing target × Cost band maximum",
  "Cost band max staffing target position budget": "{costBandMax} × {desiredHolders} = Position Budgeted Salary",
  "This is driven by the position budget field": "This is driven by the {field} field.",
  "This option is disabled due to package restrictions": "This option is disabled due to package restrictions",
  "Record out of scope info": "To edit details of this employee, you must assign them to a position in this plan.",
  "rlsallowedtoggleinfo": "Allowed fields toggled-on are shown",
  "rlsrestrictedtoggleinfo": "Restricted fields toggled-on are hidden",
  "rlsconditionaltoggleinfo": " Fields toggled-on are shown based on conditional rules",
  "rlsuserrecordnotfound": "Your security profile requires your record in this chart, but your record could not be found. Please contact your system administrator.",
  "Core mapped fields must always show to build your base chart": "Core mapped fields must always show to build your base chart",
  "This field cannot be {status1} as it has already been selected as {status2}": "This field cannot be {status1} as it has already been selected as {status2}",
  "Position Management enables you to visualize your employees and positions separately to gain better insight in your open roles and key position details": "Position Management enables you to visualize your employees and positions separately to gain better insight in your open roles and key position details.",
  "Upgrade": "Upgrade",
  "Employees in deleted position will be unassigned in the Employee List.": "Employees in deleted position will be unassigned in the Employee List.",
  "Would you like to rollup or delete the subordinates for {position}?": "Would you like to rollup or delete the subordinates for {position}?",
  "Multiple parent positions rollup alert": "Some positions you're deleting have subordinates reporting to them. What would you like to do with these subordinate positions?",
  "Rollup or delete subordinate positions": "Rollup or delete subordinate positions",
  "Rollup subordinates": "Rollup subordinates",
  "Delete subordinates": "Delete subordinates",
  "Invalid target value":"Target value must be a number.",
  "Position field": "Position field",
  "noPositionSelectedTooltipInfo": "Select a position to enable this action.",
  "onlyActivePositionsSelectedTooltipInfo": "The selected position(s) are active.",
  "onlyClosedPositionsSelectedTooltipInfo": "The selected position(s) are closed and must be reopened to make changes.",
  "multiplePositionsSelectedTooltipInfo": "Select only one position to clone at a time.",
  "closedOrUnassignedPositionsSelectedTooltipInfo": "The selected position(s) have no assignments.",
  "Allocation": "Allocation",
  "Holder Count": "Holder Count",
  "Add subordinate position": "Add subordinate position",
  "Add subordinate position(s)": "Add subordinate position(s)",
  "Add employee(s) to position": "Add employee(s) to position",
  "Add assistant position": "Add assistant position",
  "Created and assigned to": "Created and assigned to",
  "Position profile": "Position profile",
  "Employee profile": "Employee profile",
  "Edit position details": "Edit position details",
  "Edit employee details": "Edit employee details",
  "Edit record details": "Edit record details",
  "Employee details": "Employee details",
  "Create new chart": "Create new chart",
  "Revert all position changes info": "You can revert all changes associated with this position, but employees assigned at the time of closure {positionRevertWarning}. To revert employees back to their source position, please go to their employee details modal.",
  "Revert all position confirm": "Are you sure you want to revert all changes made to this position?",
  "positionRevertWarning": "won't be automatically reassigned",
  "This action cannot be undone": "This action cannot be undone.",
  "range": "range",
  "Starting value": "Starting value",
  "Ending value": "Ending value",
  "My filters info": "Create, manage, and apply filters on any chart type.",
  "My highlights info": "Create, manage, and apply highlights on any chart type.",
  "Saved highlights info": "Legacy highlights are managed by administrators in the Chart Settings: Import filters tab.",
  "No highlights created yet": "No highlights created yet",
  "Search filters": "Search filters",
  "Search highlights": "Search highlights",
  "Shared filters info": "These filters are shared with you and can be applied to any chart type. The ability to edit certain filters will depend on your sharing access.",
  "Shared highlights info": "These highlights are shared with you and can be applied to any chart type. The ability to edit certain highlights will depend on your sharing access.",
  "Choose a color": "Choose a color",
  "Interactive highlights": "Interactive highlights",
  "Delete highlight?": "Delete highlight?",
  "daterange": "date range",
  "last [n] days": "last [n] days",
  "last [n] weeks": "last [n] weeks",
  "last [n] months": "last [n] months",
  "last [n] years": "last [n] years",
  "next [n] days": "next [n] days",
  "next [n] weeks": "next [n] weeks",
  "next [n] months": "next [n] months",
  "next [n] years": "next [n] years",
  "yesterday": "yesterday",
  "tomorrow": "tomorrow",
  "To (optional)": "To (optional)",
  "specific date": "specific date",
  "Immediate days": 'Immediately (0 days)',
  "Retain vacant supervisory positions":"Retain vacant positions",
  "Retain vacant supervisory positions info": "OrgChart generates vacant positions in your chart when employees are removed from your data source. This preserves your organization structure and allows you to reassign or plan for these critical roles. The append table is used to manage these system generated vacant positions.",
  "Retain positions": "One or more employees were {removedFromDataSet}. In order to retain their roles, OrgChart has {createdPositions} your org structure. Use the {appendTable} to adjust these positions as needed.",
  "removed from your data set": "removed from your data set",
  "created positions for you to maintain": "created positions for you to maintain",
  "append table": "append table",
  "Retain position info": "Retain positions in your chart when the assigned employees are removed from your data source. This preserves your organizational structure and allows you to reassign or plan for these critical roles.",
  "Auto purge vacant positions": "Auto-purge vacant positions",
  "Auto purge vacant positions info": "Automatically remove vacant positions after a specified time period to keep your chart current.",
  "Purge positions after":"Purge positions after:",
  "Minimum subordinate threshold": "Minimum subordinate threshold",
  "Include": "Include",
  "Exclude": "Exclude",
  "Favorite field {i}": "Favorite field {i}",
  "Profile picture": "Profile picture",
  "Employee profile card": "Employee profile card",
  "Employee profile desc": "The employee profile card displays employee data. Choose what employee data you would like to display in the employee profile card below.",
  "Position profile card": "Position profile card",
  "Position profile desc": "The position profile card displays position data. Choose what data you would like to display in the position profile card below.",
  "Additional {type} information": "Additional {type} information",
  "Additional {type} information desc": "Additional {type} information is listed underneath the favorited fields.",
  "Heading information": "Heading information",
  "Agent profile": "Agent profile",
  "Agent profile card": "Agent profile card",
  "Agent profile desc": "Choose the data to display on Agent profile cards.",
  "Card header information": "Card header information",
  "About me": "About me",
  "Lifecycle and governance details": "Lifecycle and governance details",
  "Lifecycle and governance": "Lifecycle and governance",
  "Adoption & activity": "Adoption & activity",
  "Adoption and activity": "Adoption and activity",
  "Additional details": "Additional details",
  "view here": "view here",
  "Agent audit log": "Audit log",
  "last ran {n} days ago": "last ran {n} days ago",
  "Identity": "Identity",
  "Technical": "Technical",
  "Cost": "Cost",
  "Alerts": "Alerts",
  "Action breakdown": "Action breakdown",
  "1 employee affected": "1 employee affected",
  "{n} employees affected": "{n} employees affected",
  "Open alert details": "Open alert details",
  "Agent name": "Agent name",
  "Agent type": "Agent type",
  "About": "About",
  "Detail link": "Detail link",
  "Last updated": "Last updated",
  "Model used": "Model used",
  "Models used": "Models used",
  "Platform": "Platform",
  "Review frequency": "Review frequency",
  "Access scope": "Access scope",
  "Audit log link": "Audit log link",
  "Date created": "Date created",
  "Date deployed": "Date deployed",
  "Errors prevented": "Errors prevented",
  "Auto-corrections": "Auto-corrections",
  "Items reviewed": "Items reviewed",
  "Items reviewed (last pay cycle)": "Items reviewed (last pay cycle)",
  "Time saved": "Time saved",
  "Time saved (this month)": "Time saved (this month)",
  "Active users": "Active users",
  "Approval rate": "Approval rate",
  "Days since last use": "Days since last use",
  "Requests made": "Requests made",
  "Sessions": "Sessions",
  "Sessions (this month)": "Sessions (this month)",
  "Agent spend": "Agent spend",
  "Token spend": "Token spend",
  "Token spend (this month)": "Token spend (this month)",
  "Critical alerts": "Critical alerts",
  "Open alerts": "Open alerts",
  "Top alerts": "Top alerts",
  "Auto-applied": "Auto-applied",
  "Resolved": "Resolved",
  "Dismissed": "Dismissed",
  "Full name (Title)": "Full name (Title)",
  "Fields to": "Fields to",
  "Position start date": "Position start date",
  "Position end date": "Position end date",
  "Full name": "Full name",
  "Employee ID": "Employee ID",
  "Position ID": "Position ID",
  "Record type": "Record type",
  "Record name": "Record name",
  "Modification type": "Modification type",
  "Replace all": "Replace all",
  "Add to existing":"Add to existing",
  "Append table has existing records": "Append table has existing records",
  "Information unavailable": "Information unavailable",
  "Position information unavailable": "Position information unavailable. Please change to a position chart in order to view and manage position records.",
  "Retain only vacant with subs": "Retain only vacant positions with subordinates",
  "Clear vacant positions": "Clear vacant positions",
  "Clear vacant positions after": "Clear vacant positions after",
  "Clear vacant positions after info": "Clear the system generated vacant positions after a defined period of time that are no longer needed to preserve your organization structure. If you want to always keep these vacant positions in your chart, turn this toggle off. ",
  "1 assignee": "1 assignee",
  "{n} assignees": "{n} assignees",
  "__blocked__": "(hidden)",
  "profile preview": "Profile Preview",
  "No assignees yet": "No assignees yet.",
  "blockedmetrictip": "This metric is unavailable, since you are not permitted to see all of the values used for this calculation. To see this number, enter a working value for the fields used for this calculation that are marked as 'hidden.'",
  "compensationaccesstip": "You don't have access to the actual compensation data for this employee.",
  "recordeditorcompaccesstip": "You don't have access to the actual value for some fields. You can enter a placeholder value for the hidden values for planning purposes.",
  "authorBlockedFieldTip": "The user who made this change did not have access to see this actual {fieldName} value.",
  "Field name": "Field name",
  "No fields added yet": "No fields added yet",
  "No holders in preview": "All positions are vacant. No assignees to preview.",
  "Preview not available": "Preview is unavailable. \n Refresh your chart and try again.",
  "Data sources below are not yet supported for this chart type. For assistance, please reach out to ": "Data sources below are not yet supported for this chart type. For assistance, please reach out to ",
  "What type of dataset do you want to ": "What type of dataset do you want to ",
  "Force queue refresh": "Force queue refresh",
  "Force queue refresh question": "Force queue refresh?",
  "Force queue": "Force queue",
  "Refresh Queue Info": "Do you want to force this chart into the refresh queue immediately? The chart will refresh in the background.",
  "photoRefreshChoice": "Do you want to force reload all photos while this process is taking place?",
  "Chart added to the refresh queue": "Chart added to the refresh queue successfully",
  "Use Auth V1": "Use Auth V1",
  "Conflict record detected": "Conflict detected",
  "Plan state": "Plan state",
  "Approval Status": "Approval Status",
  "Approval status": "Approval status",
  "This plan has the following approver(s) and their approval status:": "This plan has the following approver(s) and their approval status:",
  "Draft": "Draft",
  "Submitted": "Submitted",
  "Approved": "Approved",
  "Rejected": "Rejected",
  "Withdrawn": "Withdrawn",
  "Pending": "Pending",
  "Submit Plan for Approval": "Submit Plan for Approval",
  "Plan details": "Plan details",
  "Owner": "Owner",
  "Add approvers": "Add approvers",
  "Search for approvers": "Search for approvers",
  "Maximum approvers allowed. Please remove some approvers.": "Maximum {approverLimit} approvers allowed. Please remove some approvers.",
  "Message": "Message",
  "Add a message for approvers": "Add a message for approvers",
  "Submit for approval": "Submit for approval",
  "Plan submitted for approval successfully": "Plan submitted for approval successfully.",
  "Failed to submit plan request": "Failed to submit plan request.",
  "Plan request withdrawn successfully": "Plan request withdrawn successfully.",
  "Failed to withdraw plan request": "Failed to withdraw plan request.",
  "Plan approved successfully": "Plan approved successfully.",
  "Failed to approve plan": "Failed to approve plan.",
  "Plan rejected": "Plan rejected.",
  "Failed to reject plan": "Failed to reject plan.",
  "Submit Plan": "Submit Plan",
  "Plan Submitted": "Plan Submitted",
  "Approve Plan": "Approve Plan",
  "Approve plan": "Approve plan",
  "Reject plan": "Reject plan",
  "Submit plan": "Submit plan",
  "Withdraw plan": "Withdraw plan",
  "Plan already submitted": "Plan already submitted.",
  "No active plan request to withdraw": "No active plan request to withdraw.",
  "No plan approvals have been made yet.": "No plan approvals have been made yet.",
  "Approvals": "Approvals",
  "Reject Plan": "Reject Plan",
  "Approval message": "Approval message",
  "Rejection message": "Rejection message",
  "Approve": "Approve",
  "Reject": "Reject",
  "Submission Info": "Submission Info",
  "Submitted by": "Submitted by",
  "Submitted on": "Submitted on",
  "Submission message": "Submission message",
  "Approvers": "Approvers",
  "Add a message": "Add a message",
  "Plan submission withdrawn successfully": "Plan submission withdrawn successfully.",
  "Failed to submit plan submission": "Failed to submit plan submission.",
  "Failed to withdraw plan submission": "Failed to withdraw plan submission.",
  "No active plan submission to withdraw": "No active plan submission to withdraw.",
  "Approvers label": "Approver(s)",
  "Some approvers need access": "Some approvers can't access plan",
  "Some approvers need access info": "{reviewersWithoutPlanAccessCount} of {totalReviewerCount} approvers you're adding don't have access to the plan. Grant them viewer access now, or you can add them later before they begin their review.",
  "Grant access":"Grant access",
  "Withdraw": "Withdraw",
  "Withdrawal message": "Withdrawal message",
  "Optional message": "Optional message",
  "Withdraw plan info message": "Withdrawing this plan will remove any approvals and return the plan status to \"Draft\". You'll then be able to make changes to the plan.",
  "Select approvers for this plan": "Select approver(s) for this plan",
  "Maximum approvers": "Maximum {approverLimit} approvers",
  "Withdrawn by": "Withdrawn by",
  "Withdrawn on": "Withdrawn on",
  "Refresh Formula Info": "Do you want to force recalculation of all formulas for this chart? This will update computed values without refreshing the entire chart.",
  "Force calculate": "Force calculate",
  "Force calculate formulas": "Force calculate formulas",
  "Force calculate formulas question": "Force calculate formulas?",
  "Table view": "Table view",
  "Default editable fields": "Default editable fields",
  "Choose the default editable fields that you want to show in the {entity} modals.": "Choose the default editable fields that you want to show in the {entity} modals.",
  "Plan settings apply to plans created from the selected base chart.": "Plan settings apply to plans created from the selected base chart.",
  "Approval settings": "Approval settings",
  "Enable plan approvals": "Enable plan approvals",
  "Disable plan approval?": "Disable plan approval?",
  "Disabling plan approval will hide plan approval flows for all plans created from this base chart. Are you sure you want to disable plan approval for this base chart?": "Disabling plan approval will hide plan approval flows for all plans created from this base chart. Are you sure you want to disable plan approval for this base chart?",
  "When enabled, plans can be submitted for approval and e-mail notifications are sent for status updates.": "When enabled, plans can be submitted for approval and e-mail notifications are sent for status updates.",
  "Disable": "Disable",
  "Show only plans needing my approval": "Show only plans needing my approval",
  "Plan requires approval": "Plan requires approval",
  "This plan is awaiting approval": "This plan is awaiting approval from {reviewerNames}.",
  "you": "you",
  "Review changes": "Review changes",
  "This plan is locked and cannot be edited.": "This plan is {status} and cannot be edited.",
  "Plan owners can unlock the plan in the Plan Explorer by hovering over the plan": " Plan owners can unlock the plan in the Plan Explorer by hovering over the plan, and then clicking on the ⋮ icon.",
  "You have already approved this plan": "You have already approved this plan.",
  "You have already rejected this plan": "You have already rejected this plan.",
  "In Review": "In Review",
  "Manage plan fields": "Manage plan fields",
  "Review plan": "Review plan",
  "This plan is in draft and has no approver information available until it is submitted for approval.": "This plan is in draft and has no approver information available until it is submitted for approval.",
  "LocalizationSettingsDesc": "Add the ability for your users to view their chart data in their preferred language selection. Add your desired field mappings that will drive the displayed translations.",
  "NoLocalizationData": "No language configurations added yet.",
  "Add language": "Add language",
  "Data localization": "Data localization",
  "Include field?": "Include field?",
  "Include field": "Include field",
  "Are you sure you want to include this field?": "Are you sure you want to include this field?",
  "The \"{fieldName}\" field is currently excluded from the profile. If you map this field, it will be included in the profile.": "The \"{fieldName}\" field is currently excluded from the profile. If you map this field, it will be included in the profile.",
  "Search for field": "Search for field",
  "Delete language": "Delete language",
  "Are you sure you want to delete this language? All mapped field configurations for this language will be lost.": "Are you sure you want to delete this language? All mapped field configurations for this language will be lost.",
  "Layout type": "Layout type",
  "Standard box": "Standard box",
  "Group box": "Group box",
  "Group box style": "Group box style",
  "Save changes": "Save changes",
  "Display settings": "Display settings",
  "Limit text to a single row": "Limit text to a single row",
  "columns used in the group box": "columns used in the group box",
  "Default to view's box style": "Default to view's box style",
  "Group box layouts cannot have columns": "Group box layouts cannot have columns",
  "This box layout type is applied to employee boxes.": "This box layout type is applied to employee boxes.",
  "This box layout type is applied to the grouped box that groups the employee records.": "This box layout type is applied to the grouped box that groups the employee records.",
  "This box layout type is applied to position boxes."  : "This box layout type is applied to position boxes.",
  "You do not have any custom group styles created. Create a custom group style in the 'Box styles' panel and apply it to a conditional grouping.": "You do not have any custom group styles created. Create a custom group style in the 'Box styles' panel and apply it to a conditional grouping.",
  "Framed": "Framed",
  "Condensed": "Condensed",
  "Grouped employee records appear in a list. The ‘Group by field’ value for those grouped records is displayed at the top of the group.": "Grouped employee records appear in a list. The ‘Group by field’ value for those grouped records is displayed at the top of the group.",
  "A frame is placed around grouped records. Conditional formatting targeting framed grouped records still appear.": "A frame is placed around grouped records. Conditional formatting targeting framed grouped records still appear.",
  "Employee box style": "Employee box style",
  "Default to last used or only created": "Default to last used or only created",
  "Applying filter": "Applying filter...",
  "Loading chart": "Loading chart...",
  "Create and manage box styles for your charts. Apply box styles with a View.": "Create and manage box styles for your charts. Apply box styles with a View.",
  "Create box style": "Create box style",
  "Search box styles": "Search box styles",
  "Applied to:": "Applied to:",
  "A to Z": "A to Z",
  "Z to A": "Z to A",
  "Most used": "Most used",
  "Least used": "Least used",
  "System box styles first": "System box styles first",
  "Shared box styles first": "Shared box styles first",
  "Employee box styles first": "Employee box styles first",
  "Position box styles first": "Position box styles first",
  "Group box styles first": "Group box styles first",
  "Filter": "Filter",
  "Applied to views": "Applied to views",
  "Not applied to views": "Not applied to views",
  "Box style library": "Box style library",
  "Box style type": "Box style type",
  "Reset filters": "Reset filters",
  "Go to a view:": "Go to a view:",
  "views unavailable to access": "{viewCount} views unavailable to access",
  "The box style is applied to the following views. Click on the view to preview.": "The box style is applied to the following views. Click on the view to preview.",
  "Apply to new view": "Apply to new view",
  "No view rules reference this box style.": "No view rules reference this box style.",
  "Box style name": "Box style name",
  "Back to box styles": "Back to box styles",
  "Edit box style": "Edit box style",
  "Copy box style": "Copy box style",
  "Revert box style": "Revert box style",
  "Delete box style": "Delete box style",
  "Delete box style?": "Delete box style?",
  "Delete box style confirmation": "This will permanently delete the box style from your library. Any views currently using this style will revert to the system default, and you'll need to reapply a box style to those view rules.",
  "box style deleted": "{box style name} box style deleted.",
  "The box style could not be deleted": "The box style could not be deleted. Please try again.",
  "copied to box style library": "{box style name} copied to box style library.",
  "The box style could not be copied": "The box style could not be copied. Please try again.",
  "box style created": "{box style name} box style created.",
  "box style changes saved": "{box style name} box style changes saved.",
  "edited": "edited",
  "box layout editor pending changes banner":
    "Changes including rename, copy, and delete in the Box Layout Editor are pending until you save or discard.",
  "1 box style with unsaved changes": "1 box style with unsaved changes.",
  "{n} box styles with unsaved changes": "{n} box styles with unsaved changes.",
  "1 box style deleted": "1 box style deleted.",
  "{n} box styles deleted": "{n} box styles deleted.",
  "{n} box styles updated": "{n} box styles updated.",
  "{n} box styles saved": "{n} box styles saved.",
  "Keep editing": "Keep editing",
  "box style save failed": "Couldn't save box styles. Please try again.",
  "Legacy filters": "Saved filters (legacy)",
  "Legacy highlights": "Saved highlights (legacy)",
  "View name": "View name",
  "Chart scope": "Chart scope",
  "Chart scope description": "View the chart scope and apply a rule to this custom chart.",
  "Levels under top box": "Levels under the top box",
  "Chart scope edit cc to edit": "Edit the chart to adjust the chart scope.",
  "Now available: IF/IH": "Now available: Interactive filters and highlights on any chart type",
  "Now available: IF/IH detail": "Use the chart's right-side panel to create, manage, and share interactive filters and highlights. Your existing saved filters remain accessible. Learn more about using {link} in our help documentation.",
  "Interactive filters and highlights": "interactive filters and highlights",
  "Choose a base chart:": "Choose a base chart:",
  "view library upgrade message": "Upgrade to create an unlimited number of custom org chart views to deepen insight into your organization. Add fields such as employee tenure, salary, and performance to your boxes, enhance your charts with brand colors and color-coding of fields, and even call out position vacancies.",
  "view library upgrade template": "Upgrade to create an {unlimited number of custom org chart views} to deepen insight into your organization. Add fields such as employee tenure, salary, and performance to your boxes, enhance your charts with brand colors and color-coding of fields, and even call out position vacancies.",
  "unlimited number of custom org chart views": "unlimited number of custom org chart views",
  "Upgrade to add views": "Upgrade to add views",
  "filters upgrade message": "Upgrade to use interactive filters on your chart for enhanced visibility. With filters, you can choose to only show certain records on your chart, such as those in certain departments, locations, and more.",
  "filters upgrade template": "Upgrade to use {interactive filters} on your chart for enhanced visibility. With filters, you can choose to only show certain records on your chart, such as those in certain departments, locations, and more.",
  "interactive filters": "interactive filters",
  "highlights upgrade message": "Upgrade to use interactive highlights on your chart and instantly illuminate employees in specific departments, locations, and more.",
  "highlights upgrade template": "Upgrade to use {interactive highlights} on your chart and instantly illuminate employees in specific departments, locations, and more.",
  "interactive highlights": "interactive highlights",
  "Interactive filters & highlights": "Interactive filters & highlights",
  "Upgrade to export": "Upgrade to export",
  "export upgrade message": "Upgrade to export your org chart to PDF, PPT, PNG, SVG, JPEG, and XLSX formats. Instantly get presentation-ready charts with control over page size, orientation, chart scope, and more.",
  "export upgrade template": "Upgrade to export your org chart to {PDF, PPT, PNG, SVG, JPEG, and XLSX formats}. Instantly get presentation-ready charts with control over page size, orientation, chart scope, and more.",
  "PDF, PPT, PNG, SVG, JPEG, and XLSX formats": "PDF, PPT, PNG, SVG, JPEG, and XLSX formats",
  "Merge duplicates": "Merge duplicates",
  "Merge by field": "Merge by field",
  "Box style name must be unique": "Box style name must be unique",
  "Box style name cannot be empty": "Box style name cannot be empty",
  "Audit log": "Admin log",
  "admin log upgrade message":
    "Stay audit-ready year-round. The admin log captures user, permission, and access changes with a timestamped record your auditors can review on demand.",
  "admin log upgrade template":
    "Stay {audit-ready} year-round. The admin log captures user, permission, and access changes with a {timestamped record} your auditors can review on demand.",
  "audit-ready": "audit-ready",
  "timestamped record": "timestamped record",
  "auditLog.title": "Admin log",
  "auditLog.totalRecords": "Total records",
  "auditLog.error.loadFailed": "Failed to load admin log records.",
  "auditLog.error.exportFailed": "Failed to export admin log.",
  "auditLog.error.snapshotFailed": "Failed to generate security snapshot.",
  "auditLog.filter.startDate": "Start date",
  "auditLog.filter.endDate": "End date",
  "auditLog.filter.eventType": "Event type",
  "auditLog.filter.source": "Source",
  "auditLog.filter.outcome": "Outcome",
  "auditLog.filter.actorId": "User ID or email",
  "auditLog.filter.targetId": "Target ID or email",
  "auditLog.action.apply": "Apply",
  "auditLog.action.reset": "Reset",
  "auditLog.action.exportCsv": "Export CSV",
  "auditLog.action.exportXlsx": "Export Excel report",
  "auditLog.action.generateSnapshot": "Generate snapshot",
  "auditLog.pagination.previous": "Previous",
  "auditLog.pagination.next": "Next",
  "auditLog.pagination.page": "Page",
  "auditLog.column.timestamp": "Timestamp (GMT)",
  "auditLog.column.eventType": "Event",
  "auditLog.column.outcome": "Outcome",
  "auditLog.column.source": "Source",
  "auditLog.column.actor": "Actor",
  "auditLog.column.target": "Target",
  "auditLog.column.diffKeys": "Changed keys",
  "auditLog.column.message": "Message",
  "auditLog.event.userCreate": "User created",
  "auditLog.event.userDelete": "User removed",
  "auditLog.event.userDeleteRequest": "User removal requested",
  "auditLog.event.userRoleChange": "User role changed",
  "auditLog.event.userPrivChange": "Access group or chart access changed",
  "auditLog.event.userRlsAssign": "User RLS profile assigned",
  "auditLog.event.securityGroupUpdate": "Access group configuration changed",
  "auditLog.event.securityRlsProfileUpdate": "Row-level security profile changed",
  "auditLog.event.securityBlsProfileUpdate": "Branch-level security profile changed",
  "auditLog.event.securityImpersonationToggle": "Impersonation setting changed",
  "auditLog.event.securityDirectSigninToggle": "Direct sign-in setting changed",
  "auditLog.event.securityAutoAssignmentChange": "Auto-assignment configuration changed",
  "auditLog.event.securitySsoConfigChange": "SSO configuration changed",
  "auditLog.event.securityAuthorizationDenied": "Authorization denied",
  "auditLog.event.securityUiProfileUpdate": "UI profile changed",
  "auditLog.event.authLoginImpersonation": "Login via impersonation",
  "auditLog.event.auditReportViewed": "Admin log viewed",
  "auditLog.event.auditReportExported": "Admin log exported",
  "auditLog.event.auditReportExportedXlsx": "Admin Excel report exported",
  "auditLog.event.auditSnapshotGenerated": "Security snapshot generated",
  "auditLog.outcome.success": "Success",
  "auditLog.outcome.denied": "Denied",
  "auditLog.outcome.failed": "Failed",
  "auditLog.source.manageUsersUi": "Manage users",
  "auditLog.source.authorizationUi": "Authorization",
  "auditLog.source.rlsUi": "Row-level security",
  "auditLog.source.blsUi": "Branch-level security",
  "auditLog.source.accessGroupsUi": "Access groups",
  "auditLog.source.uiProfilesUi": "UI profiles",
  "auditLog.source.ssoConfigUi": "SSO configuration",
  "auditLog.source.auditLogUi": "Admin log",
  "auditLog.source.bulkImport": "Bulk import",
  "auditLog.source.api": "API",
  "auditLog.source.system": "System",
  "auditLog.source.unknown": "Unknown",
  "Back to groups": "Back to groups",
  "Delete group?": "Delete group?",
  "Delete group confirm": "Deleting this group will remove it from your grouping list.",
  "In two quick steps, we'll customize your org chart with your logo and brand colors.": "In two quick steps, we'll customize your org chart with your logo and brand colors.",
  "Upload your logo": "1. Upload your logo",
  "Auto-generates a branded background.": "Auto-generates a branded background.",
  "Set brand colors": "2. Set brand colors",
  "Applied to all org chart system boxes.": "Applied to all org chart system boxes.",
  "Skip setup": "Skip setup",
  "Brand setup": "Brand setup",
  "Step {current} of {total}": "Step {current} of {total}",
  "brandedBackgroundMessage": "Your logo will generate a branded background for your org chart. OrgChart supports you having multiple logos, please reference this help document to learn more. Click 'Continue' to skip this step.",
  "brandedBackgroundTemplate": "Your logo will generate a branded background for your org chart. OrgChart supports you having multiple logos, please reference this {help document} to learn more. Click 'Continue' to skip this step.",
  "help document": "help document",
  "Drag and drop your file here, or click to browse": "Drag and drop your file here, or click to browse",
  "file formats": "{formats} format - max {size} MB",
  "Choose colors for your org chart boxes. They will be applied to all default system boxes and views. You can skip this step and edit later in the Box Layout Editor.": "Choose colors for your org chart boxes. They will be applied to all default system boxes and views. You can skip this step and edit later in the Box Layout Editor.",
  "Box fill color:": "Box fill color:",
  "Box border color:": "Box border color:",
  "Preview employee box styles": "Preview employee box styles",
  "Finish setup": "Finish setup",
  "Go to chart": "Go to chart",
  "You're all set!": "You're all set!",
  "autoExportUpgradeMessage": "Upgrade to configure OrgChart to automatically export base charts. Set OrgChart to send base charts in PDF, PPT, or Excel straight to stakeholder inboxes.",
  "autoExportUpgradeTemplate": "Upgrade to configure OrgChart to {automatically export} base charts. Set OrgChart to send base charts in PDF, PPT, or Excel straight to stakeholder inboxes.",
  "automatically export": "automatically export",
  "Your brand is applied.": "Your brand is applied.",
  "Failed to delete file. Please try again.": "Failed to delete file. Please try again.",
  "Copy to clipboard": "Copy to clipboard",
  "Paste from clipboard": "Paste from clipboard",
  "Paste views and box styles from clipboard": "Paste views and box styles from clipboard",
  "Use the ctrl/cmd V shortcut key to paste your views and box styles from your clipboard.": "Use the ctrl/cmd V shortcut key to paste your views and box styles from your clipboard.",
  "Failed to import views. Please try again.": "Failed to import views. Please try again.",
  "Paste from your clipboard.": "Paste from your clipboard.",
  "Import views": "Import views",
  "Failed to paste views. Please copy views and box styles and try again.": "Failed to paste views. Please copy views and box styles and try again.",
  "Views and box styles pasted from clipboard.": "Views and box styles pasted from clipboard.",
  "Export views and box styles": "Export views and box styles",
  "Views and box styles copied to your clipboard.": "Views and box styles copied to your clipboard.",
  "Views and box styles imported successfully.": "Views and box styles imported successfully.",
  "Grouping tab description": "Group boxes to organize them by category and make your chart easier to scan.",
  "No groups created yet": "No groups created yet",
  "No sort keys added yet": "No sort keys added yet",
  "No disconnected records found": "No disconnected records found.",
  "No changes have been made yet.": "No changes have been made yet.",
  "Staging info": "Staging temporarily stores disconnected records. Drag records from Staging onto the chart to establish reporting relationships. Drag records to Staging to disconnect (branches move together).",
  "Shared filter update error": "Failed to update",
  "Shared filter delete error": "Failed to delete",
  "Dismiss": "Dismiss",
  "Got it": "Got it",
  "Let's go": "Let's go",
  "Click on the view switcher to change the information that is displayed on the chart. Your chart comes with three pre-installed views.": "Click on the view switcher to change the information that is displayed on the chart. Your chart comes with three pre-installed views.",
  "Use the levels control to increase or decrease the amount of organizational levels displayed on a single page.": "Use the levels control to increase or decrease the amount of organizational levels displayed on a single page.",
  "Create filters to show specific records. For example, filter your chart to just see Full Time employees. Create highlights to illuminate specific records. For example, quickly highlight employees who work in New York.": "Create filters to show specific records. For example, filter your chart to just see Full Time employees. Create highlights to illuminate specific records. For example, quickly highlight employees who work in New York.",
  "Instantly get presentation-ready org charts. Export your chart to PPT, PDF, SVG, and additional formats.": "Instantly get presentation-ready org charts. Export your chart to PPT, PDF, SVG, and additional formats.",
  "Welcome to Your Charts, Powered by OrgChart!": "Welcome to Your Charts, Powered by OrgChart!",
  "isolvedFreeTrialMessage": "For the next 21 days, you will have free access to premium org chart features only available in isolved, including the ability to export charts, highlight information on charts, and see multiple chart views.",
  "isolvedFreeTrialTemplate": "For the next {21 days}, you will have free access to {premium org chart features} only available in isolved, including the ability to export charts, highlight information on charts, and see multiple chart views.",
  "isolvedMissingJobDataErrTitle": "Incomplete or missing job data",
  "isolvedMissingJobDataErrAdmin": "Job data is incomplete or missing. Confirm that employees have assigned managers and titles, and then the org chart will populate within the hour.",
  "isolvedMissingJobDataErrUser": "Job data is incomplete or missing. Contact your isolved admin to review and confirm that employees have assigned managers and titles.",
  "isolvedMissingJobIdErrTitle": "Missing job assignment",
  "isolvedMissingJobIdErrAdmin": "None of your isolved employees have an assigned job on their job instance. Assign a job to each employee in isolved, and the org chart will populate within the hour.",
  "isolvedMissingJobIdErrUser": "None of your organization's employees in isolved have a job assignment. Contact your isolved admin to complete these job instances.",
  "isolvedMappingMissingManagerTitle": "Missing manager reporting relationships detected",
  "isolvedMappingMissingManagerAdmin": "We have not detected any reporting relationships in your current supervisor mapping. Assigned supervisor ID has reporting relationships. Would you like to update your supervisor mapping to use assigned supervisor ID instead?",
  "isolvedMappingMissingManagerUser": "No reporting relationships were found for your chart's current supervisor mapping in isolved. Contact your isolved admin to update the supervisor mapping.",
  "isolvedMappingIncompleteManagerTitle": "Incomplete manager reporting relationships detected",
  "isolvedMappingIncompleteManagerAdmin": "Some employees are missing a reporting relationship in your current supervisor mapping. We've detected that reporting relationships built using assigned supervisor ID are more populated. Would you like to update your supervisor mapping to use assigned supervisor ID? If you'd like to keep your current mapping, ensure that all employees have a value for it in isolved.",
  "isolvedMappingIncompleteManagerUser": "Some employees are missing a reporting relationship for your chart's current supervisor mapping in isolved. Contact your isolved admin to review the supervisor mapping.",
  "isolvedMappingMissingSupervisorTitle": "Missing supervisor reporting relationships detected",
  "isolvedMappingMissingSupervisorAdmin": "We have not detected any reporting relationships in your current supervisor mapping. Assigned manager ID has reporting relationships. Would you like to update your supervisor mapping to use assigned manager ID instead?",
  "isolvedMappingMissingSupervisorUser": "No reporting relationships were found for your chart's current supervisor mapping in isolved. Contact your isolved admin to update the supervisor mapping.",
  "isolvedMappingIncompleteSupervisorTitle": "Incomplete supervisor reporting relationships detected",
  "isolvedMappingIncompleteSupervisorAdmin": "Some employees are missing a reporting relationship in your current supervisor mapping. We've detected that reporting relationships built using assigned manager ID are more populated. Would you like to update your supervisor mapping to use assigned manager ID? If you'd like to keep your current mapping, ensure that all employees have a value for it in isolved.",
  "isolvedMappingIncompleteSupervisorUser": "Some employees are missing a reporting relationship for your chart's current supervisor mapping in isolved. Contact your isolved admin to review the supervisor mapping.",
  "isolvedMappingNoneDetectedTitle": "No reporting relationships detected",
  "isolvedMappingNoneDetectedAdmin": "A chart cannot be built since there were no reporting relationships detected. Ensure that employees have an assigned manager or supervisor in isolved, and then the org chart will populate within the hour.",
  "isolvedMappingNoneDetectedUser": "A chart cannot be built since there were no reporting relationships detected in isolved. Contact your isolved admin to ensure employees have an assigned manager or supervisor.",
  "21 days": "21 days",
  "premium org chart features": "premium org chart features",
  "Take the tour to get started and learn more!": "Take the tour to get started and learn more!",
  "Brand colors could not be saved. Please try again or skip setup.": "Brand colors could not be saved. Please try again or skip setup.",
  "Logo could not be saved. Please try again or skip setup.": "Logo could not be saved. Please try again or skip setup.",
  "Resource center": "Resource center",
  "Help documentation": "Help documentation",
  "Learn about specific topics": "Learn about specific topics",
  "Submit a support ticket": "Submit a support ticket",
  "Onboarding": "Onboarding",
  "Take a tour of our core features": "Take a tour of our core features",
  "SCIMSectionTitle": "SCIM Provisioning",
  "SCIMUpgradeBody": "Upgrade to enable SCIM and manage user provisioning, group assignment, and deactivation directly from your IdP.",
  "SCIMUpgradeTemplate": "Upgrade to {bold1} and manage user provisioning, group assignment, and deactivation {bold2}.",
  "SCIMUpgradeBold1": "enable SCIM",
  "SCIMUpgradeBold2": "directly from your IdP",
  "SCIMTokenPanelIntro": "Issue a bearer token to your identity provider (e.g. Okta) so it can provision, update, and deprovision users via SCIM 2.0. Tokens are shown once on creation and are not retrievable afterward.",
  "SCIMTokenGenerate": "Generate token",
  "SCIMTokenCopy": "Copy",
  "SCIMTokenDismiss": "Dismiss",
  "SCIMTokenNewTitle": "Token created",
  "SCIMTokenNewWarning": "Copy this token now. It cannot be displayed again.",
  "SCIMTokenNoneActive": "No SCIM tokens have been issued for this account.",
  "SCIMTokenCreatedBy": "Created by",
  "SCIMTokenCreatedAt": "Created",
  "SCIMTokenLastUsed": "Last used",
  "SCIMTokenListError": "Could not load SCIM tokens.",
  "SCIMTokenCreateError": "Could not create SCIM token.",
  "SCIMTokenDeleteError": "Could not delete SCIM token.",
  "SCIMSAMLConflictTitle": "SCIM and SAML auto-provisioning are both enabled",
  "SCIMSAMLConflictBody": "Both systems can write to the same user records. SAML attributes override SCIM values at login. To avoid drift, disable auto-provision on the SSO configuration or delete the SCIM token.",
  "No functional statement": "No functional statement",
  "Functional Statement": "Functional Statement",
  "Chart Navigator": "Chart Navigator",
  "Navigator": "Navigator",
  "Point in Time": "Point in Time",
  "No results": "No results",
  "PDF Export Only": "PDF Export Only",
  "Include Functional Statements": "Include Functional Statements",
  "includeFunctionalStatementsHelper": "Append a page with each unit's functional statement to the end of the export",
  "disableFunctionalStatementsSwitch": "Functional statements are only available for entire chart exports. Click on the General tab, and then update the scope to entire chart, in order to use this option",
  "includeExcelFunctionalStatementsHelper": "Add a column containing each unit's functional statement",
  "Unlock": "Unlock",
  "Unlock advanced security": "Unlock advanced security",
  "Unlock plan approvals": "Unlock plan approvals",
  "Unlock planning": "Unlock planning",
  "Unlock point in time": "Unlock point in time",
  "access groups upgrade message": "Create custom access groups to control exactly who can view, edit, and manage specific charts, folders, and data across your organization.",
  "access groups upgrade template": "Create {custom access groups} to control exactly who can view, edit, and manage specific charts, folders, and data across your organization.",
  "custom access groups": "custom access groups",
  "ui profiles upgrade message": "Control access to certain UI elements, so users see exactly what they need.",
  "ui profiles upgrade template": "Control access to {certain UI elements}, so users see exactly what they need.",
  "certain UI elements": "certain UI elements",
  "Unlock access groups": "Unlock access groups",
  "Unlock UI profiles": "Unlock UI profiles",
  "Unlock Admin Log": "Unlock Admin Log"
}
